// Code generated by tygo. DO NOT EDIT.
// In order to regenerate types run: `make codegen` at the root of the repository

// types added for the exclusion of common.go, excluded bcs: 'T' is declared but its value is never read.
type Strings = string[];
type Metadata = Record<string, any>;
type JSONArray<T> = T[];

//////////
// source: address.go

/**
 * LegalAddres is recipient's legal address.
 */
export interface LegalAddress {
    /**
     * Address lines, it may one ore two lines.
     */
    address?: string[];
    /**
     * City name.
     */
    city?: string;
    /**
     * Region two-letter US state code like "CA" for California or a
     * free-form identification of a particular region worldwide.
     */
    region?: string;
    /**
     * PostalCode local postal code in free format.
     */
    postal_code?: string;
    /**
     * Country code in ISO3166Alpha2 format.
     */
    country?: string;
}
export type Region = string;
export const NoRegion: Region = "";
export const USARegion: Region = "usa";
export const LATAMRegion: Region = "latam";
export const AnywhereRegion: Region = "anywhere";
export const NotUSARegion: Region = "not_usa";

//////////
// source: agreement.go

/**
 * Agreement represents public.agreements
 */
export interface Agreement {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    entity_id: number /* int */;
    entity_table: string;
    customer_id?: number /* int */;
    contract_id?: number /* int */;
    contracting_entity_id?: number /* int */;
    name?: string;
    type: AgreementType;
    signed?: boolean;
    signed_at?: string /* RFC3339 */;
    pandadoc_id?: string;
    pandadoc_sign_url?: string;
    document_id?: number /* int */;
    amendment_type?: AmendmentType;
    user_id?: number /* int */;
    tax_form_type?: TaxFormType;
}
export type AgreementType = 'CA' | 'EA' | 'tax_form' | 'termination' | 'code_of_conduct' | 'amendment' | 'other';
export const CAAgreementType: AgreementType = "CA";
export const EAAgreementType: AgreementType = "EA";
export const TaxFormAgreementType: AgreementType = "tax_form";
export const TerminationAgreementType: AgreementType = "termination";
export const CodeOfConductAgreementType: AgreementType = "code_of_conduct";
export const AmendmentAgreementType: AgreementType = "amendment";
export const OtherAgreementType: AgreementType = "other";
export type AmendmentType = 'salary' | 'entity' | 'country';
export const SalaryAmendmentType: AmendmentType = "salary";
export const EntityAmendmentType: AmendmentType = "entity";
export const CountryAmendmentType: AmendmentType = "country";
export type TaxFormType = 'w8ben' | 'w8ben-e' | 'w9';
export const W8benTaxFormType: TaxFormType = "w8ben";
export const W8ben_eTaxFormType: TaxFormType = "w8ben-e";
export const W9TaxFormType: TaxFormType = "w9";

//////////
// source: application.go

/**
 * Application represents public.applications
 */
export interface Application {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    job_opening_id: number /* int */;
    candidate_id: number /* int */;
    stage_id: number /* int */;
    stage_kind: JobOpeningStageKind;
    stage_type?: CustomerStageType;
    stage_status?: JobOpeningStageStatus;
    status?: ApplicationStatus;
    moved_by?: number /* int */;
    last_stage_change_at?: string /* RFC3339 */;
    disqualification_reason?: DisqualificationReason;
    history: ApplicationHistory;
    data?: ApplicationData;
    score?: ApplicationScore;
    score_updated_at?: string /* RFC3339 */;
    last_stage_status_change_at?: string /* RFC3339 */;
    over_budget?: boolean;
    extra_match?: boolean;
    extra_match_reasons?: JobOpeningExpansions;
    match: boolean;
}
export type JobOpeningStageKind = 'sourced' | 'applied' | 'customer_submission' | 'customer_specific' | 'disqualified' | 'declined' | 'offer' | 'hired' | 'background_check';
export const SourcedJobOpeningStageKind: JobOpeningStageKind = "sourced";
export const AppliedJobOpeningStageKind: JobOpeningStageKind = "applied";
export const CustomerSubmissionJobOpeningStageKind: JobOpeningStageKind = "customer_submission";
export const CustomerSpecificJobOpeningStageKind: JobOpeningStageKind = "customer_specific";
export const DisqualifiedJobOpeningStageKind: JobOpeningStageKind = "disqualified";
export const DeclinedJobOpeningStageKind: JobOpeningStageKind = "declined";
export const OfferJobOpeningStageKind: JobOpeningStageKind = "offer";
export const HiredJobOpeningStageKind: JobOpeningStageKind = "hired";
export const BackgroundCheckJobOpeningStageKind: JobOpeningStageKind = "background_check";
export type CustomerStageType = 'first_screening' | 'technical_vetting' | 'round_of_interviews' | 'background_check' | 'take_home';
export const FirstScreeningCustomerStageType: CustomerStageType = "first_screening";
export const TechnicalVettingCustomerStageType: CustomerStageType = "technical_vetting";
export const RoundOfInterviewCustomerStageType: CustomerStageType = "round_of_interviews";
export const BackgroundCheckCustomerStageType: CustomerStageType = "background_check";
export const TakeHomeCustomerStageType: CustomerStageType = "take_home";
export type JobOpeningStageStatus = 'ready_to_submit' | 'pending_info' | 'backlog' | 'need_to_schedule' | 'scheduled' | 'interview_complete' | 'to_be_sent' | 'sent' | 'submitted' | 'needs_offer' | 'offer_sent' | 'offer_accepted' | 'background_check_ordered' | 'background_check_pending' | 'background_check_action_required';
export const ReadyToSubmitJobOpeningStageStatus: JobOpeningStageStatus = "ready_to_submit";
export const PendingInfoJobOpeningStageStatus: JobOpeningStageStatus = "pending_info";
export const BacklogJobOpeningStageStatus: JobOpeningStageStatus = "backlog";
export const NeedToScheduleJobOpeningStageStatus: JobOpeningStageStatus = "need_to_schedule";
export const ScheduledJobOpeningStageStatus: JobOpeningStageStatus = "scheduled";
export const InterviewCompleteJobOpeningStageStatus: JobOpeningStageStatus = "interview_complete";
export const ToBeSentJobOpeningStageStatus: JobOpeningStageStatus = "to_be_sent";
export const SentJobOpeningStageStatus: JobOpeningStageStatus = "sent";
export const SubmittedJobOpeningStageStatus: JobOpeningStageStatus = "submitted";
export const NeedsOfferJobOpeningStageStatus: JobOpeningStageStatus = "needs_offer";
export const OfferSentJobOpeningStageStatus: JobOpeningStageStatus = "offer_sent";
export const OfferAcceptedJobOpeningStageStatus: JobOpeningStageStatus = "offer_accepted";
export const BackgroundCheckOrderedJobOpeningStageStatus: JobOpeningStageStatus = "background_check_ordered";
export const BackgroundCheckPendingJobOpeningStageStatus: JobOpeningStageStatus = "background_check_pending";
export const BackgroundCheckActionRequiredJobOpeningStageStatus: JobOpeningStageStatus = "background_check_action_required";
export type ApplicationStatus = 'open' | 'closed' | 'hired';
export const OpenApplicationStatus: ApplicationStatus = "open";
export const ClosedApplicationStatus: ApplicationStatus = "closed";
export const HiredApplicationStatus: ApplicationStatus = "hired";
export type JobOpeningExpansion = 'seniority' | 'current_salary';
export const SeniorityJobOpeningExpansion: JobOpeningExpansion = "seniority";
export const CurrentSalaryJobOpeningExpansion: JobOpeningExpansion = "current_salary";

//////////
// source: application_fit_feedback.go

/**
 * ApplicationFitFeedback represents public.application_fit_feedbacks
 */
export interface ApplicationFitFeedback {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    score_id: string;
    type: ApplicationFitFeedbackType;
    application_id: number /* int */;
    fit: string[];
    feedback: string;
}
export type ApplicationFitFeedbackType = 'highlight' | 'watchout';
export const HighlightApplicationFitFeedbackType: ApplicationFitFeedbackType = "highlight";
export const WatchoutApplicationFitFeedbackType: ApplicationFitFeedbackType = "watchout";

//////////
// source: application_store.go

export interface ApplicationStatusChange {
    date?: string /* RFC3339 */;
    Status: ApplicationStatus;
}
export interface ApplicationScore {
    id: string;
    version: number /* int */;
    scores: Partial<Record<string, number /* int */>>;
    total: number /* int */;
    description?: string;
    good_fit_reasons: string[];
    bad_fit_reasons: string[];
    highlights?: string[];
    watchouts?: string[];
    gaps?: string[];
    duration: number /* float64 */; // in seconds
    generating_at?: string /* RFC3339 */;
    failed_at?: string /* RFC3339 */;
}
export type ScoreStatus = string;
export const PendingScoreStatus: ScoreStatus = "pending";
export const GeneratingScoreStatus: ScoreStatus = "generating";
export const ReadyScoreStatus: ScoreStatus = "ready";
export const FailedScoreStatus: ScoreStatus = "failed";
/**
 * SegmentedScoreVersion is the first scoring version that separates the fit
 * watchouts by audience, into customer-facing watchouts and candidate-facing gaps.
 */
export const SegmentedScoreVersion = 30;
export type CandidateJobScore = ApplicationScore;
/**
 * scoreGeneratingTimeout is the max amount of time we'll consider the score generating. If all this
 * time has passed and the flag has not been cleared, it's because there was an irrecoverable issue,
 * so we will ignore the flag in that case. It usually takes up to 5 min to score an application/prospect,
 * so 1 hour is _very_ generous.
 */
export interface ApplicationData {
    bio?: string;
}
export interface ApplicationCandidate {
    id: number /* int */;
    candidate_id: number /* int */;
    referred_by?: number /* int */;
    source: CandidateSource;
    user_id: number /* int */;
    roles: Roles;
    stage_id: number /* int */;
    stage_kind: JobOpeningStageKind;
    stage_status?: JobOpeningStageStatus;
    first_name: string;
    last_name: string;
    picture: string;
    last_stage_change_at?: string /* RFC3339 */;
    interview?: TalentSpecialistEvent;
    calendar_event_start?: string /* RFC3339 */;
    calendar_event_end?: string /* RFC3339 */;
    calendar_event_timezone?: string;
    calendar_event_job_opening_stage_interview_id?: string;
    calendar_event_completed?: boolean;
    disqualification_reason?: string;
    history?: ApplicationHistory;
    offer_letter_id?: number /* int */;
    offer_letter_status?: OfferLetterStatus;
    message_count?: number /* int */;
    score?: ApplicationScore;
    email_status?: EmailStatus;
    email_scheduled_date_time?: string /* RFC3339 */;
    email_scheduled_timezone?: string;
    email_sent_at?: string /* RFC3339 */;
    verified?: boolean;
    verification_status?: CandidateVerificationStatus;
    profile_complete?: boolean;
    onboard_flow?: OnboardFlow;
    client_referral?: boolean;
    referrer_first_name?: string;
    referrer_last_name?: string;
    over_budget?: boolean;
    extra_match?: boolean;
    extra_match_reasons?: JobOpeningExpansions;
    match: boolean;
    recommended?: boolean;
}
export type ApplicationHistory = StageChange[];
/**
 * StageChange represents when an application has changed to an specific stage.
 */
export interface StageChange {
    changed_at: string /* RFC3339 */;
    user_id?: number /* int */; // who performed the change
    stage_id: number /* int */;
    kind: JobOpeningStageKind;
    status?: JobOpeningStageStatus;
    reason?: DisqualificationReason;
    legacy_job?: string; // job opening title for pre-unified remotely openings
    Visibility: Visibility;
}

//////////
// source: audit_log.go

/**
 * AuditLog represents public.audit_log
 */
export interface AuditLog {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    user_id?: number /* int */;
    token_id?: number /* int */;
    impersonated_user_id?: number /* int */;
    url?: string;
    kind: AuditLogKind;
    table: string;
    affected_id: number /* int */;
    affected_fields: AffectedFields;
}

//////////
// source: audit_log_store.go

export type AuditLogKind = string;
export const AgreementSignedAuditLogKind: AuditLogKind = "agreement_signed";
export const ApplicationStageChangedAuditLogKind: AuditLogKind = "application_stage_changed";
export const BonusCreatedAuditLogKind: AuditLogKind = "bonus_created";
export const BonusChangedAuditLogKind: AuditLogKind = "bonus_changed";
export const CandidateCreatedAuditLogKind: AuditLogKind = "candidate_created";
export const CandidateTsInterviewChangedAuditLogKind: AuditLogKind = "candidate_tsinterview_changed";
export const ContractStatusChangedAuditLogKind: AuditLogKind = "contract_status_changed";
export const ContractPTOAdjustmentAuditLogKind: AuditLogKind = "contract_pto_adjustment";
export const ContractTerminatedAuditLogKind: AuditLogKind = "contract_terminated";
export const ContractResignedAuditLogKind: AuditLogKind = "contract_resigned";
export const ContractTerminationAcceptedLogKind: AuditLogKind = "contract_termination_accepted";
export const ContractTerminationRejectedLogKind: AuditLogKind = "contract_termination_rejected";
export const ContractHealthInsuranceStatusChangedAuditLogKind: AuditLogKind = "contract_health_insurance_status_changed";
export const ContractHealthInsuranceMemberStatusChangedAuditLogKind: AuditLogKind = "contract_health_insurance_member_status_changed";
export const CustomerInvoiceCreatedAuditLogKind: AuditLogKind = "customer_invoice_created";
export const CustomerInvoiceChangedAuditLogKind: AuditLogKind = "customer_invoice_changed";
export const EquipmentCreatedAuditLogKind: AuditLogKind = "equipment_created";
export const EquipmentStatusChangeAuditLogKind: AuditLogKind = "equipment_status_changed";
export const EquipmentQuoteCreatedAuditLogKind: AuditLogKind = "equipment_quote_created";
export const EquipmentQuoteStatusChangeAuditLogKind: AuditLogKind = "equipment_quote_status_changed";
export const ExpenseCreatedAuditLogKind: AuditLogKind = "expense_created";
export const ExpenseStatusChangeAuditLogKind: AuditLogKind = "expense_status_changed";
export const JobOpeningClosedAuditLogKind: AuditLogKind = "job_opening_closed";
export const OfferLetterApprovedAuditLogKind: AuditLogKind = "offer_letter_approved";
export const OfferLetterCreatedAuditLogKind: AuditLogKind = "offer_letter_created";
export const OfferLetterSentAuditLogKind: AuditLogKind = "offer_letter_sent";
export const OfferLetterSignedAuditLogKind: AuditLogKind = "offer_letter_signed";
export const PricingFeeCreatedAuditLogKind: AuditLogKind = "pricing_fee_created";
export const PTOPolicyChangedAuditLogKind: AuditLogKind = "pto_policy_changed";
export const RaiseCreatedAuditLogKind: AuditLogKind = "raise_created";
export const RaiseChangeAuditLogKind: AuditLogKind = "raise_changed";
export const ReferralChangeAuditLogKind: AuditLogKind = "referral_changed";
export const TokenImpersonationAuditLogKind: AuditLogKind = "token_impersonation";
export const UserRolesChangedAuditLogKind: AuditLogKind = "user_roles_changed";
export const TwoFactorAuthConfigVerifiedLogKind: AuditLogKind = "two_factor_auth_config_verified";
export const TwoFactorAuthConfigDisabledLogKind: AuditLogKind = "two_factor_auth_config_disabled";
export const AuthCodesRegeneratedLogKind: AuditLogKind = "auth_codes_regenerated";
export const AuthCodeUsedLogKind: AuditLogKind = "auth_code_used";
export const TagMergedLogKind: AuditLogKind = "tag_merged";
export const VerificationApprovedAuditLogKind: AuditLogKind = "verification_approved";
export const VerificationDeclinedAuditLogKind: AuditLogKind = "verification_declined";
export const VerificationRequestedAuditLogKind: AuditLogKind = "verification_requested";
export const UserDeletionRequestAcceptedAuditLogKind: AuditLogKind = "deletion_accepted";
export const UserDeletionRequestDeclinedAuditLogKind: AuditLogKind = "deletion_declined";
/**
 * Generic
 */
export const DeletedEntityAuditLogKind: AuditLogKind = "deleted_entity";
export type AffectedFields = AffectedField[];
export interface AffectedField {
    Field: string;
    From: string;
    To: string;
}

//////////
// source: auth_code.go

/**
 * AuthCode represents public.auth_codes
 */
export interface AuthCode {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    code: string;
    used_at?: string /* RFC3339 */;
    user_id: number /* int */;
}

//////////
// source: background_check_pricing.go

/**
 * BackgroundCheckPricing represents public.background_check_pricings
 */
export interface BackgroundCheckPricing {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    country_code?: string;
    type: BackgroundCheckPricingType;
    price: number;
    eta_days_min?: number /* int */;
    eta_days_max?: number /* int */;
}
export type BackgroundCheckPricingType = 'criminal' | 'global_watchlist';
export const CriminalBackgroundCheckPricingType: BackgroundCheckPricingType = "criminal";
export const GlobalWatchlistBackgroundCheckPricingType: BackgroundCheckPricingType = "global_watchlist";

//////////
// source: bank_account.go

/**
 * BankAccount represents public.bank_accounts
 */
export interface BankAccount {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    primary?: boolean;
    method: BankAccountMethod;
    service: BankAccountService;
    user_id: number /* int */;
    legal_name: string;
    alias?: string;
    country: string;
    address: LegalAddress;
    routing_number?: string;
    account_number?: string;
    account_type?: BankAccountType;
    iban?: string;
    swift?: string;
    cbu?: string;
    tax_id?: string;
    clabe?: string;
    mercury_id?: string;
    bank_code?: string;
    transit_number?: string;
    last_number_update_at?: string /* RFC3339 */;
    beneficiary_id?: string;
    currency?: string;
    set_primary_at?: string /* RFC3339 */;
    routing_number_mask?: string;
    account_number_mask?: string;
    iban_mask?: string;
    swift_mask?: string;
    cbu_mask?: string;
    tax_id_mask?: string;
    clabe_mask?: string;
    bank_code_mask?: string;
    transit_number_mask?: string;
    memo?: string;
    contracting_entity_id?: number /* int */;
    status?: BankAccountStatus;
    wants_primary?: boolean;
}
export type BankAccountService = 'mercury' | 'nium' | 'tipalti';
export const MercuryBankAccountService: BankAccountService = "mercury";
export const NiumBankAccountService: BankAccountService = "nium";
export const TipaltiBankAccountService: BankAccountService = "tipalti";
export type BankAccountType = 'personal_checking' | 'personal_savings' | 'business_checking' | 'business_savings';
export const PersonalCheckingBankAccountType: BankAccountType = "personal_checking";
export const PersonalSavingBankAccountType: BankAccountType = "personal_savings";
export const BusinessCheckingBankAccountType: BankAccountType = "business_checking";
export const BusinessSavingsBankAccountType: BankAccountType = "business_savings";
export type BankAccountStatus = 'active' | 'pending' | 'rejected' | 'inactive';
export const ActiveBankAccountStatus: BankAccountStatus = "active";
export const PendingBankAccountStatus: BankAccountStatus = "pending";
export const RejectedBankAccountStatus: BankAccountStatus = "rejected";
export const InactiveBankAccountStatus: BankAccountStatus = "inactive";

//////////
// source: bank_account_store.go


//////////
// source: bank_account_validation_schema.go

/**
 * BankAccountValidationSchema represents public.bank_account_validation_schemas
 */
export interface BankAccountValidationSchema {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    title: string;
    schema_id: string;
    currency?: string;
    method: BankAccountMethod;
    countries: string[];
    schema: string;
}
export type BankAccountMethod = 'ACH' | 'wire' | 'international_wire' | 'LOCAL' | 'SWIFT';
export const ACHBankAccountMethod: BankAccountMethod = "ACH";
export const WireBankAccountMethod: BankAccountMethod = "wire";
export const InternationalWireBankAccountMethod: BankAccountMethod = "international_wire";
export const LOCALBankAccountMethod: BankAccountMethod = "LOCAL";
export const SWIFTBankAccountMethod: BankAccountMethod = "SWIFT";

//////////
// source: bank_account_validation_schema_store.go


//////////
// source: bonus.go

/**
 * Bonus represents public.bonuses
 */
export interface Bonus {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    status?: BonusStatus;
    contractor_accounting_status?: AccountingStatus;
    customer_accounting_status?: AccountingStatus;
    created_by?: number /* int */;
    contract_id: number /* int */;
    customer_id: number /* int */;
    comment?: string;
    effective_at: string /* RFC3339 */;
    amount: number;
    customer_invoice_id?: number /* int */;
    contractor_invoice_id?: number /* int */;
    reviewed_at?: string /* RFC3339 */;
    reviewer_id?: number /* int */;
}
export type BonusStatus = 'pending' | 'approved' | 'rejected';
export const PendingBonusStatus: BonusStatus = "pending";
export const ApprovedBonusStatus: BonusStatus = "approved";
export const RejectedBonusStatus: BonusStatus = "rejected";
export type AccountingStatus = 'pending' | 'invoiced' | 'paid';
export const PendingAccountingStatus: AccountingStatus = "pending";
export const InvoicedAccountingStatus: AccountingStatus = "invoiced";
export const PaidAccountingStatus: AccountingStatus = "paid";

//////////
// source: bonus_store.go


//////////
// source: calendar_event.go

/**
 * CalendarEvent represents public.calendar_events
 */
export interface CalendarEvent {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    status?: CalendarEventStatus;
    source?: CalendarEventSource;
    visibility?: Visibility;
    organizer_id: number /* int */;
    start: string /* RFC3339 */;
    end?: string /* RFC3339 */;
    timezone?: string;
    attendees: string[];
    candidate_id: number /* int */;
    summary: string;
    uid: string;
    last_modified?: string /* RFC3339 */;
    meeting_url?: string;
    meeting_url_custom?: boolean;
    recorded: boolean;
    job_opening_stage_id?: number /* int */;
    job_opening_stage_interview_id?: string;
    remotely_managed?: boolean;
    google_meet_space_id?: string;
    google_calendar_event_id?: string;
    notified_at?: string /* RFC3339 */;
}
export type CalendarEventStatus = 'tentative' | 'confirmed' | 'cancelled' | 'pending_cancellation';
export const TentativeCalendarEventStatus: CalendarEventStatus = "tentative";
export const ConfirmedCalendarEventStatus: CalendarEventStatus = "confirmed";
export const CancelledCalendarEventStatus: CalendarEventStatus = "cancelled";
export const PendingCancellationCalendarEventStatus: CalendarEventStatus = "pending_cancellation";
export type CalendarEventSource = 'unknown' | 'meet' | 'zoom' | 'daily' | 'mux';
export const UnknownCalendarEventSource: CalendarEventSource = "unknown";
export const MeetCalendarEventSource: CalendarEventSource = "meet";
export const ZoomCalendarEventSource: CalendarEventSource = "zoom";
export const DailyCalendarEventSource: CalendarEventSource = "daily";
export const MuxCalendarEventSource: CalendarEventSource = "mux";
export type Visibility = 'candidate' | 'customer' | 'private';
export const CandidateVisibility: Visibility = "candidate";
export const CustomerVisibility: Visibility = "customer";
export const PrivateVisibility: Visibility = "private";

//////////
// source: calendar_event_store.go

export interface CalendarEventAttendance {
    joined?: (CalendarEventAttendanceAttendee | undefined)[];
    start: string /* RFC3339 */;
    end: string /* RFC3339 */;
    recording_id?: string;
    recording_url?: string;
    transcript_id?: string;
    transcript_url?: string;
}
export interface CalendarEventAttendanceAttendee {
    anonymous?: boolean;
    phone?: boolean;
    id?: string;
    display_name?: string;
    primary_email?: string;
    emails?: string[];
    joined_at: string /* RFC3339 */;
    left_at: string /* RFC3339 */;
}
export interface CalendarEventWithOrganizer {
    CalendarEvent: CalendarEvent;
    poster_first_name: string;
    poster_last_name: string;
    poster_picture: string;
}
/**
 * CalendarEventWithRecording is a domain.CalendarEvent with some extra recording information
 */
export interface CalendarEventWithRecording {
    CalendarEvent?: CalendarEvent;
    completed: boolean;
    recording_url?: string;
}

//////////
// source: candidate.go

/**
 * Candidate represents public.candidates
 */
export interface Candidate {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    user_id: number /* int */;
    source: CandidateSource;
    email: string[];
    email_normalized: string[];
    tags: number[];
    tags_metadata?: TagsMetadata;
    profile_updated_at?: string /* RFC3339 */;
    last_autotags_updated_at?: string /* RFC3339 */;
    skills: number[];
    permalink: string;
    resume_url?: string;
    linkedin_resume: LinkedinResume;
    linkedin_resume_updated_at?: string /* RFC3339 */;
    linkedin_resume_errored_at?: string /* RFC3339 */;
    linkedin_resume_status?: LinkedinResumeStatus;
    ts_interview: CandidateProfile;
    marketing: Marketing;
    application_data: CandidateApplicationData;
    lead_data: CandidateLeadData;
    referred_by?: number /* int */;
    created_by?: number /* int */;
    last_updated_by?: number /* int */;
    open_to_opportunities: boolean;
    last_open_to_opportunities_at?: string /* RFC3339 */;
    open_to_opportunities_after?: string /* RFC3339 */;
    open_to_opportunities_reason?: string;
    network_accepted_at?: string /* RFC3339 */;
    status?: CandidateStatus;
    status_last_updated_at?: string /* RFC3339 */;
    status_disqualification_reason?: DisqualificationReason;
    about?: string;
    about_hash?: string;
    provided_references?: number /* int */;
    verification_status?: CandidateVerificationStatus;
    experience_years?: number /* int */;
    roles?: number[];
    profile_complete?: boolean;
    profile_builder?: CandidateProfileBuilder;
    im_contact_id?: string;
    experiments?: Experiments;
    computed_active_applications_count?: number /* int */;
    computed_last_applied_at?: string /* RFC3339 */;
    onboard_flow?: OnboardFlow;
    grain_recording_url?: string;
    ai_experience?: CandidateAIExperience;
}
export type CandidateSource = 'onboard' | 'referral' | 'gitsight' | 'sourced' | 'careers_site' | 'claria' | 'linkedin' | 'typeform' | 'calendly' | 'contractor' | 'hunting_torre' | 'hunting_consider' | 'hunting_linkedin' | 'hunting_progai' | 'paid' | 'organic' | 'external_recruiter' | 'dripify' | 'other';
export const OnboardCandidateSource: CandidateSource = "onboard";
export const ReferralCandidateSource: CandidateSource = "referral";
export const GitsightCandidateSource: CandidateSource = "gitsight";
export const SourcedCandidateSource: CandidateSource = "sourced";
export const CareersSiteCandidateSource: CandidateSource = "careers_site";
export const ClariaCandidateSource: CandidateSource = "claria";
export const LinkedinCandidateSource: CandidateSource = "linkedin";
export const TypeformCandidateSource: CandidateSource = "typeform";
export const CalendlyCandidateSource: CandidateSource = "calendly";
export const ContractorCandidateSource: CandidateSource = "contractor";
export const HuntingTorreCandidateSource: CandidateSource = "hunting_torre";
export const HuntingConsiderCandidateSource: CandidateSource = "hunting_consider";
export const HuntingLinkedinCandidateSource: CandidateSource = "hunting_linkedin";
export const HuntingProgaiCandidateSource: CandidateSource = "hunting_progai";
export const PaidCandidateSource: CandidateSource = "paid";
export const OrganicCandidateSource: CandidateSource = "organic";
export const ExternalRecruiterCandidateSource: CandidateSource = "external_recruiter";
export const DripifyCandidateSource: CandidateSource = "dripify";
export const OtherCandidateSource: CandidateSource = "other";
export type LinkedinResumeStatus = 'pending' | 'filled' | 'error' | 'not_found';
export const PendingLinkedinResumeStatus: LinkedinResumeStatus = "pending";
export const FilledLinkedinResumeStatus: LinkedinResumeStatus = "filled";
export const ErrorLinkedinResumeStatus: LinkedinResumeStatus = "error";
export const NotFoundLinkedinResumeStatus: LinkedinResumeStatus = "not_found";
export type CandidateStatus = 'sourced' | 'first_contact' | 'second_contact' | 'disqualified_lead' | 'disqualified' | 'declined' | 'applicant' | 'network_accepted' | 'hired_customer' | 'anonymized';
export const SourcedCandidateStatus: CandidateStatus = "sourced";
export const FirstContactCandidateStatus: CandidateStatus = "first_contact";
export const SecondContactCandidateStatus: CandidateStatus = "second_contact";
export const DisqualifiedLeadCandidateStatus: CandidateStatus = "disqualified_lead";
export const DisqualifiedCandidateStatus: CandidateStatus = "disqualified";
export const DeclinedCandidateStatus: CandidateStatus = "declined";
export const ApplicantCandidateStatus: CandidateStatus = "applicant";
export const NetworkAcceptedCandidateStatus: CandidateStatus = "network_accepted";
export const HiredCustomerCandidateStatus: CandidateStatus = "hired_customer";
export const AnonymizedCandidateStatus: CandidateStatus = "anonymized";
export type CandidateExperiment = 'ai_profile_builder';
export const AiProfileBuilderCandidateExperiment: CandidateExperiment = "ai_profile_builder";
export type OnboardFlow = 'standard' | 'ai_interview' | 'ai_profile_builder' | 'non_scheduling';
export const StandardOnboardFlow: OnboardFlow = "standard";
export const AiInterviewOnboardFlow: OnboardFlow = "ai_interview";
export const AiProfileBuilderOnboardFlow: OnboardFlow = "ai_profile_builder";
export const NonSchedulingOnboardFlow: OnboardFlow = "non_scheduling";

//////////
// source: candidate_background_check.go

/**
 * CandidateBackgroundCheck represents public.candidate_background_checks
 */
export interface CandidateBackgroundCheck {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    candidate_id: number /* int */;
    customer_id: number /* int */;
    application_id?: number /* int */;
    package_slug: string;
    work_country: string;
    work_state?: string;
    work_city?: string;
    status?: CandidateBackgroundCheckStatus;
    checkr_candidate_id?: string;
    checkr_invitation_id?: string;
    checkr_invitation_url?: string;
    checkr_report_id?: string;
    checkr_invitation_status?: CheckrInvitationStatus;
    checkr_report_status?: CheckrReportStatus;
    checkr_report_result?: CheckrReportResult;
    checkr_report_assessment?: CheckrReportAssessment;
    ordered_at?: string /* RFC3339 */;
    estimated_completion_at?: string /* RFC3339 */;
    completed_at?: string /* RFC3339 */;
    report?: string;
    price: number;
    accounting_status?: AccountingStatus;
    document_id?: number /* int */;
    order_document_id?: number /* int */;
    customer_invoice_id?: number /* int */;
    expired_at?: string /* RFC3339 */;
    canceled_at?: string /* RFC3339 */;
    offer_letter_id?: number /* int */;
}
export type CandidateBackgroundCheckStatus = 'draft' | 'order_failed' | 'invitation_sent' | 'invitation_expired' | 'in_progress' | 'suspended' | 'paused' | 'dispute' | 'action_required' | 'completed' | 'rejected' | 'canceled';
export const DraftCandidateBackgroundCheckStatus: CandidateBackgroundCheckStatus = "draft";
export const OrderFailedCandidateBackgroundCheckStatus: CandidateBackgroundCheckStatus = "order_failed";
export const InvitationSentCandidateBackgroundCheckStatus: CandidateBackgroundCheckStatus = "invitation_sent";
export const InvitationExpiredCandidateBackgroundCheckStatus: CandidateBackgroundCheckStatus = "invitation_expired";
export const InProgressCandidateBackgroundCheckStatus: CandidateBackgroundCheckStatus = "in_progress";
export const SuspendedCandidateBackgroundCheckStatus: CandidateBackgroundCheckStatus = "suspended";
export const PausedCandidateBackgroundCheckStatus: CandidateBackgroundCheckStatus = "paused";
export const DisputeCandidateBackgroundCheckStatus: CandidateBackgroundCheckStatus = "dispute";
export const ActionRequiredCandidateBackgroundCheckStatus: CandidateBackgroundCheckStatus = "action_required";
export const CompletedCandidateBackgroundCheckStatus: CandidateBackgroundCheckStatus = "completed";
export const RejectedCandidateBackgroundCheckStatus: CandidateBackgroundCheckStatus = "rejected";
export const CanceledCandidateBackgroundCheckStatus: CandidateBackgroundCheckStatus = "canceled";
export type CheckrInvitationStatus = 'pending' | 'completed' | 'expired' | 'canceled';
export const PendingCheckrInvitationStatus: CheckrInvitationStatus = "pending";
export const CompletedCheckrInvitationStatus: CheckrInvitationStatus = "completed";
export const ExpiredCheckrInvitationStatus: CheckrInvitationStatus = "expired";
export const CanceledCheckrInvitationStatus: CheckrInvitationStatus = "canceled";
export type CheckrReportStatus = 'pending' | 'complete' | 'suspended' | 'paused' | 'dispute' | 'canceled';
export const PendingCheckrReportStatus: CheckrReportStatus = "pending";
export const CompleteCheckrReportStatus: CheckrReportStatus = "complete";
export const SuspendedCheckrReportStatus: CheckrReportStatus = "suspended";
export const PausedCheckrReportStatus: CheckrReportStatus = "paused";
export const DisputeCheckrReportStatus: CheckrReportStatus = "dispute";
export const CanceledCheckrReportStatus: CheckrReportStatus = "canceled";
export type CheckrReportResult = 'clear' | 'consider';
export const ClearCheckrReportResult: CheckrReportResult = "clear";
export const ConsiderCheckrReportResult: CheckrReportResult = "consider";
export type CheckrReportAssessment = 'eligible' | 'review' | 'escalated';
export const EligibleCheckrReportAssessment: CheckrReportAssessment = "eligible";
export const ReviewCheckrReportAssessment: CheckrReportAssessment = "review";
export const EscalatedCheckrReportAssessment: CheckrReportAssessment = "escalated";

//////////
// source: candidate_customer_fit.go

/**
 * CandidateCustomerFit represents public.candidate_customer_fits
 */
export interface CandidateCustomerFit {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    candidate_id: number /* int */;
    customer_id: number /* int */;
    result: CandidateCustomerFitResult;
    reason: string;
}
export type CandidateCustomerFitResult = 'fits' | 'does_not_fit' | 'unknown';
export const FitCandidateCustomerFitResult: CandidateCustomerFitResult = "fits";
export const DoesNotFitCandidateCustomerFitResult: CandidateCustomerFitResult = "does_not_fit";
export const UnknownCandidateCustomerFitResult: CandidateCustomerFitResult = "unknown";

//////////
// source: candidate_data.go

export type AIExperienceCategory = 'ai-assisted' | 'ai-builder' | 'ai-model-builder' | 'no-evidence';
export const AIAssisted: AIExperienceCategory = "ai-assisted";
export const AIBuilder: AIExperienceCategory = "ai-builder";
export const AIModelBuilder: AIExperienceCategory = "ai-model-builder";
export const NoAIEvidence: AIExperienceCategory = "no-evidence";
export interface AICategoryExperience {
    category: AIExperienceCategory;
    blurb: string;
    tech_stack: number /* int */[];
}
export interface CandidateAIExperience {
    categories: AIExperienceCategory[];
    experiences?: AICategoryExperience[];
    skills?: number /* int */[];
    last_updated_at?: string /* RFC3339 */;
    last_updated_by?: number /* int */;
}
export interface SourceChange {
    source: CandidateSource;
    time: string /* RFC3339 */;
    user_id?: number /* int */;
    referrer_id?: number /* int */;
}
export type SourceHistory = SourceChange[];
export type LinkedinResume = Record<string, any>;
export interface Marketing {
    utm_campaign?: string;
    utm_medium?: string;
    utm_source?: string;
    utm_position?: string;
}
export interface CandidateProfile extends CandidateProfilePublic, CandidateProfilePrivate {
    interviewer_id?: number /* int */;
    interviewed_at?: string /* RFC3339 */;
    scheduled_at?: string /* RFC3339 */;
    event?: TalentSpecialistEvent;
}
export interface TalentSpecialistEvent {
    history: TalentSpecialistEventHistory[];
    uri?: string;
    created_at?: string /* RFC3339 */;
    start_time?: string /* RFC3339 */;
    meeting_url?: string;
    interviewer?: string;
}
export interface TalentSpecialistEventHistory {
    uri?: string;
    time: string /* RFC3339 */;
    start_time: string /* RFC3339 */;
    interviewer?: string;
}
export interface ExpectedSalaryHistory {
    amount: number;
    timestamp: string /* RFC3339 */;
    user_id?: number /* int */;
    user_name?: string;
}
export interface SeniorityChange {
    seniority: SeniorityLevel;
    previous_seniority?: SeniorityLevel;
    reason?: string;
    changed_at: string /* RFC3339 */;
}
export type SeniorityEvaluationOutcome = 'evaluated' | 'deferred_active_pipeline';
export const EvaluatedSeniorityEvaluationOutcome: SeniorityEvaluationOutcome = "evaluated";
export const DeferredActivePipelineSeniorityEvaluationOutcome: SeniorityEvaluationOutcome = "deferred_active_pipeline";
export type SeniorityEvaluationCohort = 'engineering';
export const EngineeringSeniorityEvaluationCohort: SeniorityEvaluationCohort = "engineering";
export type WorkExperienceSource = 'manual' | 'linkedin' | 'ai_profile_builder' | 'contract_termination' | 'ai_experience_formatter';
export const ManualWorkExperienceSource: WorkExperienceSource = "manual";
export const LinkedinWorkExperienceSource: WorkExperienceSource = "linkedin";
export const AIProfileBuilderWorkExperienceSource: WorkExperienceSource = "ai_profile_builder";
export const ContractTerminationWorkExperienceSource: WorkExperienceSource = "contract_termination";
export const AIExperienceFormatterWorkExperienceSource: WorkExperienceSource = "ai_experience_formatter";
export type WorkExperienceHistoryAction = 'created' | 'updated' | 'deleted';
export const CreatedWorkExperienceHistoryAction: WorkExperienceHistoryAction = "created";
export const UpdatedWorkExperienceHistoryAction: WorkExperienceHistoryAction = "updated";
export const DeletedWorkExperienceHistoryAction: WorkExperienceHistoryAction = "deleted";
/**
 * WorkExperienceHistoryEntry is the payload for CandidateWorkExperienceHistoryType.
 */
export interface WorkExperienceHistoryEntry {
    work_experience_id: string;
    action: WorkExperienceHistoryAction;
    source: WorkExperienceSource;
    changed_fields?: string[];
    changed_at: string /* RFC3339 */;
    user_id?: number /* int */;
}
export type CertificationSource = 'manual' | 'linkedin';
export const ManualCertificationSource: CertificationSource = "manual";
export const LinkedinCertificationSource: CertificationSource = "linkedin";
export type CertificationHistoryAction = 'created' | 'updated' | 'deleted';
export const CreatedCertificationHistoryAction: CertificationHistoryAction = "created";
export const UpdatedCertificationHistoryAction: CertificationHistoryAction = "updated";
export const DeletedCertificationHistoryAction: CertificationHistoryAction = "deleted";
export interface CertificationHistoryEntry {
    certification_id: string;
    action: CertificationHistoryAction;
    source: CertificationSource;
    changed_fields?: string[];
    changed_at: string /* RFC3339 */;
    user_id?: number /* int */;
}
export interface CandidateProfilePublic {
    summary?: string;
    time_zone?: string;
    career_goals?: string;
    career_expectations?: string;
    work_experience?: WorkExperience[];
    work_experience_last_updated_at?: string /* RFC3339 */;
    expected_salary?: number;
    expected_salary_updated_at?: string /* RFC3339 */;
    studies?: Study[];
    certifications: Certification[];
    seniority?: SeniorityLevel;
    grain_url?: string[];
    experience_years?: number /* int */;
    is_manager_or_lead?: boolean;
    /**
     * TechStrengths list of Tag ids, with category SkillTagCategory
     */
    tech_strengths?: number /* int */[];
    /**
     * Expertise list of Tag ids, with category ExpertiseTagCategory
     */
    expertise?: number /* int */[];
    /**
     * Industry list of Tag ids, with category SectorTagCategory
     */
    industry?: number /* int */[];
    /**
     * Other links to the candidate's work.
     * TechnicalAssessmentURL is the URL of the technical assessment.
     */
    technical_assessment_url?: string;
    portfolio_url?: string;
    portfolio_password?: string;
    other_personal_url?: string;
    /**
     * CurrentJob is the lagacy version of WorkExperience[0]
     */
    current_job?: string;
    /**
     * PastJob is the lagacy version of WorkExperience[1:]
     */
    past_job?: string;
    /**
     * IdealPosition is the legacy version of Role
     */
    ideal_position?: string;
    /**
     * Roles list of roles that this candidate can accomplish. This is a list
     * of ids from the JobOpeningRole table.
     */
    roles?: number /* int */[];
}
export interface WorkExperience {
    id?: string;
    hash?: string;
    /**
     * Company name, compatible with linkedin.Resume entity
     */
    company: string;
    /**
     * CustomerID is an optional ID of the customer
     */
    customer_id?: number /* int */;
    /**
     * ContractID is an optional ID of the contract
     */
    contract_id?: number /* int */;
    /**
     * CompanyURL is the LinkedIn URL of the company, compatible with linkedin.Resume entity.
     */
    company_url: string;
    /**
     * Position name, compatible with linkedin.Resume entity
     */
    position: string;
    /**
     * Period of time, compatible with linkedin.Resume entity
     */
    period: Period;
    /**
     * Stack list of Tag.IDs
     */
    stack?: number /* int */[];
    /**
     * Industries of the company.
     */
    industries: number /* int */[];
    /**
     * Description of the role
     */
    description: string;
    /**
     * TODO: this field will be removed soon, so don't rely on it.
     */
    original_description?: string;
    /**
     * Quit job reason
     */
    quit_reason: string;
    /**
     * Current job
     */
    is_current: boolean;
}
export interface Study {
    /**
     * School name, compatible with linkedin.Education entity
     */
    school: string;
    /**
     * Title name, compatible with linkedin.Education entity
     */
    title: string;
    /**
     * Period name, compatible with linkedin.Education entity
     */
    period: Period;
}
export interface Certification {
    id: string;
    hash: string;
    name: string;
    organization: string;
    year: number /* int */;
    month: number;
    evidence?: string;
    hidden?: boolean;
}
export interface Period {
    from: string /* RFC3339 */;
    to: string /* RFC3339 */;
}
export interface CandidateProfilePrivate {
    score?: number /* int */;
    current_salary?: number;
    benefits_relation?: string;
    yellow_flags?: string;
    personal_background?: string;
    personal_appreciation?: string;
    remotely_needs?: {
        english_level?: EnglishLevel;
        work_experience?: Grade;
        interviewing_skills?: Grade;
        work_stability?: Grade;
        remote_experience_skills?: Grade;
    };
    cultural_fit?: {
        overall_personality?: Grade;
        accountability?: Grade;
        transparency?: Grade;
        professionalism?: Grade;
        ego_health?: Grade;
        teamwork?: Grade;
        politeness?: Grade;
    };
    communication_skills?: {
        assertiveness?: Grade;
        body_language?: Grade;
        listening_skills?: Grade;
        elaboration_in_the_answers?: Grade;
    };
    startup_experience?: boolean;
    mentoring_experience?: boolean;
    other_processes?: boolean;
    live_coding_experience?: boolean;
    /**
     * Notes private Talent Specialist Notes
     */
    notes?: string;
    /**
     * TalentManagerNotes private Talent Manager Notes
     */
    talent_manager_notes?: string;
    work_type?: WorkType[];
}
export type Grade = number /* int */;
export const AwfulGrade: Grade = 1;
export const PoorGrade: Grade = 2;
export const NeedsImprovementGrade: Grade = 3;
export const GoodGrade: Grade = 4;
export const VeryGoodGrade: Grade = 5;
export const GreatGrade: Grade = 6;
export type SeniorityLevel = string;
export const IC1SeniorityLevel: SeniorityLevel = "IC1";
export const IC2SeniorityLevel: SeniorityLevel = "IC2";
export const IC3SeniorityLevel: SeniorityLevel = "IC3";
export const IC4SeniorityLevel: SeniorityLevel = "IC4";
export const IC5SeniorityLevel: SeniorityLevel = "IC5";
export const IC6SeniorityLevel: SeniorityLevel = "IC6";
export const M5SeniorityLevel: SeniorityLevel = "M5";
export const M6SeniorityLevel: SeniorityLevel = "M6";
export const LeadSeniorityLevel: SeniorityLevel = "lead";
export const ManagerSeniorityLevel: SeniorityLevel = "manager";
export const DirectorSeniorityLevel: SeniorityLevel = "director";
export type EnglishLevel = number /* int */;
export const BeginnerEnglishLevel: EnglishLevel = 1; // A1
export const ElementaryEnglishLevel: EnglishLevel = 2; // A2
export const IntermediateEnglishLevel: EnglishLevel = 3; // B1
export const UpperIntermediateEnglishLevel: EnglishLevel = 4; // B2
export const AdvancedEnglishLevel: EnglishLevel = 5; // C1
export const ProficientEnglishLevel: EnglishLevel = 6; // C2
export type CandidateApplicationStep = string;
export const StartApplicationStep: CandidateApplicationStep = "start";
export const ExperienceApplicationStep: CandidateApplicationStep = "experience";
export const SkillsApplicationStep: CandidateApplicationStep = "skills";
export const EnglishTestApplicationStep: CandidateApplicationStep = "english_test";
export const VideoAskApplicationStep: CandidateApplicationStep = "videoask";
export const AsyncInterviewApplicationStep: CandidateApplicationStep = "async_interview";
export const AIInterviewApplicationStep: CandidateApplicationStep = "ai_interview";
export const ScheduleMeetingApplicationStep: CandidateApplicationStep = "schedule";
export const ScheduledMeetingApplicationStep: CandidateApplicationStep = "scheduled";
export const LastDetailsApplicationStep: CandidateApplicationStep = "last_details";
export const FinishedApplicationStep: CandidateApplicationStep = "finished";
export const RejectionApplicationStep: CandidateApplicationStep = "rejection";
export type ApplicationRejectionReason = string;
export const EnglishApplicationRejection: ApplicationRejectionReason = "english_level";
export const ExperienceApplicationRejection: ApplicationRejectionReason = "experience";
export const NotDeveloperApplicationRejection: ApplicationRejectionReason = "not_developer";
export const CountryApplicationRejection: ApplicationRejectionReason = "country";
export interface CandidateApplicationDataHistory {
    step: CandidateApplicationStep;
    rejection_reason?: ApplicationRejectionReason;
    time: string /* RFC3339 */;
}
export type CandidateApplicationHistory = CandidateApplicationData[];
export type AIInterviewService = string;
export const HirevoiceAIInterviewService: AIInterviewService = "hirevoice";
export const AdaAIInterviewService: AIInterviewService = "ada";
export const ElevenlabsAIInterviewService: AIInterviewService = "elevenlabs";
export type AIInterviewStatus = 'completed' | 'not_evaluated' | 'timeout' | 'permission_denied' | 'audio_issue' | 'system_error' | 'unknown';
export const CompletedAIInterviewStatus: AIInterviewStatus = "completed";
export const NotEvaluatedAIInterviewStatus: AIInterviewStatus = "not_evaluated";
export const TimeoutAIInterviewStatus: AIInterviewStatus = "timeout";
export const PermissionDeniedAIInterviewStatus: AIInterviewStatus = "permission_denied";
export const AudioIssueAIInterviewStatus: AIInterviewStatus = "audio_issue";
export const SystemErrorAIInterviewStatus: AIInterviewStatus = "system_error";
export const UnknownAIInterviewStatus: AIInterviewStatus = "unknown";
export type AIInterviewScheduleMethod = string;
export const GoogleCalendarAIInterviewScheduleMethod: AIInterviewScheduleMethod = "google_calendar";
export const ICSAIInterviewScheduleMethod: AIInterviewScheduleMethod = "ics";
export interface CandidateApplicationData {
    applied?: boolean;
    history: CandidateApplicationDataHistory[];
    step: CandidateApplicationStep;
    rejection_reason?: ApplicationRejectionReason;
    experience_years?: number /* int */;
    english_level?: EnglishLevel;
    requires_english_test?: boolean;
    english_test_score?: number /* float64 */;
    english_test_scores?: number /* float64 */[];
    english_test_audio_id?: number /* int */;
    english_test_transcript_id?: number /* int */;
    english_test_attempts: number /* int */;
    is_manager_or_lead?: boolean;
    skills?: number /* int64 */[];
    async_interview_sent?: boolean;
    async_interview_scheduled?: boolean;
    min_days_to_schedule?: number /* int */;
    ai_interview_id?: string;
    ai_interview_service?: AIInterviewService;
    ai_interview_presented?: boolean;
    ai_interview_scheduled?: boolean;
    ai_interview_schedule_method?: AIInterviewScheduleMethod;
    ai_interview_scheduled_at?: string /* RFC3339 */;
    ai_interview_schedule_date?: string /* RFC3339 */;
    ai_interview_created?: boolean;
    ai_interview_created_at?: string /* RFC3339 */;
    ai_interview_finished?: boolean;
    ai_interview_finished_at?: string /* RFC3339 */;
    ai_interview_failed?: boolean;
    ai_interview_status?: AIInterviewStatus;
    ai_interview_duration?: number /* int */;
    ai_interview_failed_at?: string /* RFC3339 */;
    ai_interview_url?: string;
    ai_interview_testing?: boolean;
    ai_interview_elevenlabs?: boolean;
    videoask_sent?: boolean;
    videoask_scheduled?: boolean;
    meeting_scheduled?: boolean;
    english_lesson_requested?: boolean;
    resume_url?: string;
    technical_evidence_url?: string;
    scheduling_url?: string;
    last_details_sent?: boolean;
    last_details_completed?: boolean;
    /**
     * EnglishUpToPar means the candidate specified they think their english is
     * enough to continue the process, even if the level < B2.
     */
    english_up_to_par?: boolean;
    /**
     * EarlierMeetingRequested means the candidate requested to meet before the
     * scheduled calendar meeting.
     */
    earlier_meeting_requested?: boolean;
    /**
     * Roles list of roles that this candidate specified they think can
     * accomplish. This is a list of ids from the JobOpeningRole table.
     */
    roles?: number /* int */[];
    /**
     * OtherRole in the user doesn't fit in any
     */
    other_role?: string;
    /**
     * EngineeringRoles legacy field to be deleted, replace by Roles
     */
    engineering_roles?: string[];
}
export const MinEnglishTestScore = 72;
export const MaxEnglishTestAttempts = 3;
export type CandidateStatusHistory = CandidateStatusChange[];
/**
 * CandidateStatusChange represents when a candidate has changed to an specific status.
 */
export interface CandidateStatusChange {
    changed_at: string /* RFC3339 */;
    user_id?: number /* int */; // who performed the change
    status: CandidateStatus;
    reason?: string;
    legacy_job?: string; // job opening title for pre-unified remotely openings
}
export interface CandidateLeadData {
    roles?: number /* int */[];
    skills?: number /* int */[];
}
export type TagsMetadata = TagMetadata[];
export interface TagMetadata {
    tag?: number /* int */;
    reason?: string;
    manual?: boolean;
    deleted?: boolean;
}
export const TagsMetadataReasonManualOverwrite = "Manual overwrite";
export type ProfileBuilderStatus = 'success' | 'error' | 'failed';
export const SuccessProfileBuilderStatus: ProfileBuilderStatus = "success";
export const ErrorProfileBuilderStatus: ProfileBuilderStatus = "error";
export const FailedProfileBuilderStatus: ProfileBuilderStatus = "failed";
export type ProfileBuilderCallType = 'profile_builder' | 'vetting';
export const ProfileBuilderCallTypeValue: ProfileBuilderCallType = "profile_builder";
export const VettingCallTypeValue: ProfileBuilderCallType = "vetting";
export interface CandidateProfileBuilder {
    conversation_id?: string;
    roles?: string[];
    last_interaction_id?: number /* int */;
    last_interaction?: string /* RFC3339 */;
    interactions?: number /* int */;
    status?: ProfileBuilderStatus;
}
export type CandidateProfileSection = 'about' | 'work_history';
export const AboutCandidateProfileSection: CandidateProfileSection = "about";
export const WorkHistoryCandidateProfileSection: CandidateProfileSection = "work_history";
export interface CandidateProfileUpdateSection {
    section: CandidateProfileSection;
    comments?: string;
}

//////////
// source: candidate_profile_update_request.go

/**
 * CandidateProfileUpdateRequest represents public.candidate_profile_update_requests
 */
export interface CandidateProfileUpdateRequest {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    candidate_id: number /* int */;
    method: CandidateProfileUpdateMethod;
    sections?: JSONArray<CandidateProfileUpdateSection>;
    calendly_event_uri?: string;
}
export type CandidateProfileUpdateMethod = 'written_details' | 'booked_call';
export const WrittenDetailCandidateProfileUpdateMethod: CandidateProfileUpdateMethod = "written_details";
export const BookedCallCandidateProfileUpdateMethod: CandidateProfileUpdateMethod = "booked_call";

//////////
// source: candidate_prospect.go

/**
 * CandidateProspect represents public.candidate_prospects
 */
export interface CandidateProspect {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    status?: CandidateProspectStatus;
    created_by?: number /* int */;
    job_opening_id: number /* int */;
    candidate_id: number /* int */;
    application_id?: number /* int */;
    stage_id?: number /* int */;
    stage_kind?: JobOpeningStageKind;
    stage_name?: string;
    reviewed?: boolean;
    disqualification_reason?: DisqualificationReason;
    excluded_at?: string /* RFC3339 */;
    excluded_by?: number /* int */;
    score?: CandidateJobScore;
    score_updated_at?: string /* RFC3339 */;
    over_budget?: boolean;
    extra_match?: boolean;
    extra_match_reasons?: JobOpeningExpansions;
    match: boolean;
}
export type CandidateProspectStatus = 'pending' | 'sourced' | 'excluded';
export const PendingCandidateProspectStatus: CandidateProspectStatus = "pending";
export const SourcedCandidateProspectStatus: CandidateProspectStatus = "sourced";
export const ExcludedCandidateProspectStatus: CandidateProspectStatus = "excluded";

//////////
// source: candidate_store.go

export type Experiments = CandidateExperiment[];
export interface CandidateJobMatch {
    UserID: number /* int */;
    FirstName: string;
    LastName: string;
    CandidateID: number /* int */;
    Sourced: boolean;
    Picture: string;
    CurrentSalary: number;
    ExpectedSalary: number;
    Seniority: SeniorityLevel;
}
export interface ApplicationMarkersData {
    Seniority: SeniorityLevel;
    ExpectedSalary: number;
    CurrentSalary: number;
}

//////////
// source: candidate_verification.go

/**
 * CandidateVerification represents public.candidate_verifications
 */
export interface CandidateVerification {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    requested_by?: number /* int */;
    status?: CandidateVerificationStatus;
    inquiry_id?: string;
    started_at?: string /* RFC3339 */;
    completed_at?: string /* RFC3339 */;
    reviewed_at?: string /* RFC3339 */;
    reviewed_by?: number /* int */;
    reason?: string;
    id_matches?: boolean;
    country_matches?: boolean;
    country_not_matched_valid_reason?: boolean;
    candidate_id: number /* int */;
    document_id?: number /* int */;
    legal_name?: string;
    user_id: number /* int */;
    kind: CandidateVerificationKind;
}
export type CandidateVerificationStatus = 'pending' | 'started' | 'completed' | 'failed' | 'expired' | 'approved' | 'declined';
export const PendingCandidateVerificationStatus: CandidateVerificationStatus = "pending";
export const StartedCandidateVerificationStatus: CandidateVerificationStatus = "started";
export const CompletedCandidateVerificationStatus: CandidateVerificationStatus = "completed";
export const FailedCandidateVerificationStatus: CandidateVerificationStatus = "failed";
export const ExpiredCandidateVerificationStatus: CandidateVerificationStatus = "expired";
export const ApprovedCandidateVerificationStatus: CandidateVerificationStatus = "approved";
export const DeclinedCandidateVerificationStatus: CandidateVerificationStatus = "declined";
export type CandidateVerificationKind = 'pipeline' | 'legal_name_change' | 'manual' | 'offer_letter';
export const PipelineCandidateVerificationKind: CandidateVerificationKind = "pipeline";
export const LegalNameChangeCandidateVerificationKind: CandidateVerificationKind = "legal_name_change";
export const ManualCandidateVerificationKind: CandidateVerificationKind = "manual";
export const OfferLetterCandidateVerificationKind: CandidateVerificationKind = "offer_letter";

//////////
// source: candidate_verification_store.go


//////////
// source: client_gen.go


//////////
// source: client_testutils.go


//////////
// source: company.go

/**
 * Company represents public.companies
 */
export interface Company {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    slug: string;
    linkedin_id?: number /* int */;
    name: string;
    tagline?: string;
    description?: string;
    website?: string;
    industry?: string;
    company_type?: string;
    founded_year?: number /* int */;
    size_min?: number /* int */;
    size_max?: number /* int */;
    hq_country?: string;
    hq_country_name?: string;
    hq_city?: string;
    ipo_status?: string;
    last_round_type?: string;
    last_round_date?: string /* RFC3339 */;
    total_funding_usd?: number /* int */;
    specialties?: string[];
    picture_url?: string;
}

//////////
// source: company_store.go


//////////
// source: constants.go

export const RemotelyCustomerID = 4;
export const EdpuzzleCustomerID = 10;
export const RemotelyJobOpeningID = 416;
export const PlatformSyncUserID = 114474;
export const RemotelyInterviewsUserID = 150987;
export const ProfileBuilderUserID = 162318;
export const ProfileImproverUserEmail = "profile-improver@remotely.works";

//////////
// source: contract.go

/**
 * Contract represents public.contracts
 */
export interface Contract {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    customer_id: number /* int */;
    customer_group_id?: number /* int */;
    user_id: number /* int */;
    status?: ContractStatus;
    relation?: ContractRelation;
    role?: string;
    role_kind?: JobOpeningRoleKind;
    description?: string;
    started_at: string /* RFC3339 */;
    terminated_at?: string /* RFC3339 */;
    fee_type?: FeeType;
    resigned?: boolean;
    termination_reason?: ContractTerminationReason;
    manager_id?: number /* int */;
    approval_manager_id?: number /* int */;
    salary: number;
    rate?: number;
    stock_options?: string;
    health_insurance?: HealthInsuranceDetails;
    customer_sourced?: boolean;
    deposit_months?: number /* int */;
    deposit_id?: number /* int */;
    job_opening_id?: number /* int */;
    last_notified_termination_at?: string /* RFC3339 */;
    benefits?: ContractBenefits;
    custom_management_fee?: number;
    management_fee?: number;
    checkins?: ContractCheckIns;
    work_type?: WorkType;
    termination_details?: TerminationDetails;
    deposit?: ContractDepositDetails;
    contracting_entity_id?: number /* int */;
    customer_health?: ContractorCustomerHealth;
    customer_health_reason?: ContractorCustomerHealthReason;
    customer_health_updated_at?: string /* RFC3339 */;
}
export type ContractStatus = 'draft' | 'in_progress' | 'active' | 'terminated' | 'resigned' | 'solicited' | 'canceled';
export const DraftContractStatus: ContractStatus = "draft";
export const InProgressContractStatus: ContractStatus = "in_progress";
export const ActiveContractStatus: ContractStatus = "active";
export const TerminatedContractStatus: ContractStatus = "terminated";
export const ResignedContractStatus: ContractStatus = "resigned";
export const SolicitedContractStatus: ContractStatus = "solicited";
export const CanceledContractStatus: ContractStatus = "canceled";
export type ContractRelation = 'employee' | 'contractor';
export const EmployeeContractRelation: ContractRelation = "employee";
export const ContractorContractRelation: ContractRelation = "contractor";
export type FeeType = 'fixed' | 'pay_as_you_go';
export const FixedFeeType: FeeType = "fixed";
export const PayAsYouGoFeeType: FeeType = "pay_as_you_go";
export type ContractTerminationReason = 'acquisition' | 'performance' | 'shutdown' | 'management' | 'restructuring' | 'provisional' | 'recruited' | 'unmotivated' | 'cancelled' | 'personal' | 'solicited';
export const AcquisitionContractTerminationReason: ContractTerminationReason = "acquisition";
export const PerformanceContractTerminationReason: ContractTerminationReason = "performance";
export const ShutdownContractTerminationReason: ContractTerminationReason = "shutdown";
export const ManagementContractTerminationReason: ContractTerminationReason = "management";
export const RestructuringContractTerminationReason: ContractTerminationReason = "restructuring";
export const ProvisionalContractTerminationReason: ContractTerminationReason = "provisional";
export const RecruitedContractTerminationReason: ContractTerminationReason = "recruited";
export const UnmotivatedContractTerminationReason: ContractTerminationReason = "unmotivated";
export const CancelledContractTerminationReason: ContractTerminationReason = "cancelled";
export const PersonalContractTerminationReason: ContractTerminationReason = "personal";
export const SolicitedContractTerminationReason: ContractTerminationReason = "solicited";
export type WorkType = 'full_time' | 'part_time' | 'project_based';
export const FullTimeWorkType: WorkType = "full_time";
export const PartTimeWorkType: WorkType = "part_time";
export const ProjectBasedWorkType: WorkType = "project_based";
export type ContractorCustomerHealth = 'strong' | 'monitor' | 'at_risk' | 'healthy' | 'critical' | 'exit';
export const StrongContractorCustomerHealth: ContractorCustomerHealth = "strong";
export const MonitorContractorCustomerHealth: ContractorCustomerHealth = "monitor";
export const AtRiskContractorCustomerHealth: ContractorCustomerHealth = "at_risk";
export const HealthyContractorCustomerHealth: ContractorCustomerHealth = "healthy";
export const CriticalContractorCustomerHealth: ContractorCustomerHealth = "critical";
export const ExitContractorCustomerHealth: ContractorCustomerHealth = "exit";
export type ContractorCustomerHealthReason = 'customer_feedback' | 'conflicting_feedback' | 'feedback_outdated' | 'other';
export const CustomerFeedbackContractorCustomerHealthReason: ContractorCustomerHealthReason = "customer_feedback";
export const ConflictingFeedbackContractorCustomerHealthReason: ContractorCustomerHealthReason = "conflicting_feedback";
export const FeedbackOutdatedContractorCustomerHealthReason: ContractorCustomerHealthReason = "feedback_outdated";
export const OtherContractorCustomerHealthReason: ContractorCustomerHealthReason = "other";

//////////
// source: contract_health_insurance.go

/**
 * ContractHealthInsurance represents public.contract_health_insurances
 */
export interface ContractHealthInsurance {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    contract_id: number /* int */;
    status?: ContractHealthInsuranceStatus;
    start_date?: string /* RFC3339 */;
    expiry_date?: string /* RFC3339 */;
    annual_cost?: number;
    monthly_cost?: number;
    expiration_days: number /* int */;
    member_id?: number /* int */;
    plan_id?: number /* int */;
    standard_plan_cost?: number;
    contractor_cost?: number;
    policy_id?: string;
    member_status?: InsuranceMemberStatus;
    dependants?: JSONArray<InsuranceDependant>;
    costs?: JSONArray<InsuranceCost>;
    start_age?: number /* int */;
    group_id?: number /* int */;
    current: boolean;
    reenrollment?: boolean;
}
export type ContractHealthInsuranceStatus = 'draft' | 'accepted' | 'rejected' | 'updated_info' | 'expired' | 'pending' | 'active' | 'canceled';
export const DraftContractHealthInsuranceStatus: ContractHealthInsuranceStatus = "draft";
export const AcceptedContractHealthInsuranceStatus: ContractHealthInsuranceStatus = "accepted";
export const RejectedContractHealthInsuranceStatus: ContractHealthInsuranceStatus = "rejected";
export const UpdatedInfoContractHealthInsuranceStatus: ContractHealthInsuranceStatus = "updated_info";
export const ExpiredContractHealthInsuranceStatus: ContractHealthInsuranceStatus = "expired";
export const PendingContractHealthInsuranceStatus: ContractHealthInsuranceStatus = "pending";
export const ActiveContractHealthInsuranceStatus: ContractHealthInsuranceStatus = "active";
export const CanceledContractHealthInsuranceStatus: ContractHealthInsuranceStatus = "canceled";

//////////
// source: contract_health_insurance_store.go

export const DefaultContractInsuranceExpirationDays = 30;
export interface InsuranceChange {
    annual_cost?: number;
    monthly_cost?: number;
    contractor_cost?: number;
    standard_plan_cost?: number;
    date: string /* RFC3339 */;
    plan_id?: number /* int */;
    member_status?: InsuranceMemberStatus;
    start_date?: string /* RFC3339 */;
    expiry_date?: string /* RFC3339 */;
    dependants?: number /* int */;
}
export interface InsuranceDependant {
    safetywing_id: number /* int */;
    email: string;
    firstName: string;
    lastName: string;
    birthdate: string;
    citizenship: string;
    residency: string;
    gender: string;
    occupation: string;
    relationship: string;
    status: InsuranceMemberStatus;
}
export interface InsuranceCost {
    id: number /* int */;
    cost: number;
    start: string /* RFC3339 */;
    end: string /* RFC3339 */;
    dependant: boolean;
    description: string;
}
export type InsuranceMemberStatus = string;
export const InvitedInsuranceMemberStatus: InsuranceMemberStatus = "INVITED";
export const ProcessingInsuranceMemberStatus: InsuranceMemberStatus = "PROCESSING";
export const ActiveInsuranceMemberStatus: InsuranceMemberStatus = "ACTIVE";
export const CancelledInsuranceMemberStatus: InsuranceMemberStatus = "CANCELLED";
export const CancellingInsuranceMemberStatus: InsuranceMemberStatus = "CANCELLING";
export const ExpiredInsuranceMemberStatus: InsuranceMemberStatus = "EXPIRED";
export const OnboardingInsuranceMemberStatus: InsuranceMemberStatus = "ONBOARDING";
export const OtherInsuranceMemberStatus: InsuranceMemberStatus = "OTHER";

//////////
// source: contract_pto.go

/**
 * ContractPTO represents public.contract_ptos
 */
export interface ContractPTO {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    contract_id: number /* int */;
    customer_id: number /* int */;
    policy_id: number /* int */;
    approved_days?: number /* float64 */;
    adjusted_days?: PTOAdjustedDays;
    carryover_days?: PTOCarryoverDays;
}

//////////
// source: contract_pto_store.go

export type PTOAdjustedDays = Partial<Record<number /* int */, number /* int */>>;
export type PTOCarryoverDays = Partial<Record<number /* int */, PTOCarryoverYear>>;
export interface PTOCarryoverYear {
    days: number /* float64 */;
    approved: number /* float64 */;
}

//////////
// source: contract_store.go

export interface ContractDepositDetails {
    total_held: number;
    termination_payment: number;
}
export type CheckInDays = number /* int */;
export type ContractCheckIns = Partial<Record<CheckInDays, string /* RFC3339 */>>;
export type HealthInsuranceProvider = string;
export const NoneHealthInsuranceProvider: HealthInsuranceProvider = "none";
export const RemotelyHealthInsuranceProvider: HealthInsuranceProvider = "remotely";
export const CustomerHealthInsuranceProvider: HealthInsuranceProvider = "customer";
export type ContractHealthInsuranceType = string;
export const NoneContractHealthInsuranceType: ContractHealthInsuranceType = "none";
export const StipendContractHealthInsuranceType: ContractHealthInsuranceType = "stipend";
export const SafetyWingContractHealthInsuranceType: ContractHealthInsuranceType = "safetywing";
export interface ContractBenefits {
    insurance_provider: HealthInsuranceProvider;
    severance: boolean;
    pto: boolean;
    on_call: boolean;
    equipment: boolean;
}
export interface TerminationDetails {
    termination_fee?: number;
    unused_pto_days?: number;
}
export interface HealthInsuranceDetails {
    /**
     * Type of health insurance provided for this contract.
     */
    type?: ContractHealthInsuranceType;
    /**
     * Cost of the health insurance per month. This is used for stipend
     * and only for ease of use for SafetyWing.
     */
    cost?: number;
    /**
     * This field is only for the transition from Stipend -> SafetyWing
     * It holds the old stipend cost that might need to be applied in
     * a billing cycle before the SafetyWing plan comes into effect.
     */
    old_cost?: number;
    /**
     * CanChoose specifies whether the contractor can choose between
     * stipend and SafetyWing.
     */
    can_choose?: boolean;
    /**
     * ChoiceRequestedAt is when the contractor was asked to choose.
     */
    choice_requested_at?: string /* RFC3339 */;
    /**
     * CanChooseUntil is the deadline for choosing one or the other.
     */
    can_choose_until?: string /* RFC3339 */;
    /**
     * EnrollLater specifies whether the contractor intends to enroll in
     * SafetyWing later, even after choosing to stay in stipend.
     */
    enroll_later?: boolean;
    /**
     * CurrentPlanEnd is when the current plan the contractor has will end.
     */
    current_plan_end?: string /* RFC3339 */;
    /**
     * EarliestInsuranceStart is the minimum date for starting the insurance
     * policy. This is only used for SafetyWing policies.
     */
    earliest_insurance_start?: string /* RFC3339 */;
}
export interface ContractorAnniversary {
    id: number /* int */;
    first_name: string;
    last_name: string;
    anniversary: string /* RFC3339 */;
    years: number /* int */;
    picture: null /* sql.NullString */;
}
export interface ContractorContract {
    ID: number /* int */;
    ContractID: number /* int */;
    FirstName: string;
    LastName: string;
    Role: string;
    CustomerID: number /* int */;
    Company: string;
    Email: string;
    Picture: string;
    StartedAt: string /* RFC3339 */;
    TerminatedAt: null /* sql.NullTime */;
    Salary: number;
    Status: ContractStatus;
    HealthInsurance: number;
    CustomerSourced: boolean;
}
export interface CustomerContractor {
    ID: number /* int */;
    ContractID: number /* int */;
    CustomerID: number /* int */;
    CustomerGroupID?: number /* int */;
    Company: string;
    FirstName: string;
    LastName: string;
    Email: string;
    Picture: string;
    Role: string;
    Status: ContractStatus;
    StartedAt: null /* sql.NullTime */;
    TerminatedAt: null /* sql.NullTime */;
    TerminationReason?: ContractTerminationReason;
    Salary: number;
    HealthInsurance: number;
    ManagementFee?: number;
    CustomerSourced: boolean;
    ManagerID?: number /* int */;
    PersonalInfo?: PersonalInfo;
    ContractorHealth?: ContractorCustomerHealth;
    ContractorHealthReason?: ContractorCustomerHealthReason;
    ContractorHealthScore?: number /* int */;
    Seniority?: SeniorityLevel;
}
export interface Contractor {
    CreatedAt: string /* RFC3339 */;
    id: number /* int */;
    first_name: string;
    last_name: string;
    email: string;
    email_normalized: string;
    picture: string;
    country?: string;
    contract_id: number /* int */;
    status: ContractStatus;
    role: string;
    relation: ContractRelation;
    contractor_health?: ContractorCustomerHealth;
    contractor_health_reason?: ContractorCustomerHealthReason;
    contractor_health_score?: number /* int */;
    started_at?: string /* RFC3339 */;
    terminated_at?: string /* RFC3339 */;
    termination_reason?: ContractTerminationReason;
    salary: number;
    health_insurance_cost?: number;
    customer_id: number /* int */;
    company_name: string;
    customer_sourced: boolean;
    manager_id?: number /* int */;
    manager_first_name: string;
    manager_last_name: string;
    manager_email: string;
    open_to_opportunities: boolean;
    fee_type: FeeType;
    work_type?: WorkType;
    management_fee?: number;
    rate?: number;
    source: CandidateSource;
    roles: number[];
    stack: number[];
    verification_status?: CandidateVerificationStatus;
    personal_info?: PersonalInfo;
    tags: number[];
    user_id: number /* int */;
}
export interface ContractDepositsStats {
    total_held: number;
    total_termination_payment: number;
    total_unfunded_liability: number;
}

//////////
// source: contracting_entity.go

/**
 * ContractingEntity represents public.contracting_entities
 */
export interface ContractingEntity {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    name: string;
    type: ContractingEntityType;
    business_structure?: ContractingEntityStructure;
    tax_id?: string;
    address?: LegalAddress;
    phone?: string;
    user_id: number /* int */;
    status?: ContractingEntityStatus;
    locked?: boolean;
    business_structure_other?: string;
    title?: string;
}
export type ContractingEntityType = 'individual' | 'business';
export const IndividualContractingEntityType: ContractingEntityType = "individual";
export const BusinessContractingEntityType: ContractingEntityType = "business";
export type ContractingEntityStructure = 'ltd' | 'simplified_joint_stock_company' | 'llc' | 'corporation' | 'other' | 'joint_stock_company';
export const LtdContractingEntityStructure: ContractingEntityStructure = "ltd";
export const SimplifiedJointStockCompanyContractingEntityStructure: ContractingEntityStructure = "simplified_joint_stock_company";
export const LlcContractingEntityStructure: ContractingEntityStructure = "llc";
export const CorporationContractingEntityStructure: ContractingEntityStructure = "corporation";
export const OtherContractingEntityStructure: ContractingEntityStructure = "other";
export const JointStockCompanyContractingEntityStructure: ContractingEntityStructure = "joint_stock_company";
export type ContractingEntityStatus = 'available' | 'retired' | 'pending';
export const AvailableContractingEntityStatus: ContractingEntityStatus = "available";
export const RetiredContractingEntityStatus: ContractingEntityStatus = "retired";
export const PendingContractingEntityStatus: ContractingEntityStatus = "pending";

//////////
// source: contracting_entity_selection.go

/**
 * ContractingEntitySelection represents public.contracting_entity_selections
 */
export interface ContractingEntitySelection {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    user_id: number /* int */;
    requested_by: number /* int */;
    selected_entity_id?: number /* int */;
    offer_letter_id?: number /* int */;
}

//////////
// source: contracting_entity_store.go


//////////
// source: contractor_checkin.go

/**
 * ContractorCheckin represents public.contractor_checkins
 */
export interface ContractorCheckin {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    status?: ContractorCheckinStatus;
    contractor_id: number /* int */;
    contract_id: number /* int */;
    customer_id: number /* int */;
    manager_id?: number /* int */;
    days: number /* int */;
    response_type?: ContractorCheckinResponseType;
    score?: number /* int */;
    quote?: string;
    completed_at?: string /* RFC3339 */;
    document_id?: number /* int */;
    campaign: ContractorCheckinCampaign;
    meeting_scheduled_at?: string /* RFC3339 */;
    meeting_completed_at?: string /* RFC3339 */;
    url?: string;
    summary?: string;
    transcript?: string;
    form_data?: ContractorCheckinFormData;
    summary_status?: ContractorCheckinSummaryStatus;
    summary_failure_reason?: ContractorCheckinSummaryFailureReason;
    summary_prompt_version?: string;
    summary_model?: string;
    summarized_at?: string /* RFC3339 */;
    meeting_ical_uid?: string;
}
export type ContractorCheckinStatus = 'pending' | 'scheduled' | 'completed' | 'expired';
export const PendingContractorCheckinStatus: ContractorCheckinStatus = "pending";
export const ScheduledContractorCheckinStatus: ContractorCheckinStatus = "scheduled";
export const CompletedContractorCheckinStatus: ContractorCheckinStatus = "completed";
export const ExpiredContractorCheckinStatus: ContractorCheckinStatus = "expired";
export type ContractorCheckinResponseType = 'videoask' | 'meeting' | 'pdf';
export const VideoaskContractorCheckinResponseType: ContractorCheckinResponseType = "videoask";
export const MeetingContractorCheckinResponseType: ContractorCheckinResponseType = "meeting";
export const PdfContractorCheckinResponseType: ContractorCheckinResponseType = "pdf";
export type ContractorCheckinCampaign = 'd30' | 'd60' | 'd90' | 'd180' | 'd270' | 'quarterly';
export const D30ContractorCheckinCampaign: ContractorCheckinCampaign = "d30";
export const D60ContractorCheckinCampaign: ContractorCheckinCampaign = "d60";
export const D90ContractorCheckinCampaign: ContractorCheckinCampaign = "d90";
export const D180ContractorCheckinCampaign: ContractorCheckinCampaign = "d180";
export const D270ContractorCheckinCampaign: ContractorCheckinCampaign = "d270";
export const QuarterlyContractorCheckinCampaign: ContractorCheckinCampaign = "quarterly";
export type ContractorCheckinSummaryStatus = 'pending' | 'generating' | 'succeeded' | 'failed';
export const PendingContractorCheckinSummaryStatus: ContractorCheckinSummaryStatus = "pending";
export const GeneratingContractorCheckinSummaryStatus: ContractorCheckinSummaryStatus = "generating";
export const SucceededContractorCheckinSummaryStatus: ContractorCheckinSummaryStatus = "succeeded";
export const FailedContractorCheckinSummaryStatus: ContractorCheckinSummaryStatus = "failed";
export type ContractorCheckinSummaryFailureReason = 'unusable_input' | 'too_short' | 'timeout';
export const UnusableInputContractorCheckinSummaryFailureReason: ContractorCheckinSummaryFailureReason = "unusable_input";
export const TooShortContractorCheckinSummaryFailureReason: ContractorCheckinSummaryFailureReason = "too_short";
export const TimeoutContractorCheckinSummaryFailureReason: ContractorCheckinSummaryFailureReason = "timeout";

//////////
// source: contractor_checkin_store.go

export const ContractorCheckinAISummaryFallback = "Could not generate AI summary.";
/**
 * quarterlyStartDays is the first day-offset at which the recurring
 * quarterly campaign fires (every 90 days thereafter while the contract
 * is active).
 */
export interface ContractorCheckinFormData {
    answers: ContractorCheckinFormAnswer[];
    url: string;
    form_id: string;
    response_id: string;
    Metadata: {
        company: string;
        contractor_email: string;
        contractor_id: string;
        contractor_name: string;
        manager_id: string;
        campaign: string;
        source: string;
    };
}
export interface ContractorCheckinFormAnswer {
    question: string;
    value: any;
}

//////////
// source: contractor_invoice.go

/**
 * ContractorInvoice represents public.contractor_invoices
 */
export interface ContractorInvoice {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    user_id: number /* int */;
    status?: ContractorInvoiceStatus;
    last_status_change_at?: string /* RFC3339 */;
    month: number /* int */;
    year: number /* int */;
    number: string;
    issued_at?: string /* RFC3339 */;
    issued_by?: string;
    billed_to?: string;
    paid_at?: string /* RFC3339 */;
    document_id?: number /* int */;
    account_id?: number /* int */;
    amount: number;
    currency?: string;
    transfer_type?: BankAccountMethod;
    wire_id?: string;
    payment_service?: string;
    error_description?: string;
    contract_id?: number /* int */;
    customer_id?: number /* int */;
}
export type ContractorInvoiceStatus = 'draft' | 'error' | 'approved' | 'issued' | 'payment_scheduled' | 'paid' | 'pending';
export const DraftContractorInvoiceStatus: ContractorInvoiceStatus = "draft";
export const ErrorContractorInvoiceStatus: ContractorInvoiceStatus = "error";
export const ApprovedContractorInvoiceStatus: ContractorInvoiceStatus = "approved";
export const IssuedContractorInvoiceStatus: ContractorInvoiceStatus = "issued";
export const PaymentScheduledContractorInvoiceStatus: ContractorInvoiceStatus = "payment_scheduled";
export const PaidContractorInvoiceStatus: ContractorInvoiceStatus = "paid";
export const PendingContractorInvoiceStatus: ContractorInvoiceStatus = "pending";

//////////
// source: contractor_invoice_setting.go

/**
 * ContractorInvoiceSetting represents public.contractor_invoice_settings
 */
export interface ContractorInvoiceSetting {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    user_id: number /* int */;
    number_type?: ContractorInvoiceNumberType;
    number_prefix?: string;
    number_suffix?: string;
    number_seed?: number /* int */;
    number_digits?: number /* int */;
    auto_approve?: boolean;
    consolidated?: boolean;
    issue_date?: InvoiceIssueDateType;
}
export type ContractorInvoiceNumberType = 'date' | 'number' | 'manual';
export const DateContractorInvoiceNumberType: ContractorInvoiceNumberType = "date";
export const NumberContractorInvoiceNumberType: ContractorInvoiceNumberType = "number";
export const ManualContractorInvoiceNumberType: ContractorInvoiceNumberType = "manual";
export type InvoiceIssueDateType = 'last_of_month' | 'first_of_next_month';
export const LastOfMonthInvoiceIssueDateType: InvoiceIssueDateType = "last_of_month";
export const FirstOfNextMonthInvoiceIssueDateType: InvoiceIssueDateType = "first_of_next_month";

//////////
// source: contractor_invoice_store.go

export interface ContractorInvoiceDetails {
    id: number /* int */;
    user_id: number /* int */;
    contract_id?: number /* int */;
    status: ContractorInvoiceStatus;
    month: number /* int */;
    year: number /* int */;
    amount: number;
    transfer_type?: BankAccountMethod;
    account_id?: number /* int */;
    customer_id?: number /* int */;
    contractor_first_name: string;
    contractor_last_name: string;
    customer_name?: string;
    url?: string;
}

//////////
// source: country_change_request.go

/**
 * CountryChangeRequest represents public.country_change_requests
 */
export interface CountryChangeRequest {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    user_id: number /* int */;
    contracting_entity_id: number /* int */;
    address?: LegalAddress;
    status?: CountryChangeRequestStatus;
}
export type CountryChangeRequestStatus = 'pending' | 'approved' | 'rejected';
export const PendingCountryChangeRequestStatus: CountryChangeRequestStatus = "pending";
export const ApprovedCountryChangeRequestStatus: CountryChangeRequestStatus = "approved";
export const RejectedCountryChangeRequestStatus: CountryChangeRequestStatus = "rejected";

//////////
// source: credential.go

/**
 * Credential represents public.credentials
 */
export interface Credential {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    kind: CredentialKind;
    status?: CredentialStatus;
    user_id: number /* int */;
    services: CredentialServices;
    credential: string;
    metadata?: CredentialsMetadata;
}
export type CredentialKind = 'oauth2';
export const Oauth2CredentialKind: CredentialKind = "oauth2";
export type CredentialStatus = 'valid' | 'expired';
export const ValidCredentialStatus: CredentialStatus = "valid";
export const ExpiredCredentialStatus: CredentialStatus = "expired";
export type CredentialService = 'gmail' | 'google_calendar';
export const GmailCredentialService: CredentialService = "gmail";
export const GoogleCalendarCredentialService: CredentialService = "google_calendar";

//////////
// source: credential_store.go

export type CredentialServices = CredentialService[];
export type CredentialsMetadata = Partial<Record<string, CredentialsMetadataInfo>>;
export interface CredentialsMetadataInfo {
    last_usage?: string /* RFC3339 */;
    last_update?: string /* RFC3339 */;
}

//////////
// source: csp_report.go

/**
 * CspReport represents public.csp_reports
 */
export interface CspReport {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    url: string;
    report?: string;
}

//////////
// source: customer.go

/**
 * Customer represents public.customers
 */
export interface Customer {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    company_name: string;
    permalink: string;
    legal_name: string;
    status?: CustomerStatus;
    signed_at?: string /* RFC3339 */;
    recruiting_only?: boolean;
    recruiting_fee_always?: boolean;
    auto_payment?: boolean;
    address?: LegalAddress;
    ein?: string;
    contact_id?: number /* int */;
    billing_contacts_ids: number[];
    offer_letter_contacts_ids: number[];
    approval_manager_id?: number /* int */;
    payment_reminder_disabled?: boolean;
    invoice_view?: CustomerInvoiceView;
    order_form_id?: number /* int */;
    slack_channel_id?: string;
    landing_page_url?: string;
    linkedin_url?: string;
    url?: string;
    domains?: Strings;
    employees?: EmployeesRange;
    engineers?: number /* int */;
    recruiting?: boolean;
    public?: boolean;
    description?: string;
    selling_pitch?: string;
    engineering_architecture?: string;
    product_demo?: string;
    logo?: string;
    header?: string;
    market?: Market;
    tags: number[];
    sectors: number[];
    investors: number[];
    time_zone?: string;
    hq?: string;
    funding?: number /* int */;
    benefits?: Benefits;
    policies?: CustomerPolicies;
    stage?: CompanyStage;
    stage_at_signing?: CompanyStage;
    hubspot_id?: string;
    terms_accepted?: boolean;
    mercury_id?: string;
    last_updated_by?: number /* int */;
    deposit_months?: number /* int */;
    company_owner_id?: number /* int */;
    safetywing_group_id?: number /* int */;
    talent_preferences?: string;
}
export type CustomerStatus = 'prospect' | 'not_working_not_hiring' | 'not_working_hiring' | 'working_hiring' | 'working_not_hiring' | 'recruiting_only_hiring' | 'recruiting_only_not_hiring' | 'churned' | 'closed_lost';
export const ProspectCustomerStatus: CustomerStatus = "prospect";
export const NotWorkingNotHiringCustomerStatus: CustomerStatus = "not_working_not_hiring";
export const NotWorkingHiringCustomerStatus: CustomerStatus = "not_working_hiring";
export const WorkingHiringCustomerStatus: CustomerStatus = "working_hiring";
export const WorkingNotHiringCustomerStatus: CustomerStatus = "working_not_hiring";
export const RecruitingOnlyHiringCustomerStatus: CustomerStatus = "recruiting_only_hiring";
export const RecruitingOnlyNotHiringCustomerStatus: CustomerStatus = "recruiting_only_not_hiring";
export const ChurnedCustomerStatus: CustomerStatus = "churned";
export const ClosedLostCustomerStatus: CustomerStatus = "closed_lost";
export type CustomerInvoiceView = 'default' | 'grouped';
export const DefaultCustomerInvoiceView: CustomerInvoiceView = "default";
export const GroupedCustomerInvoiceView: CustomerInvoiceView = "grouped";
export type Market = 'crypto' | 'consumer' | 'enterprise' | 'small_and_midsize';
export const CryptoMarket: Market = "crypto";
export const ConsumerMarket: Market = "consumer";
export const EnterpriseMarket: Market = "enterprise";
export const SmallAndMidsizeMarket: Market = "small_and_midsize";
export type CompanyStage = 'agency' | 'early' | 'growth' | 'mature' | 'pe_backed' | 'post_ipo';
export const AgencyCompanyStage: CompanyStage = "agency";
export const EarlyCompanyStage: CompanyStage = "early";
export const GrowthCompanyStage: CompanyStage = "growth";
export const MatureCompanyStage: CompanyStage = "mature";
export const PeBackedCompanyStage: CompanyStage = "pe_backed";
export const PostIpoCompanyStage: CompanyStage = "post_ipo";

//////////
// source: customer_checkin.go

/**
 * CustomerCheckin represents public.customer_checkins
 */
export interface CustomerCheckin {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    status?: CustomerCheckinStatus;
    manager_id: number /* int */;
    contractor_id: number /* int */;
    contract_id: number /* int */;
    customer_id: number /* int */;
    days: number /* int */;
    response_type?: CustomerCheckinResponseType;
    completed_at?: string /* RFC3339 */;
    document_id?: number /* int */;
    form_data?: CustomerCheckinFormData;
    score?: number /* int */;
    campaign_type?: CustomerCheckinCampaignType;
    completed_by?: number /* int */;
    comments?: string;
    recording_url?: string;
    campaign: CustomerCheckinCampaign;
}
export type CustomerCheckinStatus = 'pending' | 'completed' | 'expired' | 'cancelled';
export const PendingCustomerCheckinStatus: CustomerCheckinStatus = "pending";
export const CompletedCustomerCheckinStatus: CustomerCheckinStatus = "completed";
export const ExpiredCustomerCheckinStatus: CustomerCheckinStatus = "expired";
export const CancelledCustomerCheckinStatus: CustomerCheckinStatus = "cancelled";
export type CustomerCheckinResponseType = 'typeform' | 'document' | 'call' | 'note' | 'meeting';
export const TypeformCustomerCheckinResponseType: CustomerCheckinResponseType = "typeform";
export const DocumentCustomerCheckinResponseType: CustomerCheckinResponseType = "document";
export const CallCustomerCheckinResponseType: CustomerCheckinResponseType = "call";
export const NoteCustomerCheckinResponseType: CustomerCheckinResponseType = "note";
export const MeetingCustomerCheckinResponseType: CustomerCheckinResponseType = "meeting";
export type CustomerCheckinCampaignType = 'milestone' | 'biannual' | 'quarterly';
export const MilestoneCustomerCheckinCampaignType: CustomerCheckinCampaignType = "milestone";
export const BiannualCustomerCheckinCampaignType: CustomerCheckinCampaignType = "biannual";
export const QuarterlyCustomerCheckinCampaignType: CustomerCheckinCampaignType = "quarterly";
export type CustomerCheckinCampaign = 'd30' | 'd60' | 'd90' | 'd180' | 'd270' | 'biannual' | 'quarterly';
export const D30CustomerCheckinCampaign: CustomerCheckinCampaign = "d30";
export const D60CustomerCheckinCampaign: CustomerCheckinCampaign = "d60";
export const D90CustomerCheckinCampaign: CustomerCheckinCampaign = "d90";
export const D180CustomerCheckinCampaign: CustomerCheckinCampaign = "d180";
export const D270CustomerCheckinCampaign: CustomerCheckinCampaign = "d270";
export const BiannualCustomerCheckinCampaign: CustomerCheckinCampaign = "biannual";
export const QuarterlyCustomerCheckinCampaign: CustomerCheckinCampaign = "quarterly";

//////////
// source: customer_checkin_store.go

export interface CustomerCheckinFormData {
    answers: CustomerCheckinFormAnswer[];
    url: string;
    form_id: string;
    response_id: string;
    Metadata: {
        company: string;
        contractor_email: string;
        contractor_id: string;
        contractor_name: string;
        env: string;
        hiring_manager_email: string;
        hiring_manager_name: string;
        manager_id: string;
        source: string;
    };
}
export interface CustomerCheckinFormAnswer {
    question: string;
    type?: string;
    value: any;
}

//////////
// source: customer_group.go

/**
 * CustomerGroup represents public.customer_groups
 */
export interface CustomerGroup {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    customer_id: number /* int */;
    name: string;
    notes?: string;
    approval_type?: CustomerGroupApprovalType;
    approval_id?: number /* int */;
    created_by?: number /* int */;
}
export type CustomerGroupApprovalType = 'company' | 'custom';
export const CompanyCustomerGroupApprovalType: CustomerGroupApprovalType = "company";
export const CustomCustomerGroupApprovalType: CustomerGroupApprovalType = "custom";

//////////
// source: customer_group_store.go

export const CustomerGroupDefaultName = "Unassigned";
export const CustomerGroupCompanyLevelFallbackName = "Company Level Approver";

//////////
// source: customer_invoice.go

/**
 * CustomerInvoice represents public.customer_invoices
 */
export interface CustomerInvoice {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    reviewed_at?: string /* RFC3339 */;
    issued_by?: string;
    billed_to?: string;
    issued_at?: string /* RFC3339 */;
    paid_at?: string /* RFC3339 */;
    sent_at?: string /* RFC3339 */;
    status: CustomerInvoiceStatus;
    customer_id: number /* int */;
    document_id?: number /* int */;
    comments?: string;
    year: number /* int */;
    month: number /* int */;
    year_invoice_number: number /* int */;
    number: string;
    amount: number;
    currency?: string;
    due_date?: string /* RFC3339 */;
    transaction_id?: string;
    remarks: string[];
}
export type CustomerInvoiceStatus = 'draft' | 'reviewed' | 'issued' | 'sent' | 'payment_scheduled' | 'review_payment' | 'paid' | 'written_off';
export const DraftCustomerInvoiceStatus: CustomerInvoiceStatus = "draft";
export const ReviewedCustomerInvoiceStatus: CustomerInvoiceStatus = "reviewed";
export const IssuedCustomerInvoiceStatus: CustomerInvoiceStatus = "issued";
export const SentCustomerInvoiceStatus: CustomerInvoiceStatus = "sent";
export const PaymentScheduledCustomerInvoiceStatus: CustomerInvoiceStatus = "payment_scheduled";
export const ReviewPaymentCustomerInvoiceStatus: CustomerInvoiceStatus = "review_payment";
export const PaidCustomerInvoiceStatus: CustomerInvoiceStatus = "paid";
export const WrittenOffCustomerInvoiceStatus: CustomerInvoiceStatus = "written_off";

//////////
// source: customer_invoice_store.go


//////////
// source: customer_store.go

export type CustomerStageHistory = CustomerStageChange[];
/**
 * CandidateStatusChange represents when a candidate has changed to an specific status.
 */
export interface CustomerStageChange {
    changed_at: string /* RFC3339 */;
    status: CompanyStage;
}
export const AgencyCompanyStageName: string = "agency stage";
export const EarlyCompanyStageName: string = "early-stage";
export const GrowthCompanyStageName: string = "growth stage";
export const MatureCompanyStageName: string = "mature stage";
export const PeBackedCompanyStageName: string = "PE-backed stage";
export const PostIpoCompanyStageName: string = "post-IPO stage";
export type EmployeesRange = string;
export const EmployeeRange1to10: EmployeesRange = "1-10";
export const EmployeeRange11to50: EmployeesRange = "11-50";
export const EmployeeRange51to100: EmployeesRange = "51-100";
export const EmployeeRange101to250: EmployeesRange = "101-250";
export const EmployeeRange251to500: EmployeesRange = "251-500";
export const EmployeeRange501to1000: EmployeesRange = "501-1000";
export const EmployeeRange1001to5000: EmployeesRange = "1001-5000";
export const EmployeeRange5001to10000: EmployeesRange = "5001-10000";
export const EmployeeRange10001Plus: EmployeesRange = "10001+";
export type EquipmentOption = 'not_provided' | 'provided';
export const NotProvidedEquipmentOption: EquipmentOption = "not_provided";
export const ProvidedEquipmentOption: EquipmentOption = "provided";
export type Stocks = 'negotiable' | 'yes' | 'not_offered';
export const NegotiableStocks: Stocks = "negotiable";
export const OfferedStocks: Stocks = "yes";
export const NotOfferedStocks: Stocks = "not_offered";
export type HealthInsurance = 'not_offered' | 'provided_by_customer' | 'provided_by_remotely';
export const ProvidedByCustomerHealthInsurance: HealthInsurance = "provided_by_customer";
export const ProvidedByRemotelyHealthInsurance: HealthInsurance = "provided_by_remotely";
export const NotOfferedHealthInsurance: HealthInsurance = "not_offered";
export type OnCallOption = 'always_required' | 'never_required' | 'role_specific';
export const AlwaysRequiredOnCall: OnCallOption = "always_required";
export const NeverRequiredOnCall: OnCallOption = "never_required";
export const RoleSpecificOnCall: OnCallOption = "role_specific";
export type LaptopSpecifications = EquipmentQuoteRequirements;
export interface Benefits {
    stocks: Stocks;
    equipment: EquipmentOption;
    health_insurance: HealthInsurance;
    laptop_specifications?: LaptopSpecifications;
    other_benefits?: string;
    grandfathered_customer: boolean;
}
export interface CustomerPolicies {
    timezone_overlap?: TimezoneOverlap;
    offer_special_clause?: string;
    background_check?: boolean;
    offer_letter_expiration_days?: number /* int */;
    on_call?: OnCallOption;
}
export interface CustomerContractorStats {
    ID: number /* int */;
    Name: string;
    Status: CustomerStatus;
    SignedAt: null /* sql.NullTime */;
    TotalContractors: number /* int */;
    TotalHealthInsurance: number;
    TotalSalaries: number;
}

//////////
// source: disqualification_reason.go

export type DisqualificationReason = string;
/**
 * NOTICE: The following DisqualificationReason must be also added into ClientReasons
 */
export const ClientCulturalFitDisqualificationReason: DisqualificationReason = "C-Cultural Fit";
/**
 * NOTICE: The following DisqualificationReason must be also added into ClientReasons
 */
export const ClientDroppedOutDisqualificationReason: DisqualificationReason = "C-Dropped out";
/**
 * NOTICE: The following DisqualificationReason must be also added into ClientReasons
 */
export const ClientEnglishSkillsDisqualificationReason: DisqualificationReason = "C-English Skills";
/**
 * NOTICE: The following DisqualificationReason must be also added into ClientReasons
 */
export const ClientFailedTechnicalTestDisqualificationReason: DisqualificationReason = "C-Failed Technical Test";
/**
 * NOTICE: The following DisqualificationReason must be also added into ClientReasons
 */
export const ClientOfferSomeoneElseNotOursDisqualificationReason: DisqualificationReason = "C-Offer Made to Someone Else (Not Ours)";
/**
 * NOTICE: The following DisqualificationReason must be also added into ClientReasons
 */
export const ClientOfferSomeoneElseOursDisqualificationReason: DisqualificationReason = "C-Offer Made to Someone Else (Ours)";
/**
 * NOTICE: The following DisqualificationReason must be also added into ClientReasons
 */
export const ClientOtherDisqualificationReason: DisqualificationReason = "C-Other";
/**
 * NOTICE: The following DisqualificationReason must be also added into ClientReasons
 */
export const ClientRejectedOfferDisqualificationReason: DisqualificationReason = "C-Rejected client's offer";
/**
 * NOTICE: The following DisqualificationReason must be also added into ClientReasons
 */
export const ClientRejectedCodeOfConductDisqualificationReason: DisqualificationReason = "C-Rejected code of conduct";
/**
 * NOTICE: The following DisqualificationReason must be also added into ClientReasons
 */
export const ClientSalaryExpectationsDisqualificationReason: DisqualificationReason = "C-Salary Expectations";
/**
 * NOTICE: The following DisqualificationReason must be also added into ClientReasons
 */
export const ClientSeniorityDisqualificationReason: DisqualificationReason = "C-Seniority";
/**
 * NOTICE: The following DisqualificationReason must be also added into ClientReasons
 */
export const ClientTechSkillsDisqualificationReason: DisqualificationReason = "C-Tech skills don't match position";
/**
 * NOTICE: The following DisqualificationReason must be also added into ClientReasons
 */
export const ClientCommunicationSkillsDisqualificationReason: DisqualificationReason = "C-Communication Skills";
/**
 * NOTICE: The following DisqualificationReason must be also added into ClientReasons
 */
export const ClientPausedPositionDisqualificationReason: DisqualificationReason = "C-Paused position";
/**
 * NOTICE: The following DisqualificationReason must be also added into ClientReasons
 */
export const ClientClosedPositionDisqualificationReason: DisqualificationReason = "C-Closed position";
/**
 * NOTICE: The following DisqualificationReason must be also added into ClientReasons
 */
export const ClientTimezoneDisqualificationReason: DisqualificationReason = "C-Timezone overlap";
/**
 * NOTICE: The following DisqualificationReason must be also added into RemotelyReasons
 */
export const AcceptedOtherRoleDisqualificationReason: DisqualificationReason = "R-Accepted another Remotely job";
/**
 * NOTICE: The following DisqualificationReason must be also added into RemotelyReasons
 */
export const ClosedPositionDisqualificationReason: DisqualificationReason = "R-Closed position";
/**
 * NOTICE: The following DisqualificationReason must be also added into RemotelyReasons
 */
export const CountryBoundariesDisqualificationReason: DisqualificationReason = "R-Country boundaries";
/**
 * NOTICE: The following DisqualificationReason must be also added into RemotelyReasons
 */
export const CulturalFitDisqualificationReason: DisqualificationReason = "R-Cultural Fit";
/**
 * NOTICE: The following DisqualificationReason must be also added into RemotelyReasons
 */
export const NotPassedMockInterviewDisqualificationReason: DisqualificationReason = "R-Did not pass Mock Interview";
/**
 * NOTICE: The following DisqualificationReason must be also added into RemotelyReasons
 */
export const DroppedOutDisqualificationReason: DisqualificationReason = "R-Dropped out";
/**
 * NOTICE: The following DisqualificationReason must be also added into RemotelyReasons
 */
export const EnglishLevelDisqualificationReason: DisqualificationReason = "R-English Level";
/**
 * NOTICE: The following DisqualificationReason must be also added into RemotelyReasons
 */
export const IncompleteProfileDisqualificationReason: DisqualificationReason = "R-Incomplete profile";
/**
 * NOTICE: The following DisqualificationReason must be also added into RemotelyReasons
 */
export const JustStartedJobDisqualificationReason: DisqualificationReason = "R-Just started a job";
/**
 * NOTICE: The following DisqualificationReason must be also added into RemotelyReasons
 */
export const LivesUSADisqualificationReason: DisqualificationReason = "R-Lives in USA";
/**
 * NOTICE: The following DisqualificationReason must be also added into RemotelyReasons
 */
export const NoAnswerDisqualificationReason: DisqualificationReason = "R-No Answer";
/**
 * NOTICE: The following DisqualificationReason must be also added into RemotelyReasons
 */
export const NoShowInterviewDisqualificationReason: DisqualificationReason = "R-No-Show to interview";
/**
 * NOTICE: The following DisqualificationReason must be also added into RemotelyReasons
 */
export const NotDeveloperDisqualificationReason: DisqualificationReason = "R-Not a developer";
/**
 * NOTICE: The following DisqualificationReason must be also added into RemotelyReasons
 */
export const NotInAmericasDisqualificationReason: DisqualificationReason = "R-Not in Americas";
/**
 * NOTICE: The following DisqualificationReason must be also added into RemotelyReasons
 */
export const NotInterestedDisqualificationReason: DisqualificationReason = "R-Not Interested in the opportunity";
/**
 * NOTICE: The following DisqualificationReason must be also added into RemotelyReasons
 */
export const OtherDisqualificationReason: DisqualificationReason = "R-Other";
/**
 * NOTICE: The following DisqualificationReason must be also added into RemotelyReasons
 */
export const PausedPositionDisqualificationReason: DisqualificationReason = "R-Paused position";
/**
 * NOTICE: The following DisqualificationReason must be also added into RemotelyReasons
 */
export const QualifiedNotAvailableDisqualificationReason: DisqualificationReason = "R-Qualified but not available";
/**
 * NOTICE: The following DisqualificationReason must be also added into RemotelyReasons
 */
export const SalaryExpectationsDisqualificationReason: DisqualificationReason = "R-Salary expectations don't match position budget";
/**
 * NOTICE: The following DisqualificationReason must be also added into RemotelyReasons
 */
export const ScammerDisqualificationReason: DisqualificationReason = "R-Scammer";
/**
 * NOTICE: The following DisqualificationReason must be also added into RemotelyReasons
 */
export const SeniorityDisqualificationReason: DisqualificationReason = "R-Seniority";
/**
 * NOTICE: The following DisqualificationReason must be also added into RemotelyReasons
 */
export const SourcingTimeoutDisqualificationReason: DisqualificationReason = "R-Sourcing Timeout";
/**
 * NOTICE: The following DisqualificationReason must be also added into RemotelyReasons
 */
export const StillStudentDisqualificationReason: DisqualificationReason = "R-Still a student";
/**
 * NOTICE: The following DisqualificationReason must be also added into RemotelyReasons
 */
export const TechSkillsDisqualificationReason: DisqualificationReason = "R-Tech skills do not match position needs";
/**
 * NOTICE: The following DisqualificationReason must be also added into RemotelyReasons
 */
export const NoLiveCodingSkillsDisqualificationReason: DisqualificationReason = "R-Does not have Live Code Challenge Skills";
/**
 * NOTICE: The following DisqualificationReason must be also added into RemotelyReasons
 */
export const CommunicationSkillsDisqualificationReason: DisqualificationReason = "R-Communication Skills";
/**
 * NOTICE: The following DisqualificationReason must be also added into RemotelyReasons
 */
export const InternalTestingDisqualificationReason: DisqualificationReason = "R-Internal testing";
/**
 * NOTICE: The following DisqualificationReason must be also added into TalentReasons
 */
export const TalentTypeOfWorkDisqualificationReason: DisqualificationReason = "T-Type of work doesn't align";
/**
 * NOTICE: The following DisqualificationReason must be also added into TalentReasons
 */
export const TalentSalaryDoesNotMeetExpectationsDisqualificationReason: DisqualificationReason = "T-Salary does not meet expectations";
/**
 * NOTICE: The following DisqualificationReason must be also added into TalentReasons
 */
export const TalentCompanySizeOrStageDisqualificationReason: DisqualificationReason = "T-Company size or stage is not a good fit";
/**
 * NOTICE: The following DisqualificationReason must be also added into TalentReasons
 */
export const TalentProductServiceIndustryNotInterestingDisqualificationReason: DisqualificationReason = "T-Product, service or industry not interesting";
/**
 * NOTICE: The following DisqualificationReason must be also added into TalentReasons
 */
export const TalentNotInterestedNewOpportunitiesDisqualificationReason: DisqualificationReason = "T-Not currently interested in new opportunities";
/**
 * NOTICE: The following DisqualificationReason must be also added into TalentReasons
 */
export const TalentRecentlyAcceptedAnotherJobDisqualificationReason: DisqualificationReason = "T-Recently accepted another job";
/**
 * NOTICE: The following DisqualificationReason must be also added into ReferralReasons
 */
export const ReferralSeniorityDisqualificationReason: DisqualificationReason = "R-Referral Seniority";
/**
 * NOTICE: The following DisqualificationReason must be also added into ReferralReasons
 */
export const ReferralCountryDisqualificationReason: DisqualificationReason = "R-Referral Country";
/**
 * NOTICE: The following DisqualificationReason must be also added into ReferralReasons
 */
export const ReferralRoleDisqualificationReason: DisqualificationReason = "R-Referral Role";
/**
 * NOTICE: The following DisqualificationReason must be also added into ReferralReasons
 */
export const ReferralCulturalDisqualificationReason: DisqualificationReason = "R-Referral Cultural Fit";
/**
 * NOTICE: The following DisqualificationReason must be also added into ReferralReasons
 */
export const ReferralUnresponsiveDisqualificationReason: DisqualificationReason = "R-Referral Unresponsive";

//////////
// source: document.go

/**
 * Document represents public.documents
 */
export interface Document {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    name: string;
    url: string;
    entity_table?: string;
    entity_id?: number /* int */;
}

//////////
// source: document_store.go

export type ContractorDocumentType = 'CA' | 'EA' | 'tax_form' | 'termination' | 'code_of_conduct' | 'amendment' | 'other' | 'offer_letter' | 'background_check' | 'equipment' | 'expense';
/**
 * document types are a superset of AgreementType
 */
export const OfferLetterContractorDocumentType: ContractorDocumentType = "offer_letter";
export const BackgroundCheckContractorDocumentType: ContractorDocumentType = "background_check";
export const EquipmentContractorDocumentType: ContractorDocumentType = "equipment";
export const ExpenseContractorDocumentType: ContractorDocumentType = "expense";
export interface CustomerDocument {
    ID: number /* int */;
    CreatedAt: string /* RFC3339 */;
    Name: string;
    Type: ContractorDocumentType;
    URL: string;
    FirstName: string;
    LastName: string;
}
export interface ContractorDocument {
    id: number /* int */;
    created_at: string /* RFC3339 */;
    signed_at?: string /* RFC3339 */;
    name: string;
    type: ContractorDocumentType;
    url: string;
    customer?: string;
    tax_form_type?: TaxFormType;
    amendment_type?: AmendmentType;
}

//////////
// source: elevenlabs_call.go

/**
 * ElevenlabsCall represents public.elevenlabs_calls
 */
export interface ElevenlabsCall {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    candidate_id: number /* int */;
    agent_id: string;
    conversation_id: string;
    payload?: string;
    summary?: string;
    status?: ProfileBuilderStatus;
    core_strengths?: string;
    career_progression?: string;
    work_experience?: JSONArray<WorkExperience>;
}

//////////
// source: email.go

/**
 * Email represents public.emails
 */
export interface Email {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    subject: string;
    content: string;
    sender?: EmailSender;
    sent_at?: string /* RFC3339 */;
    sent_by?: number /* int */;
    sent_to: number /* int */;
    copy_to?: number[];
    status?: EmailStatus;
    kind?: EmailKind;
    source_entities?: SourceEntities;
    scheduled_date_time?: string /* RFC3339 */;
    scheduled_timezone?: string;
    application_id?: number /* int */;
    stage_id?: number /* int */;
}
export type EmailSender = 'admin' | 'contact' | 'talent';
export const AdminEmailSender: EmailSender = "admin";
export const ContactEmailSender: EmailSender = "contact";
export const TalentEmailSender: EmailSender = "talent";
export type EmailStatus = 'scheduled' | 'aborted' | 'pending' | 'failed' | 'sent';
export const ScheduledEmailStatus: EmailStatus = "scheduled";
export const AbortedEmailStatus: EmailStatus = "aborted";
export const PendingEmailStatus: EmailStatus = "pending";
export const FailedEmailStatus: EmailStatus = "failed";
export const SentEmailStatus: EmailStatus = "sent";
export type EmailKind = 'take_home';
export const TakeHomeEmailKind: EmailKind = "take_home";

//////////
// source: email_request.go

/**
 * EmailRequest represents public.email_requests
 */
export interface EmailRequest {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    action: EmailRequestAction;
    entity_id: number /* int */;
    token: string;
    used_at?: string /* RFC3339 */;
    email: string;
    user_id?: number /* int */;
    requested_by?: number /* int */;
}
export type EmailRequestAction = 'review_pto' | 'review_invoice' | 'review_expense' | 'confirm_termination' | 'review_raise' | 'review_bonus' | 'user_deletion';
export const ReviewPTOEmailRequestAction: EmailRequestAction = "review_pto";
export const ReviewInvoiceEmailRequestAction: EmailRequestAction = "review_invoice";
export const ReviewExpenseEmailRequestAction: EmailRequestAction = "review_expense";
export const ConfirmTerminationEmailRequestAction: EmailRequestAction = "confirm_termination";
export const ReviewRaiseEmailRequestAction: EmailRequestAction = "review_raise";
export const ReviewBonusEmailRequestAction: EmailRequestAction = "review_bonus";
export const UserDeletionEmailRequestAction: EmailRequestAction = "user_deletion";

//////////
// source: email_store.go


//////////
// source: email_template.go

/**
 * EmailTemplate represents public.email_templates
 */
export interface EmailTemplate {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    name: string;
    category: EmailTemplateCategory;
    subject: string;
    content: string;
}
export type EmailTemplateCategory = 'candidate' | 'applicant';
export const CandidateEmailTemplateCategory: EmailTemplateCategory = "candidate";
export const ApplicantEmailTemplateCategory: EmailTemplateCategory = "applicant";

//////////
// source: entity_history.go

/**
 * EntityHistory represents public.entity_history
 */
export interface EntityHistory {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    author?: number /* int */;
    type: HistoryType;
    payload: string;
    entity_id: number /* int */;
}
export type HistoryType = 'application_status' | 'payment_attempt' | 'message_status' | 'contract_health_insurance_data' | 'candidate_application_data' | 'candidate_status' | 'candidate_source' | 'candidate_expected_salary' | 'job_opening_health' | 'job_opening_company_owner' | 'customer_stage' | 'candidate_open_to_opportunities' | 'contractor_health' | 'candidate_work_experience' | 'candidate_profile_complete' | 'candidate_experiments' | 'candidate_prospect_status' | 'candidate_seniority' | 'job_opening_openings' | 'job_opening_expansion' | 'candidate_certification' | 'candidate_seniority_evaluation';
export const ApplicationStatusHistoryType: HistoryType = "application_status";
export const PaymentAttemptHistoryType: HistoryType = "payment_attempt";
export const MessageStatusHistoryType: HistoryType = "message_status";
export const ContractHealthInsuranceDataHistoryType: HistoryType = "contract_health_insurance_data";
export const CandidateApplicationDataHistoryType: HistoryType = "candidate_application_data";
export const CandidateStatusHistoryType: HistoryType = "candidate_status";
export const CandidateSourceHistoryType: HistoryType = "candidate_source";
export const CandidateExpectedSalaryHistoryType: HistoryType = "candidate_expected_salary";
export const JobOpeningHealthHistoryType: HistoryType = "job_opening_health";
export const JobOpeningCompanyOwnerHistoryType: HistoryType = "job_opening_company_owner";
export const CustomerStageHistoryType: HistoryType = "customer_stage";
export const CandidateOpenToOpportunityHistoryType: HistoryType = "candidate_open_to_opportunities";
export const ContractorHealthHistoryType: HistoryType = "contractor_health";
export const CandidateWorkExperienceHistoryType: HistoryType = "candidate_work_experience";
export const CandidateProfileCompleteHistoryType: HistoryType = "candidate_profile_complete";
export const CandidateExperimentHistoryType: HistoryType = "candidate_experiments";
export const CandidateProspectStatusHistoryType: HistoryType = "candidate_prospect_status";
export const CandidateSeniorityHistoryType: HistoryType = "candidate_seniority";
export const JobOpeningOpeningHistoryType: HistoryType = "job_opening_openings";
export const JobOpeningExpansionHistoryType: HistoryType = "job_opening_expansion";
export const CandidateCertificationHistoryType: HistoryType = "candidate_certification";
export const CandidateSeniorityEvaluationHistoryType: HistoryType = "candidate_seniority_evaluation";

//////////
// source: entity_history_store.go

/**
 * CandidateOpenToOpportunitiesChange is the payload for CandidateOpenToOpportunityHistoryType.
 */
export interface CandidateOpenToOpportunitiesChange {
    open_to_opportunities: boolean;
    changed_at: string /* RFC3339 */;
}
/**
 * ChangeSource describes what caused a candidate profile_complete or
 * experiments change. Lets BigQuery readers distinguish manual toggles from
 * system side effects.
 */
export type ChangeSource = string;
export const ManualChangeSource: ChangeSource = "manual";
export const OnboardChangeSource: ChangeSource = "onboard";
export const ProfileBuilderChangeSource: ChangeSource = "profile_builder";
export const ApplicationHiredChangeSource: ChangeSource = "application_hired";
export const OpenToOpportunitiesChangeSource: ChangeSource = "open_to_opportunities";
export const RecordingAnswerChangeSource: ChangeSource = "recording_answer";
export interface CandidateProfileCompleteChange {
    profile_complete: boolean;
    source?: ChangeSource;
    changed_at: string /* RFC3339 */;
}
export interface CandidateExperimentsChange {
    experiments: Experiments;
    source?: ChangeSource;
    changed_at: string /* RFC3339 */;
}
/**
 * JobOpeningExpansionsChange is the payload for JobOpeningExpansionHistoryType.
 */
export interface JobOpeningExpansionsChange {
    expansions: JobOpeningExpansions;
    matches: number /* int */[];
}
/**
 * CandidateProspectStatusChange is the payload for CandidateProspectStatusHistoryType.
 */
export interface CandidateProspectStatusChange {
    status: CandidateProspectStatus;
    changed_at: string /* RFC3339 */;
}
/**
 * HealthChangeType describes how a contractor health change was triggered.
 */
export type HealthChangeType = string;
export const ManualHealthChangeType: HealthChangeType = "manual";
export const CheckinScoreHealthChangeType: HealthChangeType = "checkin_score";
export const CheckinNoDataHealthChangeType: HealthChangeType = "checkin_no_data";
export const ContractTerminatedHealthChangeType: HealthChangeType = "contract_terminated";
export const BackfillHealthChangeType: HealthChangeType = "backfill";
/**
 * ContractorHealthChange is the payload for ContractorHealthHistoryType.
 */
export interface ContractorHealthChange {
    health?: ContractorCustomerHealth;
    reason: ContractorCustomerHealthReason;
    comment?: string;
    score?: number /* int */;
    changed_at: string /* RFC3339 */;
    change_type?: HealthChangeType;
}

//////////
// source: equipment.go

/**
 * Equipment represents public.equipment
 */
export interface Equipment {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    kind: EquipmentKind;
    status?: EquipmentStatus;
    contract_id?: number /* int */;
    customer_id: number /* int */;
    brand: string;
    model: string;
    description?: string;
    part_number?: string;
    serial_number?: string;
    purchased_at?: string /* RFC3339 */;
    delivered_at?: string /* RFC3339 */;
    confirmed_at?: string /* RFC3339 */;
    ordered_at?: string /* RFC3339 */;
    cost: number;
    invoice_id?: number /* int */;
    accounting_status?: AccountingStatus;
    termination_status?: EquipmentStatus;
    customer_invoice_id?: number /* int */;
    location?: string;
    provider_id?: number /* int */;
    order_number?: string;
    expected_delivery?: string /* RFC3339 */;
    finished_delivery?: string /* RFC3339 */;
    picture_id?: number /* int */;
    offer_letter_id?: number /* int */;
}
export type EquipmentKind = 'laptop' | 'monitor' | 'keyboard' | 'mouse' | 'trackpad' | 'other';
export const LaptopEquipmentKind: EquipmentKind = "laptop";
export const MonitorEquipmentKind: EquipmentKind = "monitor";
export const KeyboardEquipmentKind: EquipmentKind = "keyboard";
export const MouseEquipmentKind: EquipmentKind = "mouse";
export const TrackpadEquipmentKind: EquipmentKind = "trackpad";
export const OtherEquipmentKind: EquipmentKind = "other";
export type EquipmentStatus = 'pending' | 'ordered' | 'purchased' | 'shipped' | 'delivered' | 'confirmed' | 'not_delivered' | 'canceled' | 'sold_to_developer' | 'gifted_to_developer' | 'returned' | 'in_stock' | 'stolen_or_decommissioned';
export const PendingEquipmentStatus: EquipmentStatus = "pending";
export const OrderedEquipmentStatus: EquipmentStatus = "ordered";
export const PurchasedEquipmentStatus: EquipmentStatus = "purchased";
export const ShippedEquipmentStatus: EquipmentStatus = "shipped";
export const DeliveredEquipmentStatus: EquipmentStatus = "delivered";
export const ConfirmedEquipmentStatus: EquipmentStatus = "confirmed";
export const NotDeliveredEquipmentStatus: EquipmentStatus = "not_delivered";
export const CanceledEquipmentStatus: EquipmentStatus = "canceled";
export const SoldToDeveloperEquipmentStatus: EquipmentStatus = "sold_to_developer";
export const GiftedToDeveloperEquipmentStatus: EquipmentStatus = "gifted_to_developer";
export const ReturnedEquipmentStatus: EquipmentStatus = "returned";
export const InStockEquipmentStatus: EquipmentStatus = "in_stock";
export const StolenOrDecommissionedEquipmentStatus: EquipmentStatus = "stolen_or_decommissioned";

//////////
// source: equipment_provider.go

/**
 * EquipmentProvider represents public.equipment_providers
 */
export interface EquipmentProvider {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    name: string;
    codename: string;
    emails?: string[];
    user_ids?: number[];
    enabled?: boolean;
    disregard_before?: string /* RFC3339 */;
    disregard_subjects?: string[];
}

//////////
// source: equipment_quote.go

/**
 * EquipmentQuote represents public.equipment_quotes
 */
export interface EquipmentQuote {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    equipment_ids?: number[];
    status?: EquipmentQuoteStatus;
    accounting_status?: AccountingStatus;
    contract_id?: number /* int */;
    customer_id?: number /* int */;
    provider_id?: number /* int */;
    order_number?: string;
    tracking_number?: string;
    shipping_info?: ShippingInfo;
    reviewer_id?: number /* int */;
    rejection_reason?: EquipmentQuoteRejectionReason;
    rejection_comments?: string;
    requested_at?: string /* RFC3339 */;
    proposed_at?: string /* RFC3339 */;
    reviewed_at?: string /* RFC3339 */;
    ordered_at?: string /* RFC3339 */;
    shipped_at?: string /* RFC3339 */;
    delivered_at?: string /* RFC3339 */;
    cancelled_at?: string /* RFC3339 */;
    requirements?: EquipmentQuoteRequirements;
    proposal?: EquipmentQuoteProposal;
    shipping_cost?: number;
    delivery_time?: string;
    invoice_id?: number /* int */;
    receipt_document_id?: number /* int */;
    quotation_document_id?: number /* int */;
    notes?: string;
    offer_letter_id?: number /* int */;
    approval_comment?: string;
    client_approver_id?: number /* int */;
}
export type EquipmentQuoteStatus = 'draft' | 'requested' | 'proposed' | 'approved' | 'rejected' | 'ordered' | 'shipped' | 'delivered' | 'cancelled';
export const DraftEquipmentQuoteStatus: EquipmentQuoteStatus = "draft";
export const RequestedEquipmentQuoteStatus: EquipmentQuoteStatus = "requested";
export const ProposedEquipmentQuoteStatus: EquipmentQuoteStatus = "proposed";
export const ApprovedEquipmentQuoteStatus: EquipmentQuoteStatus = "approved";
export const RejectedEquipmentQuoteStatus: EquipmentQuoteStatus = "rejected";
export const OrderedEquipmentQuoteStatus: EquipmentQuoteStatus = "ordered";
export const ShippedEquipmentQuoteStatus: EquipmentQuoteStatus = "shipped";
export const DeliveredEquipmentQuoteStatus: EquipmentQuoteStatus = "delivered";
export const CancelledEquipmentQuoteStatus: EquipmentQuoteStatus = "cancelled";
export type EquipmentQuoteRejectionReason = 'does_not_meet_requirements' | 'too_expensive' | 'delivery_is_too_late' | 'other';
export const DoesNotMeetRequirementEquipmentQuoteRejectionReason: EquipmentQuoteRejectionReason = "does_not_meet_requirements";
export const TooExpensiveEquipmentQuoteRejectionReason: EquipmentQuoteRejectionReason = "too_expensive";
export const DeliveryIsTooLateEquipmentQuoteRejectionReason: EquipmentQuoteRejectionReason = "delivery_is_too_late";
export const OtherEquipmentQuoteRejectionReason: EquipmentQuoteRejectionReason = "other";

//////////
// source: equipment_quote_store.go

export interface EquipmentQuoteRequirements {
    os: string;
    screen_size: string;
    ram: string;
    ssd: string;
    spanish_keyboard: boolean;
    extra_items?: string;
    allow_personal: boolean;
    comments?: string;
}
export interface EquipmentQuoteProposal {
    equipments: EquipmentProposed[];
    shipping: number;
    shipping_is_estimation: boolean;
    delivery_time?: string;
    document_id?: number /* int */;
    comments?: string;
}
export interface EquipmentProposed {
    kind: EquipmentKind;
    brand: string;
    model: string;
    description?: string;
    cost: number;
}
export interface ShippingInfo extends LegalAddress {
    first_name: string;
    last_name: string;
    instructions?: string;
    telephone?: string;
    national_id?: string;
    last_update?: string /* RFC3339 */;
    confirmed: boolean;
}
export interface Costs {
    equipment: number;
    shipping: number;
    total: number;
}

//////////
// source: equipment_store.go

export interface CustomerEquipment {
    id: number /* int */;
    kind: EquipmentKind;
    status?: EquipmentStatus;
    brand: string;
    model: string;
    serial_number?: string;
    purchased_at?: string /* RFC3339 */;
    cost: number;
    first_name: string;
    last_name: string;
    url?: string;
    agreement_url?: string;
}

//////////
// source: expense.go

/**
 * Expense represents public.expenses
 */
export interface Expense {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    status?: ExpensesStatus;
    contract_id?: number /* int */;
    customer_id: number /* int */;
    title: string;
    description?: string;
    expensed_at: string /* RFC3339 */;
    kind: ExpensesKind;
    total: number;
    receipt_id: number /* int */;
    reviewed_at?: string /* RFC3339 */;
    reviewer_id?: number /* int */;
    contractor_accounting_status?: AccountingStatus;
    customer_accounting_status?: AccountingStatus;
    customer_invoice_id?: number /* int */;
    contractor_invoice_id?: number /* int */;
}
export type ExpensesStatus = 'pending' | 'approved' | 'rejected' | 'canceled';
export const PendingExpensesStatus: ExpensesStatus = "pending";
export const ApprovedExpensesStatus: ExpensesStatus = "approved";
export const RejectedExpensesStatus: ExpensesStatus = "rejected";
export const CanceledExpensesStatus: ExpensesStatus = "canceled";
export type ExpensesKind = 'transportation' | 'lodging' | 'meals' | 'equipment' | 'other';
export const TransportationExpensesKind: ExpensesKind = "transportation";
export const LodgingExpensesKind: ExpensesKind = "lodging";
export const MealExpensesKind: ExpensesKind = "meals";
export const EquipmentExpensesKind: ExpensesKind = "equipment";
export const OtherExpensesKind: ExpensesKind = "other";

//////////
// source: expense_store.go

export interface PendingApprovalCompanyExpense {
    Expense?: Expense;
    UserID: number /* int */;
    FirstName: string;
    LastName: string;
    Picture: string;
}

//////////
// source: google_api_scopes.go

export const GoogleGmailReadonlyScope = "https://www.googleapis.com/auth/gmail.readonly"; // Read access to Gmail API (read emails)
export const GoogleCalendarScope = "https://www.googleapis.com/auth/calendar"; // Read/Write access to Calendar API
export const GoogleCalendarReadonlyScope = "https://www.googleapis.com/auth/calendar.readonly"; // Read access to Calendar API
export const GoogleCalendarEventsScope = "https://www.googleapis.com/auth/calendar.events"; // Read/Write calendar events
export const GoogleCalendarEventsReadonlyScope = "https://www.googleapis.com/auth/calendar.events.readonly"; // Read calendar events
export const GoogleMeetingsSpaceCreatedScope = "https://www.googleapis.com/auth/meetings.space.created"; // Read/Write access to Meet API
export const GoogleDriveScope = "https://www.googleapis.com/auth/drive"; // Read/Write access to Drive API (recordings)
export const GoogleDocumentsScope = "https://www.googleapis.com/auth/documents"; // Read/Write access to Docs API (transcripts)
export const GoogleUserEmailsReadScope = "https://www.googleapis.com/auth/user.emails.read"; // Read access to People API (participant emails)

//////////
// source: health_insurance_cost.go

/**
 * HealthInsuranceCost represents public.health_insurance_costs
 */
export interface HealthInsuranceCost {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    country: string;
    cost: number;
}

//////////
// source: health_insurance_plan.go

/**
 * HealthInsurancePlan represents public.health_insurance_plans
 */
export interface HealthInsurancePlan {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    active: boolean;
    plan_id: number /* int */;
    name: string;
    type: HealthInsurancePlanType;
    pricings?: JSONArray<HealthInsurancePlanPricing>;
    addons?: JSONArray<HealthInsurancePlanAddon>;
    valid_from: string /* RFC3339 */;
    valid_until: string /* RFC3339 */;
}
export type HealthInsurancePlanType = 'STANDARD' | 'PREMIUM' | 'MATERNITY';
export const STANDARDHealthInsurancePlanType: HealthInsurancePlanType = "STANDARD";
export const PREMIUMHealthInsurancePlanType: HealthInsurancePlanType = "PREMIUM";
export const MATERNITYHealthInsurancePlanType: HealthInsurancePlanType = "MATERNITY";

//////////
// source: health_insurance_plan_store.go

export type HealthInsurancePlanAddonType = string;
export const DentalHealthInsurancePlanAddonType: HealthInsurancePlanAddonType = "DENTAL";
export const VisionHealthInsurancePlanAddonType: HealthInsurancePlanAddonType = "VISION";
export const ScreeningHealthInsurancePlanAddonType: HealthInsurancePlanAddonType = "SCREENING";
export const MaternityHealthInsurancePlanAddonType: HealthInsurancePlanAddonType = "MATERNITY";
export const OutpatientHealthInsurancePlanAddonType: HealthInsurancePlanAddonType = "OUTPATIENT";
export const TherapiesHealthInsurancePlanAddonType: HealthInsurancePlanAddonType = "THERAPIES";
export const MentalHealthInsurancePlanAddonType: HealthInsurancePlanAddonType = "MENTAL_HEALTH";
export interface HealthInsurancePlanAddon {
    type: HealthInsurancePlanAddonType;
    max_covered_per_period: number /* float64 */;
    insurance_percentage: number /* float64 */;
    description: string;
}
export interface HealthInsurancePlanPricing {
    from_age: number /* int */;
    to_age: number /* int */;
    amount: number /* float64 */;
}

//////////
// source: hirevoice_result.go

/**
 * HirevoiceResult represents public.hirevoice_results
 */
export interface HirevoiceResult {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    candidate_id: number /* int */;
    status?: HirevoiceResultStatus;
    result?: string;
}
export type HirevoiceResultStatus = 'completed' | 'not_evaluated' | 'timeout' | 'permission_denied' | 'audio_issue' | 'system_error' | 'unknown';
export const CompletedHirevoiceResultStatus: HirevoiceResultStatus = "completed";
export const NotEvaluatedHirevoiceResultStatus: HirevoiceResultStatus = "not_evaluated";
export const TimeoutHirevoiceResultStatus: HirevoiceResultStatus = "timeout";
export const PermissionDeniedHirevoiceResultStatus: HirevoiceResultStatus = "permission_denied";
export const AudioIssueHirevoiceResultStatus: HirevoiceResultStatus = "audio_issue";
export const SystemErrorHirevoiceResultStatus: HirevoiceResultStatus = "system_error";
export const UnknownHirevoiceResultStatus: HirevoiceResultStatus = "unknown";

//////////
// source: holiday.go

/**
 * Holiday represents public.holidays
 */
export interface Holiday {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    name: string;
    countries?: string[];
    starred?: boolean;
    description?: string;
    customer_id?: number /* int */;
    type: HolidayType;
    day?: number /* int */;
    month?: number /* int */;
    dates?: HolidayDates;
}
export type HolidayType = 'fixed' | 'variable';
export const FixedHolidayType: HolidayType = "fixed";
export const VariableHolidayType: HolidayType = "variable";

//////////
// source: holiday_store.go

export type HolidayDates = Partial<Record<number /* int */, string /* RFC3339 */>>;

//////////
// source: im_contact.go

/**
 * ImContact represents public.im_contacts
 */
export interface ImContact {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    contact_id: string;
    candidate_id: number /* int */;
    last_message_received_at?: string /* RFC3339 */;
    phone_number?: string;
}

//////////
// source: im_message.go

/**
 * ImMessage represents public.im_messages
 */
export interface ImMessage {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    thread_id: number /* int */;
    from_id?: number /* int */;
    direction: ImMessageDirection;
    reply_to?: number /* int */;
    kind: ImMessageKind;
    is_private?: boolean;
    content?: ImMessageContent;
    status: ImMessageStatus;
    status_history?: ImMessageStatusHistory;
    error_details?: string;
    message_id: string;
    metadata?: ImMessageMetadata;
    bulk_batch_id?: string;
    type?: ImMessageType;
}
export type ImMessageDirection = 'sent' | 'received';
export const SentImMessageDirection: ImMessageDirection = "sent";
export const ReceivedImMessageDirection: ImMessageDirection = "received";
export type ImMessageKind = 'text' | 'image' | 'video' | 'audio' | 'file' | 'location' | 'event' | 'hsm' | 'rich' | 'menu' | 'buttons' | 'link' | 'whatsappSticker' | 'html';
export const TextImMessageKind: ImMessageKind = "text";
export const ImageImMessageKind: ImMessageKind = "image";
export const VideoImMessageKind: ImMessageKind = "video";
export const AudioImMessageKind: ImMessageKind = "audio";
export const FileImMessageKind: ImMessageKind = "file";
export const LocationImMessageKind: ImMessageKind = "location";
export const EventImMessageKind: ImMessageKind = "event";
export const HsmImMessageKind: ImMessageKind = "hsm";
export const RichImMessageKind: ImMessageKind = "rich";
export const MenuImMessageKind: ImMessageKind = "menu";
export const ButtonImMessageKind: ImMessageKind = "buttons";
export const LinkImMessageKind: ImMessageKind = "link";
export const WhatsappStickerImMessageKind: ImMessageKind = "whatsappSticker";
export const HTMLImMessageKind: ImMessageKind = "html";
export type ImMessageStatus = 'pending' | 'sent' | 'failed' | 'received' | 'read';
export const PendingImMessageStatus: ImMessageStatus = "pending";
export const SentImMessageStatus: ImMessageStatus = "sent";
export const FailedImMessageStatus: ImMessageStatus = "failed";
export const ReceivedImMessageStatus: ImMessageStatus = "received";
export const ReadImMessageStatus: ImMessageStatus = "read";
export type ImMessageType = 'bulk' | 'individual';
export const BulkImMessageType: ImMessageType = "bulk";
export const IndividualImMessageType: ImMessageType = "individual";

//////////
// source: im_message_store.go


type ImMessageStatusHistory = Partial<Record<ImMessageStatus, string>>;

export interface ImMessageMedia {
    url: string;
    caption?: string;
}
export interface ImMessageButtons {
    text: string;
    items?: ImMessageButtonItem;
}

type ImMessageButtonItemActionType = 'text' | 'location' | 'camera' | 'camera_roll' | 'uri';

export const ImMessageButtonItemActionText: ImMessageButtonItemActionType = "text";
export const ImMessageButtonItemActionLocation: ImMessageButtonItemActionType = "location";
export const ImMessageButtonItemActionCamera: ImMessageButtonItemActionType = "camera";
export const ImMessageButtonItemActionCameraRoll: ImMessageButtonItemActionType = "camera_roll";
export const ImMessageButtonItemActionURI: ImMessageButtonItemActionType = "uri";
export interface ImMessageButtonItemAction {
    type: ImMessageButtonItemActionType;
    uri: string;
}
export interface ImMessageButtonItem {
    text: string;
    action: string;
}
export interface ImMessageTemplateLanguage {
    policy?: string;
    code: string;
}
export interface ImMessageTemplate {
    namespace: string;
    templateName: string;
    language?: ImMessageTemplateLanguage;
    components: ImMessageTemplateComponent[];
}
export interface ImMessageTemplateKey {
    Namespace: string;
    TemplateName: string;
}

type ImMessageTemplateComponentType = 'header' | 'body' | 'carousel' | 'button';

export const HeaderImMessageTemplateComponentType: ImMessageTemplateComponentType = "header";
export const BodyImMessageTemplateComponentType: ImMessageTemplateComponentType = "body";
export const CarouselImMessageTemplateComponentType: ImMessageTemplateComponentType = "carousel";
export const ButtonImMessageTemplateComponentType: ImMessageTemplateComponentType = "button";

type ImMessageTemplateComponentSubType = 'quick_reply' | 'url';

export const QuickReplyImMessageTemplateComponentSubType: ImMessageTemplateComponentSubType = "quick_reply";
export const URLImMessageTemplateComponentSubType: ImMessageTemplateComponentSubType = "url";
export interface ImMessageTemplateComponent {
    type: ImMessageTemplateComponentType;
    sub_type?: ImMessageTemplateComponentSubType;
    index?: number /* int */;
    parameters: ImMessageTemplateParam[];
    cards?: ImMessageTemplateCard[];
}
export interface ImMessageTemplateCard {
    card_index: number /* int */;
    components: ImMessageTemplateComponent[];
}
export interface ImMessageCurrency {
    currencyCode: string;
    amount: number /* int */;
}

type ImMessageTemplateParamType = 'text' | 'payload' | 'image' | 'document' | 'currency' | 'video' | 'dateTime';

export const TextImMessageTemplateParamType: ImMessageTemplateParamType = "text";
export const PayloadImMessageTemplateParamType: ImMessageTemplateParamType = "payload";
export const ImageImMessageTemplateParamType: ImMessageTemplateParamType = "image";
export const DocumentImMessageTemplateParamType: ImMessageTemplateParamType = "document";
export const CurrencyImMessageTemplateParamType: ImMessageTemplateParamType = "currency";
export const VideoImMessageTemplateParamType: ImMessageTemplateParamType = "video";
export const DateTimeImMessageTemplateParamType: ImMessageTemplateParamType = "dateTime";
export interface ImMessageTemplateParam {
    type: ImMessageTemplateParamType;
    text?: string;
    payload?: string;
    dateTime?: string;
    currency?: ImMessageCurrency;
    document?: ImMessageMedia;
    image?: ImMessageMedia;
    video?: ImMessageMedia;
}
export interface ImMessageContent {
    text?: string;
    image?: ImMessageMedia;
    video?: ImMessageMedia;
    audio?: ImMessageMedia;
    file?: ImMessageMedia;
    buttons?: ImMessageButtons;
    hsm?: ImMessageTemplate;
}
export interface ImMessageMetadata {
    conversation_id?: string;
    agent_id?: string;
    contact_id?: string;
    job_opening_id?: number /* int */;
    calendar_event_id?: number /* int */;
    phone_number?: string;
    error_message?: string;
    error_code?: number /* int */;
    /**
     * HandledAt should be filled whenever an action has handled this message.
     */
    handled_at?: string /* RFC3339 */;
}

//////////
// source: im_template.go

/**
 * ImTemplate represents public.im_templates
 */
export interface ImTemplate {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    external_id: string;
    created_by?: number /* int */;
    name: string;
    category?: ImTemplateCategory;
    topic?: ImTopic;
    namespace: string;
    language?: string;
    status: ImTemplateStatus;
    components?: JSONArray<ImTemplateComponent>;
    waba_id?: string;
    rejection_reason?: string;
}
export type ImTemplateCategory = 'AUTHENTICATION' | 'UTILITY' | 'MARKETING';
export const AUTHENTICATIONImTemplateCategory: ImTemplateCategory = "AUTHENTICATION";
export const UTILITYImTemplateCategory: ImTemplateCategory = "UTILITY";
export const MARKETINGImTemplateCategory: ImTemplateCategory = "MARKETING";
export type ImTopic = 'scheduling' | 'matching' | 'offer' | 'position_pipeline' | 'feedback' | 'onboarding' | 'interview';
export const SchedulingImTopic: ImTopic = "scheduling";
export const MatchingImTopic: ImTopic = "matching";
export const OfferImTopic: ImTopic = "offer";
export const PositionPipelineImTopic: ImTopic = "position_pipeline";
export const FeedbackImTopic: ImTopic = "feedback";
export const OnboardingImTopic: ImTopic = "onboarding";
export const InterviewImTopic: ImTopic = "interview";
export type ImTemplateStatus = 'pending' | 'rejected' | 'active' | 'deleted';
export const PendingImTemplateStatus: ImTemplateStatus = "pending";
export const RejectedImTemplateStatus: ImTemplateStatus = "rejected";
export const ActiveImTemplateStatus: ImTemplateStatus = "active";
export const DeletedImTemplateStatus: ImTemplateStatus = "deleted";

//////////
// source: im_template_store.go

export interface ImTemplateComponent {
    type: ImTemplateComponentType;
    format?: ImTemplateComponentFormat;
    text?: string;
    buttons?: ImTemplateComponentButton[];
    example?: ImTemplateExample;
    cards?: ImTemplateCard[];
}
export interface ImTemplateCard {
    components: ImTemplateComponent[];
}
export interface ImTemplateExample {
    header_text?: string[];
    body_text?: string[][];
    header_url?: string[];
}

export type ImTemplateComponentType = 'HEADER' | 'BODY' | 'CAROUSEL' | 'BUTTONS' | 'FOOTER';

export const HeaderImTemplateComponentType: ImTemplateComponentType = "HEADER";
export const BodyImTemplateComponentType: ImTemplateComponentType = "BODY";
export const CarouselImTemplateComponentType: ImTemplateComponentType = "CAROUSEL";
export const ButtonImTemplateComponentType: ImTemplateComponentType = "BUTTONS";
export const FooterImTemplateComponentType: ImTemplateComponentType = "FOOTER";

export type ImTemplateComponentFormat = 'TEXT' | 'IMAGE' | 'DOCUMENT' | 'VIDEO';

export const TextImTemplateComponentFormat: ImTemplateComponentFormat = "TEXT";
export const ImageImTemplateComponentFormat: ImTemplateComponentFormat = "IMAGE";
export const DocumentImTemplateComponentFormat: ImTemplateComponentFormat = "DOCUMENT";
export const VideoImTemplateComponentFormat: ImTemplateComponentFormat = "VIDEO";

export type ImTemplateComponentButtonType = 'URL' | 'PHONE_NUMBER' | 'QUICK_REPLY';

export const URLImTemplateComponentButtonType: ImTemplateComponentButtonType = "URL";
export const PhoneNumberImTemplateComponentButtonType: ImTemplateComponentButtonType = "PHONE_NUMBER";
export const QuickReplyImTemplateComponentButtonType: ImTemplateComponentButtonType = "QUICK_REPLY";
export interface ImTemplateComponentButton {
    type: ImTemplateComponentButtonType;
    text: string;
    url?: string;
    phone_number?: string;
    example?: string[];
}

//////////
// source: im_thread.go

/**
 * ImThread represents public.im_threads
 */
export interface ImThread {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    candidate_id: number /* int */;
    name: string;
    created_by?: number /* int */;
    closed_by?: number /* int */;
    status: ImThreadStatus;
    closed_at?: string /* RFC3339 */;
    last_activity_at?: string /* RFC3339 */;
    last_activity_by?: number /* int */;
    last_responder_id?: number /* int */;
    responders?: number[];
    last_message_id?: number /* int */;
    conversation_id?: string;
    topics?: ImTopics;
}
export type ImThreadStatus = 'open' | 'closed';
export const OpenImThreadStatus: ImThreadStatus = "open";
export const ClosedImThreadStatus: ImThreadStatus = "closed";

//////////
// source: im_thread_participant.go

/**
 * ImThreadParticipant represents public.im_thread_participants
 */
export interface ImThreadParticipant {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    user_id: number /* int */;
    thread_id: number /* int */;
    last_read_at: string /* RFC3339 */;
}

//////////
// source: im_thread_participant_store.go


//////////
// source: im_thread_store.go

export type ImTopics = ImTopic[];
export interface ImThreadStats {
    total: number /* int */;
    open: number /* int */;
    closed: number /* int */;
}

//////////
// source: invoice_line.go

/**
 * InvoiceLine represents public.invoice_lines
 */
export interface InvoiceLine {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    type: InvoiceType;
    kind: LineKind;
    invoice_id?: number /* int */;
    customer_id?: number /* int */;
    user_id?: number /* int */;
    concept: string;
    rate: number;
    quantity: number;
    total: number;
    month?: number /* int */;
    year?: number /* int */;
    document_id?: number /* int */;
    manual?: boolean;
    source_entities: SourceEntities;
    metadata?: LineMetadata;
    contract_id?: number /* int */;
}
export type InvoiceType = 'contractor_invoices' | 'customer_invoices';
export const ContractorInvoiceInvoiceType: InvoiceType = "contractor_invoices";
export const CustomerInvoiceInvoiceType: InvoiceType = "customer_invoices";
export type LineKind = 'contractor_services' | 'security_deposit' | 'contractor_management_fee' | 'recruiting_fee' | 'non_solicitation_fee' | 'recruiting_only_fee' | 'equipment' | 'expense' | 'termination_fee' | 'health_insurance' | 'unused_pto' | 'adjustment' | 'bonus' | 'referral_fee' | 'other' | 'background_check' | 'contractor_referral_fee' | 'customer_referral_fee';
export const ContractorServiceLineKind: LineKind = "contractor_services";
export const SecurityDepositLineKind: LineKind = "security_deposit";
export const ContractorManagementFeeLineKind: LineKind = "contractor_management_fee";
export const RecruitingFeeLineKind: LineKind = "recruiting_fee";
export const NonSolicitationFeeLineKind: LineKind = "non_solicitation_fee";
export const RecruitingOnlyFeeLineKind: LineKind = "recruiting_only_fee";
export const EquipmentLineKind: LineKind = "equipment";
export const ExpenseLineKind: LineKind = "expense";
export const TerminationFeeLineKind: LineKind = "termination_fee";
export const HealthInsuranceLineKind: LineKind = "health_insurance";
export const UnusedPTOLineKind: LineKind = "unused_pto";
export const AdjustmentLineKind: LineKind = "adjustment";
export const BonusLineKind: LineKind = "bonus";
export const ReferralFeeLineKind: LineKind = "referral_fee";
export const OtherLineKind: LineKind = "other";
export const BackgroundCheckLineKind: LineKind = "background_check";
export const ContractorReferralFeeLineKind: LineKind = "contractor_referral_fee";
export const CustomerReferralFeeLineKind: LineKind = "customer_referral_fee";

//////////
// source: invoice_line_store.go

export type AdjustmentType = string;
export const RaiseAdjustmentType: AdjustmentType = "raise";
export const FeeTerminatedAdjustmentType: AdjustmentType = "fee_terminated";
export const TerminationAdjustmentType: AdjustmentType = "termination";
export const RemotelyFeeAdjustmentType: AdjustmentType = "remotely_fee";
export const HealthInsuranceAdjustmentType: AdjustmentType = "health_insurance";
export interface LineMetadata {
    affected_month?: number;
    affected_year?: number /* int */;
    adjustment_type?: AdjustmentType;
    customer_group_id?: number /* int */;
}
/**
 * SourceEntities is a map of tables and ids, with the source entities that has
 * originated the invoice line.
 */
export type SourceEntities = Partial<Record<string, number /* int */>>;
export interface DepositLine {
    id?: number /* int */;
    invoice_id: number /* int */;
    concept: string;
    rate: number;
    source_entities?: SourceEntities;
    customer_id: number /* int */;
    company_name: string;
    issued_at: null /* sql.NullTime */;
}

//////////
// source: job_opening.go

/**
 * JobOpening represents public.job_openings
 */
export interface JobOpening {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    published_at?: string /* RFC3339 */;
    closed_at?: string /* RFC3339 */;
    close_reason?: JobOpeningCloseReason;
    customer_id: number /* int */;
    copied_from?: number /* int */;
    copied_at?: string /* RFC3339 */;
    status?: JobOpeningsStatus;
    health?: JobOpeningHealth;
    health_updated_at?: string /* RFC3339 */;
    title: string;
    permalink: string;
    description: string;
    roles?: number[];
    stack?: number[];
    tech_challenge?: string;
    responsibilities?: string;
    requirements?: string;
    salary_range_start?: number;
    salary_range_end?: number;
    salary_range_currency?: Currency;
    openings?: number /* int */;
    hiring_manager_id?: number /* int */;
    hiring_manager_video_id?: number /* int */;
    service_description?: string;
    private_notes?: string;
    job_requirements?: JobRequirements;
    last_updated_by?: number /* int */;
    record_meetings: boolean;
    difficult?: boolean;
    company_owner_id?: number /* int */;
    scorecard?: JobScoreCard;
    scorecard_updated_at?: string /* RFC3339 */;
    work_type?: WorkType;
    ideal_candidate?: string;
    consider_exceptional_candidates?: boolean;
    group_id?: number /* int */;
    reports_to?: number /* int */;
    talent_manager_id?: number /* int */;
    talent_specialist_id?: number /* int */;
    hr_contact_id?: number /* int */;
    ideal_start_date?: string /* RFC3339 */;
    background_check_required?: boolean;
    provide_laptop?: boolean;
    on_call_required?: boolean;
    confidential?: boolean;
    create_method?: JobOpeningCreateMethod;
    create_input?: string;
    reason_for_opening?: JobOpeningReasonForOpening;
    paused_at?: string /* RFC3339 */;
    pause_reason?: string;
    expansions?: JobOpeningExpansions;
}
export type JobOpeningCloseReason = 'hired_on_own_latam' | 'hired_on_own_us' | 'hired_remotely' | 'hired_other_source' | 'difficult_position' | 'paused' | 'experiment' | 'misaligned_values' | 'no_longer_hiring' | 'requirements_changed';
export const HiredOnOwnLatamJobOpeningCloseReason: JobOpeningCloseReason = "hired_on_own_latam";
export const HiredOnOwnUJobOpeningCloseReason: JobOpeningCloseReason = "hired_on_own_us";
export const HiredRemotelyJobOpeningCloseReason: JobOpeningCloseReason = "hired_remotely";
export const HiredOtherSourceJobOpeningCloseReason: JobOpeningCloseReason = "hired_other_source";
export const DifficultPositionJobOpeningCloseReason: JobOpeningCloseReason = "difficult_position";
export const PausedJobOpeningCloseReason: JobOpeningCloseReason = "paused";
export const ExperimentJobOpeningCloseReason: JobOpeningCloseReason = "experiment";
export const MisalignedValueJobOpeningCloseReason: JobOpeningCloseReason = "misaligned_values";
export const NoLongerHiringJobOpeningCloseReason: JobOpeningCloseReason = "no_longer_hiring";
export const RequirementsChangedJobOpeningCloseReason: JobOpeningCloseReason = "requirements_changed";
export type JobOpeningsStatus = 'draft' | 'pending' | 'published' | 'closed' | 'paused';
export const DraftJobOpeningsStatus: JobOpeningsStatus = "draft";
export const PendingJobOpeningsStatus: JobOpeningsStatus = "pending";
export const PublishedJobOpeningsStatus: JobOpeningsStatus = "published";
export const ClosedJobOpeningsStatus: JobOpeningsStatus = "closed";
export const PausedJobOpeningsStatus: JobOpeningsStatus = "paused";
export type JobOpeningHealth = 'on_track' | 'off_track' | 'at_risk';
export const OnTrackJobOpeningHealth: JobOpeningHealth = "on_track";
export const OffTrackJobOpeningHealth: JobOpeningHealth = "off_track";
export const AtRiskJobOpeningHealth: JobOpeningHealth = "at_risk";
export type Currency = 'USD' | 'GBP' | 'EUR';
export const USDCurrency: Currency = "USD";
export const GBPCurrency: Currency = "GBP";
export const EURCurrency: Currency = "EUR";
export type JobOpeningCreateMethod = 'manual' | 'import' | 'describe';
export const ManualJobOpeningCreateMethod: JobOpeningCreateMethod = "manual";
export const ImportJobOpeningCreateMethod: JobOpeningCreateMethod = "import";
export const DescribeJobOpeningCreateMethod: JobOpeningCreateMethod = "describe";
export type JobOpeningReasonForOpening = 'new_headcount' | 'backfill';
export const NewHeadcountJobOpeningReasonForOpening: JobOpeningReasonForOpening = "new_headcount";
export const BackfillJobOpeningReasonForOpening: JobOpeningReasonForOpening = "backfill";

//////////
// source: job_opening_role.go

/**
 * JobOpeningRole represents public.job_opening_role
 */
export interface JobOpeningRole {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    name: string;
    skills: number[];
    kind: JobOpeningRoleKind;
    display_onboard?: boolean;
    display_onboard_customer?: boolean;
    display_onboard_applicant?: boolean;
    can_automatch?: boolean;
    can_schedule_meeting?: boolean;
    created_by?: number /* int */;
    last_updated_by?: number /* int */;
}
export type JobOpeningRoleKind = 'engineering' | 'design' | 'other';
export const EngineeringJobOpeningRoleKind: JobOpeningRoleKind = "engineering";
export const DesignJobOpeningRoleKind: JobOpeningRoleKind = "design";
export const OtherJobOpeningRoleKind: JobOpeningRoleKind = "other";

//////////
// source: job_opening_role_store.go


//////////
// source: job_opening_stage.go

/**
 * JobOpeningStage represents public.job_opening_stages
 */
export interface JobOpeningStage {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    name: string;
    kind?: JobOpeningStageKind;
    type?: CustomerStageType;
    order?: number /* int */;
    job_opening_id: number /* int */;
    description?: string;
    interview_duration: number /* int */;
    interviewers: number[];
    record_meetings?: boolean;
    email_template_id?: number /* int */;
    task_email_template_id?: number /* int */;
    task_document_url?: string;
    task_document_id?: number /* int */;
    time_limit?: number /* int */;
    time_limit_unit?: JobOpeningStageTimeLimitUnit;
    interviews?: JSONArray<JobOpeningStageInterview>;
}
export type JobOpeningStageTimeLimitUnit = 'hours' | 'days';
export const HourJobOpeningStageTimeLimitUnit: JobOpeningStageTimeLimitUnit = "hours";
export const DaysJobOpeningStageTimeLimitUnit: JobOpeningStageTimeLimitUnit = "days";

//////////
// source: job_opening_stage_store.go

export interface JobOpeningStageInterview {
    id?: string;
    name: string;
    interview_duration: number /* int */;
    interviewers: number /* int */[];
}
export const InterviewInviteSentStage = "Calendly Invite Sent";
export const InterviewScheduledStage = "TS Interview Scheduled";
export const InterviewCompleteStage = "TS Interview Complete";
export const AIInvitedStage = "AI: Invited";
export const AIStartedStage = "AI: Started";
export const AITimeoutStage = "AI: TimeOut";
export const AIFinishedStage = "AI: Finished";
export const AIFailedStage = "AI: Failed";
export const ReferenceCheckStage = "Reference Check";
export const OnHoldStage = "On Hold";

//////////
// source: job_opening_store.go

export const JobOpeningPauseWindowDays = 14;
export interface JobScoreCard {
    version: number /* int */;
    categories: JobScoreCardCategory[];
    additional_context?: string;
    total_points: number /* int */;
}
export interface JobScoreCardCategory {
    name: string;
    description: string;
    max_points: number /* int */;
    high_score: string;
    low_score: string;
}
export interface JobOpeningHealthChange {
    health: JobOpeningHealth;
    user_id?: number /* int */;
    comment?: string;
    changed_at: string /* RFC3339 */;
}
export type JobOpeningHealthHistory = JobOpeningHealthChange[];
export interface CompanyOwnerChange {
    time: string /* RFC3339 */;
    user_id: number /* int */;
}
export interface OpeningsChange {
    previous_openings?: number /* int */;
    openings: number /* int */;
    reduction_reason?: JobOpeningCloseReason;
}
export interface JobRequirements {
    live_coding_challenge: boolean;
    seniority: SeniorityLevel[];
    required_skills: number /* int */[][];
    optional_skills: number /* int */[];
    /**
     * DEPRECATED: we will use RequiredSkills and OptionalSkills instead.
     */
    skills: number /* int */[][];
    allowed_countries: string[];
    region: Region;
    english_level: EnglishLevel;
    tito_score: number /* int */;
    startup_experience: boolean;
    manager_or_lead: boolean;
}
export type JobOpeningExpansions = JobOpeningExpansion[];
export interface Markers {
    OverBudget: boolean;
    ExtraMatch: boolean;
    ExtraMatchReasons: JobOpeningExpansions;
}
export interface JobOpeningExtended extends JobOpening {
    hiring_manager_email: string;
    hiring_manager_first_name: string;
    hiring_manager_last_name: string;
    hiring_manager_picture: string;
    hiring_manager_scheduling_url: string;
    hiring_manager_video_url: string;
    last_updated_by_full_name?: string;
    company_name: string;
    company_logo: string;
    company_permalink: string;
}
export interface JobOpeningListFilter {
    Field: null /* db.Field */;
    Value: null;
    IsArray: boolean;
    IsIntersect: boolean;
}
export interface JobOpeningStats {
    job_opening_id: number /* int */;
    stage_kind: JobOpeningStageKind;
    count: number /* int */;
}
export interface JobOpeningWithCompanyName {
    id?: number /* int */;
    status?: JobOpeningsStatus;
    title: string;
    company_name: string;
}

//////////
// source: media.go

/**
 * Media represents public.media
 */
export interface Media {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    name: string;
    kind: MediaKind;
    url: string;
}
export type MediaKind = 'video' | 'photo' | 'audio';
export const VideoMediaKind: MediaKind = "video";
export const PhotoMediaKind: MediaKind = "photo";
export const AudioMediaKind: MediaKind = "audio";

//////////
// source: media_store.go


//////////
// source: message.go

/**
 * Message represents public.messages
 */
export interface Message {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    kind?: MessageKind;
    date?: string /* RFC3339 */;
    visibility?: Visibility;
    from_id: number /* int */;
    to_id: number /* int */;
    candidate_id: number /* int */;
    application_id?: number /* int */;
    contract_id?: number /* int */;
    stage_id?: number /* int */;
    content: string;
    subject?: string;
    thread_id?: string;
    origin_id?: string;
    attachments_id: number[];
    plain_content?: string;
}
export type MessageKind = 'email' | 'note';
export const EmailMessageKind: MessageKind = "email";
export const NoteMessageKind: MessageKind = "note";

//////////
// source: message_store.go

export interface MessageWithPoster extends Message {
    poster_first_name: string;
    poster_last_name: string;
    poster_picture: string;
    stage_name?: string;
    stage_kind?: string;
    job_opening_title?: string;
    job_opening_id?: number /* int */;
    company_name?: string;
}

//////////
// source: notification.go

/**
 * Notification represents public.notifications
 */
export interface Notification {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    notification_type: NotificationType;
    user_id?: number /* int */;
    contract_id?: number /* int */;
    customer_id?: number /* int */;
    payload: string;
    read?: boolean;
}
export type NotificationType = 'joined_network' | 'signed_contract' | 'signed_contract_customer' | 'first_day' | 'first_day_customer' | 'invoice_created' | 'invoice_approved' | 'invoice_paid' | 'invoice_submitted' | 'invoice_rejected' | 'customer_invoice_issued' | 'pto_submitted' | 'pto_canceled' | 'pto_approved' | 'pto_approved_manager' | 'pto_rejected' | 'pto_rejected_manager' | 'pto_submitted_customer' | 'expense_submitted' | 'expense_canceled' | 'expense_approved' | 'expense_approved_manager' | 'expense_rejected' | 'expense_rejected_manager' | 'expense_submitted_customer' | 'raise_created' | 'raise_created_manager' | 'bonus_approved' | 'bonus_approved_manager' | 'referral_paid' | 'referral_accepted' | 'job_opening_applied' | 'job_opening_sourced' | 'job_opening_disqualified' | 'job_opening_declined' | 'job_opening_stage_moved' | 'job_opening_feedback' | 'offer_letter_sent' | 'offer_letter_received' | 'offer_letter_rejected' | 'offer_letter_rejected_customer' | 'offer_letter_accepted' | 'offer_letter_accepted_customer' | 'offer_letter_signed' | 'offer_letter_signed_customer' | 'customer_profile_published' | 'job_opening_published' | 'job_opening_candidate_moved_forward' | 'equipment_status_change' | 'bank_account_approved' | 'bank_account_rejected' | 'legal_name_change_approved' | 'legal_name_change_rejected' | 'country_change_approved' | 'country_change_rejected';
export const JoinedNetworkNotificationType: NotificationType = "joined_network";
export const SignedContractNotificationType: NotificationType = "signed_contract";
export const SignedContractCustomerNotificationType: NotificationType = "signed_contract_customer";
export const FirstDayNotificationType: NotificationType = "first_day";
export const FirstDayCustomerNotificationType: NotificationType = "first_day_customer";
export const InvoiceCreatedNotificationType: NotificationType = "invoice_created";
export const InvoiceApprovedNotificationType: NotificationType = "invoice_approved";
export const InvoicePaidNotificationType: NotificationType = "invoice_paid";
export const InvoiceSubmittedNotificationType: NotificationType = "invoice_submitted";
export const InvoiceRejectedNotificationType: NotificationType = "invoice_rejected";
export const CustomerInvoiceIssuedNotificationType: NotificationType = "customer_invoice_issued";
export const PTOSubmittedNotificationType: NotificationType = "pto_submitted";
export const PTOCanceledNotificationType: NotificationType = "pto_canceled";
export const PTOApprovedNotificationType: NotificationType = "pto_approved";
export const PTOApprovedManagerNotificationType: NotificationType = "pto_approved_manager";
export const PTORejectedNotificationType: NotificationType = "pto_rejected";
export const PTORejectedManagerNotificationType: NotificationType = "pto_rejected_manager";
export const PTOSubmittedCustomerNotificationType: NotificationType = "pto_submitted_customer";
export const ExpenseSubmittedNotificationType: NotificationType = "expense_submitted";
export const ExpenseCanceledNotificationType: NotificationType = "expense_canceled";
export const ExpenseApprovedNotificationType: NotificationType = "expense_approved";
export const ExpenseApprovedManagerNotificationType: NotificationType = "expense_approved_manager";
export const ExpenseRejectedNotificationType: NotificationType = "expense_rejected";
export const ExpenseRejectedManagerNotificationType: NotificationType = "expense_rejected_manager";
export const ExpenseSubmittedCustomerNotificationType: NotificationType = "expense_submitted_customer";
export const RaiseCreatedNotificationType: NotificationType = "raise_created";
export const RaiseCreatedManagerNotificationType: NotificationType = "raise_created_manager";
export const BonusApprovedNotificationType: NotificationType = "bonus_approved";
export const BonusApprovedManagerNotificationType: NotificationType = "bonus_approved_manager";
export const ReferralPaidNotificationType: NotificationType = "referral_paid";
export const ReferralAcceptedNotificationType: NotificationType = "referral_accepted";
export const JobOpeningAppliedNotificationType: NotificationType = "job_opening_applied";
export const JobOpeningSourcedNotificationType: NotificationType = "job_opening_sourced";
export const JobOpeningDisqualifiedNotificationType: NotificationType = "job_opening_disqualified";
export const JobOpeningDeclinedNotificationType: NotificationType = "job_opening_declined";
export const JobOpeningStageMovedNotificationType: NotificationType = "job_opening_stage_moved";
export const JobOpeningFeedbackNotificationType: NotificationType = "job_opening_feedback";
export const OfferLetterSentNotificationType: NotificationType = "offer_letter_sent";
export const OfferLetterReceivedNotificationType: NotificationType = "offer_letter_received";
export const OfferLetterRejectedNotificationType: NotificationType = "offer_letter_rejected";
export const OfferLetterRejectedCustomerNotificationType: NotificationType = "offer_letter_rejected_customer";
export const OfferLetterAcceptedNotificationType: NotificationType = "offer_letter_accepted";
export const OfferLetterAcceptedCustomerNotificationType: NotificationType = "offer_letter_accepted_customer";
export const OfferLetterSignedNotificationType: NotificationType = "offer_letter_signed";
export const OfferLetterSignedCustomerNotificationType: NotificationType = "offer_letter_signed_customer";
export const CustomerProfilePublishedNotificationType: NotificationType = "customer_profile_published";
export const JobOpeningPublishedNotificationType: NotificationType = "job_opening_published";
export const JobOpeningCandidateMovedForwardNotificationType: NotificationType = "job_opening_candidate_moved_forward";
export const EquipmentStatusChangeNotificationType: NotificationType = "equipment_status_change";
export const BankAccountApprovedNotificationType: NotificationType = "bank_account_approved";
export const BankAccountRejectedNotificationType: NotificationType = "bank_account_rejected";
export const LegalNameChangeApprovedNotificationType: NotificationType = "legal_name_change_approved";
export const LegalNameChangeRejectedNotificationType: NotificationType = "legal_name_change_rejected";
export const CountryChangeApprovedNotificationType: NotificationType = "country_change_approved";
export const CountryChangeRejectedNotificationType: NotificationType = "country_change_rejected";

//////////
// source: notification_payload.go

export interface SignedContractNotificationPayload {
    company_name: string;
}
export interface SignedContractCustomerNotificationPayload {
    user_id: number /* int */;
    name: string;
    job_opening_id?: number /* int */;
    position: string;
}
export interface FirstDayNotificationPayload {
    company_name: string;
}
export interface FirstDayCustomerNotificationPayload {
    user_id: number /* int */;
    name: string;
    start_date: string;
}
export interface PTONotificationPayload {
    from: string;
    to: string;
    id: number /* int */;
}
export interface PTONotificationManagerPayload {
    from: string;
    to: string;
    id: number /* int */;
    name: string;
}
export interface PTOCustomerNotificationPayload {
    from: string;
    to: string;
    user_id: number /* int */;
    name: string;
    id: number /* int */;
}
export interface ExpenseNotificationPayload {
    kind: string;
    id: number /* int */;
}
export interface ExpenseManagerNotificationPayload {
    kind: string;
    id: number /* int */;
    name?: string;
}
export interface ExpenseCustomerNotificationPayload {
    kind: string;
    id: number /* int */;
    user_id?: number /* int */;
    name?: string;
    company?: string;
}
export interface InvoiceNotificationPayload {
    month: number /* int */;
    id: number /* int */;
}
export interface CustomerInvoiceNotificationPayload {
    month: number /* int */;
    id: number /* int */;
}
export interface RaiseNotificationPayload {
    id: number /* int */;
    salary: number /* float64 */;
    effective_at: string;
}
export interface RaiseManagerNotificationPayload {
    id: number /* int */;
    contractor: string;
}
export interface BonusNotificationPayload {
    id: number /* int */;
    amount: number /* float64 */;
    effective_at: string;
}
export interface BonusManagerNotificationPayload {
    id: number /* int */;
    contractor: string;
}
export interface ReferralAcceptedPayload {
    first_name: string;
    last_name: string;
    referred_id: number /* int */;
}
export interface ReferralPaidPayload {
    referred: string;
    id: number /* int */;
    referred_id: number /* int */;
}
export interface JobOpeningAppliedPayload {
    title: string;
    id: number /* int */;
    permalink: string;
    company: string;
}
export type JobOpeningSourcedPayload = JobOpeningAppliedPayload;
export type JobOpeningDisqualifiedPayload = JobOpeningAppliedPayload;
export type JobOpeningDeclinedPayload = JobOpeningAppliedPayload;
export type JobOpeningFeedbackPayload = JobOpeningAppliedPayload;
export interface JobOpeningStageMovedPayload {
    title: string;
    id: number /* int */;
    permalink: string;
    company: string;
    stage: string;
}
export interface JobOpeningManagerStageMovedPayload {
    title: string;
    id: number /* int */;
    permalink: string;
    company_id: number /* int */;
    stage: string;
    name: string;
    application_id: number /* int */;
}
export interface OfferLetterPayload {
    company: string;
    title?: string;
    id: number /* int */;
    start_date?: string;
}
export interface OfferLetterCustomerPayload {
    user_id: number /* int */;
    name: string;
    id: number /* int */;
    job_opening_id?: number /* int */;
    position: string;
}
export interface CustomerProfilePublishedPayload {
    id: number /* int */;
    permalink: string;
}
export interface JobOpeningPayload {
    title: string;
    id: number /* int */;
    permalink: string;
}
export interface EquipmentPayload {
    status: string;
    brand: string;
    model: string;
    contractor: string;
}
export interface BankAccountReviewPayload {
    bank_account_id: number /* int */;
    account_number: string;
}

//////////
// source: offer_letter.go

/**
 * OfferLetter represents public.offer_letters
 */
export interface OfferLetter {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    customer_id: number /* int */;
    job_opening_id?: number /* int */;
    application_id?: number /* int */;
    contact_id: number /* int */;
    user_id?: number /* int */;
    contract_id?: number /* int */;
    created_by?: number /* int */;
    status?: OfferLetterStatus;
    relation?: ContractRelation;
    email: string;
    email_normalized?: string;
    first_name: string;
    last_name: string;
    nickname?: string;
    role?: string;
    description?: string;
    start_date: string /* RFC3339 */;
    termination_date?: string /* RFC3339 */;
    fee_type?: FeeType;
    salary?: number;
    rate?: number;
    options?: string;
    approved_at?: string /* RFC3339 */;
    sent_at?: string /* RFC3339 */;
    accepted_at?: string /* RFC3339 */;
    code_of_conduct_accepted_at?: string /* RFC3339 */;
    code_of_conduct_rejected_at?: string /* RFC3339 */;
    signed_at?: string /* RFC3339 */;
    referree_id?: number /* int */;
    referral_amount?: number;
    phone_number?: string;
    address?: LegalAddress;
    customer_sourced?: boolean;
    document_id?: number /* int */;
    talent_managers: number[];
    benefits?: ContractBenefits;
    management_fee?: number;
    work_type?: WorkType;
    expiration_days?: number /* int */;
    special_clause?: string;
    contracting_entity_id?: number /* int */;
    group_id?: number /* int */;
    reason_for_hiring?: JobOpeningReasonForOpening;
    background_check?: boolean;
}
export type OfferLetterStatus = 'draft' | 'approved' | 'sent' | 'accepted' | 'rejected' | 'signed';
export const DraftOfferLetterStatus: OfferLetterStatus = "draft";
export const ApprovedOfferLetterStatus: OfferLetterStatus = "approved";
export const SentOfferLetterStatus: OfferLetterStatus = "sent";
export const AcceptedOfferLetterStatus: OfferLetterStatus = "accepted";
export const RejectedOfferLetterStatus: OfferLetterStatus = "rejected";
export const SignedOfferLetterStatus: OfferLetterStatus = "signed";

//////////
// source: offer_letter_store.go


//////////
// source: ops_approval.go

/**
 * OpsApproval represents public.ops_approvals
 */
export interface OpsApproval {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    type: OpsApprovalType;
    status?: OpsApprovalStatus;
    user_id: number /* int */;
    entity_id: number /* int */;
    summary: string;
    reviewed_by?: number /* int */;
    reviewed_at?: string /* RFC3339 */;
    rejection_reason?: string;
}
export type OpsApprovalType = 'bank_account_mismatch' | 'country_change';
export const BankAccountMismatchOpsApprovalType: OpsApprovalType = "bank_account_mismatch";
export const CountryChangeOpsApprovalType: OpsApprovalType = "country_change";
export type OpsApprovalStatus = 'pending' | 'approved' | 'rejected';
export const PendingOpsApprovalStatus: OpsApprovalStatus = "pending";
export const ApprovedOpsApprovalStatus: OpsApprovalStatus = "approved";
export const RejectedOpsApprovalStatus: OpsApprovalStatus = "rejected";

//////////
// source: payment.go

/**
 * Payment represents public.payments
 */
export interface Payment {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    emitted_at?: string /* RFC3339 */;
    paid_at?: string /* RFC3339 */;
    returned_at?: string /* RFC3339 */;
    expired_at?: string /* RFC3339 */;
    user_id: number /* int */;
    status?: PaymentStatus;
    contractor_invoice_id: number /* int */;
    bank_account_id: number /* int */;
    currency?: string;
    amount: number;
    beneficiary_id?: string;
    payment_id?: string;
    country?: string;
    nium_response?: string;
    nium_payment_data?: NiumPaymentData;
    document_id?: number /* int */;
    emitted_by?: number /* int */;
}
export type PaymentStatus = 'draft' | 'pending' | 'error' | 'emitted' | 'returned' | 'expired' | 'paid' | 'emitting';
export const DraftPaymentStatus: PaymentStatus = "draft";
export const PendingPaymentStatus: PaymentStatus = "pending";
export const ErrorPaymentStatus: PaymentStatus = "error";
export const EmittedPaymentStatus: PaymentStatus = "emitted";
export const ReturnedPaymentStatus: PaymentStatus = "returned";
export const ExpiredPaymentStatus: PaymentStatus = "expired";
export const PaidPaymentStatus: PaymentStatus = "paid";
export const EmittingPaymentStatus: PaymentStatus = "emitting";

//////////
// source: payment_store.go

export type PaymentHistory = PaymentAttempt[];
export interface PaymentAttempt {
    emitted_at: string /* RFC3339 */;
    emitted_by?: number /* int */;
    failed_at: string /* RFC3339 */;
    beneficiary_id: string;
    status: PaymentStatus;
    bank_account_id: number /* int */;
    payment_id: string;
    nium_response?: string;
}
export interface NiumPaymentData {
    transaction_currency: string;
    transaction_amount: string;
    system_reference_number: string;
    exchange_rate: string;
    beneficiary_name: string;
    beneficiary_account_number: string;
    beneficiary_bank_name: string;
    billing_currency: string;
    billing_amount: string;
    tags: NiumPaymentDataTags[];
}
export interface NiumPaymentDataTags {
    key: string;
    value: string;
}

//////////
// source: pricing_fee.go

/**
 * PricingFee represents public.pricing_fees
 */
export interface PricingFee {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    name?: string;
    type: PricingFeeType;
    customer_id: number /* int */;
    kind: PricingFeeKind;
    start_date: string /* RFC3339 */;
    end_date?: string /* RFC3339 */;
    base_fee: PricingBaseFee;
    discounts?: PricingDiscounts;
    comments?: string;
}
export type PricingFeeType = 'standard' | 'startup' | 'custom' | 'flat' | 'per_position' | 'per_position_capped' | 'free';
export const StandardPricingFeeType: PricingFeeType = "standard";
export const StartupPricingFeeType: PricingFeeType = "startup";
export const CustomPricingFeeType: PricingFeeType = "custom";
export const FlatPricingFeeType: PricingFeeType = "flat";
export const PerPositionPricingFeeType: PricingFeeType = "per_position";
export const PerPositionCappedPricingFeeType: PricingFeeType = "per_position_capped";
export const FreePricingFeeType: PricingFeeType = "free";
export type PricingFeeKind = 'management' | 'open_position';
export const ManagementPricingFeeKind: PricingFeeKind = "management";
export const OpenPositionPricingFeeKind: PricingFeeKind = "open_position";

//////////
// source: pricing_fee_store.go

/**
 * BaseFeeType defines the type of base fee.
 */
export type BaseFeeType = string;
/**
 * FlatBaseFeeType is a flat amount that will be charged as a base fee.
 */
export const FlatBaseFeeType: BaseFeeType = "flat";
/**
 * PercentageBaseFeeType is a percentage of a value that will be charged as a base fee.
 */
export const PercentageBaseFeeType: BaseFeeType = "percentage";
/**
 * PricingBaseFee defines how the base fee gets calculated.
 */
export interface PricingBaseFee {
    /**
     * Type of base fee.
     */
    type: BaseFeeType;
    /**
     * Value may be a flat rate or a percentage.
     */
    fee: number;
    /**
     * PerItem specifies whether this pricing is per item or global on pricing fee types
     * that support this mode (open positions only at the moment).
     */
    per_item?: boolean;
    /**
     * Cap is used to specify a max number of items to take into account if
     * PerItem is true.
     */
    cap?: number /* int */;
}
/**
 * PricingDiscounts is the list of pricing discounts for a pricing fee.
 */
export type PricingDiscounts = PricingDiscount[];
/**
 * DiscountApplyParams contains some parameters needed to calculate
 * discounts depending on the type of discounts.
 */
export interface DiscountApplyParams {
    /**
     * ContractorNumber is the 1-indexed ordinal with the position the contractor
     * joined the company for the current list of active contracts.
     * For example, the 1st contractor is 1, the 2nd is 2, and so on.
     */
    ContractorNumber: number /* int */; // only applies for flat volume discounts
    /**
     * MonthlySalary is the contractor's monthly salary.
     */
    MonthlySalary: number; // only applies for salary discounts
    /**
     * OriginalMonthlySalary is the contractor's original monthly salary.
     */
    OriginalMonthlySalary: number; // only applies for salary discounts
    /**
     * Role of the contractor.
     */
    Role: JobOpeningRoleKind; // only applies for role discounts
    /**
     * CustomerSourced is whether the customer sourced the contractor.
     */
    CustomerSourced: boolean; // only applies for sourced discounts
    /**
     * MonthsWorked is the number of months the contractor has been working.
     */
    MonthsWorked: number /* int */; // only applies for tenure discounts
    /**
     * ActiveContractors in the company.
     */
    ActiveContractors: number /* int */; // only applies for percentage volume discounts
    /**
     * Month for which we are calculating the discount.
     */
    Month: number;
    /**
     * Year for which we are calculating the discount.
     */
    Year: number /* int */;
}
export type DiscountPercentages = DiscountPercentage[];
export interface DiscountPercentage {
    Type: PricingDiscountType;
    Value: number;
}
/**
 * PricingDiscountType is the type of the discount for a pricing fee.
 */
export type PricingDiscountType = string;
/**
 * TenurePricingDiscountType is a discount based on contractor tenure.
 */
export const TenurePricingDiscountType: PricingDiscountType = "tenure";
/**
 * VolumePricingDiscountType is a discount based on contractor volume.
 */
export const VolumePricingDiscountType: PricingDiscountType = "volume";
/**
 * SalaryPricingDiscountType is a discount based on contractor salary.
 */
export const SalaryPricingDiscountType: PricingDiscountType = "salary";
/**
 * RolePricingDiscountType is a discount based on the contractor role.
 */
export const RolePricingDiscountType: PricingDiscountType = "role";
/**
 * SourcedPricingDiscountType is a discount based on whether the contractor was sourced
 * by the customer.
 */
export const SourcedPricingDiscountType: PricingDiscountType = "sourced";
/**
 * Global discount types
 */
/**
 * PercentagePricingDiscountType is a % discount.
 */
export const PercentagePricingDiscountType: PricingDiscountType = "percentage";
/**
 * DiscountFeeType is the type of discount over the fee.
 */
export type DiscountFeeType = string;
/**
 * FlatDiscountFeeType replaces the previous fee if lower.
 */
export const FlatDiscountFeeType: DiscountFeeType = "flat";
/**
 * PercentageDiscountFeeType reduces the fee the specified %.
 */
export const PercentageDiscountFeeType: DiscountFeeType = "percentage";
/**
 * PricingDiscount defines a discount over a pricing fee.
 */
export interface PricingDiscount extends BasePricingDiscount {
    discount: FeeDiscount;
}
/**
 * BasePricingDiscount defines all base fields of a pricing discount.
 */
export interface BasePricingDiscount {
    /**
     * Type of discount.
     */
    type: PricingDiscountType;
    /**
     * StartDate defines when this discount starts being effective.
     * If empty, the pricing start date will take effect.
     */
    start_date?: string /* RFC3339 */;
    /**
     * EndDate defines when this discount stops being effective.
     * If empty, the discount will never stop.
     */
    end_date?: string /* RFC3339 */;
}
/**
 * DiscountTier is a tier of a tiered discount with a value and a start
 * and end, which is optional.
 */
export interface DiscountTier<T extends number /* int */> {
    from: T;
    to?: T;
    value: number;
}
/**
 * TieredDiscount is a discount that depends on defined tiers to calculate
 * the discount.
 */
export interface TieredDiscount<T extends number /* int */> {
    /**
     * Type specifies whether the discount is a percentage or flat rate.
     */
    type: DiscountFeeType;
    /**
     * Tiers definitions.
     */
    tiers: DiscountTier<T>[];
}
export type TenureDiscount = TieredDiscount<number /* int */>;
export type VolumeDiscount = TieredDiscount<number /* int */>;
export type SalaryDiscount = SalaryDiscountTier[];
export interface SalaryDiscountTier {
    starting: number;
    max: number;
    value: number;
}
/**
 * RoleDiscount keeps a record from a role kind to a flat rate.
 */
export interface RoleDiscount {
    roles: Partial<Record<JobOpeningRoleKind, number>>;
}
/**
 * SourcedDiscount applies a flat rate to sourced contractors.
 */
export interface SourcedDiscount {
    value: number;
}
/**
 * PercentageDiscount is a discount of a certain %.
 */
export interface PercentageDiscount {
    value: number;
}
export type FeeDiscount = TenureDiscount | VolumeDiscount | SalaryDiscount | RoleDiscount | SourcedDiscount | PercentageDiscount;

//////////
// source: pto_policy.go

/**
 * PTOPolicy represents public.pto_policies
 */
export interface PTOPolicy {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    customer_id: number /* int */;
    name: string;
    status?: PTOPolicyStatus;
    start_date?: string /* RFC3339 */;
    end_date?: string /* RFC3339 */;
    countries: string[];
    description?: string;
    kind: PTOPolicyKind;
    number?: number /* int */;
    calendars?: PTOPolicyCalendars;
    last_updated_by?: number /* int */;
    carryover?: number /* int */;
    carryover_expiration?: CarryoverExpiration;
    structure: PTOPolicyStructure;
}
export type PTOPolicyStatus = 'active' | 'inactive';
export const ActivePTOPolicyStatus: PTOPolicyStatus = "active";
export const InactivePTOPolicyStatus: PTOPolicyStatus = "inactive";
export type PTOPolicyKind = 'PTO' | 'Holiday' | 'Sick' | 'Other';
export const PTOPTOPolicyKind: PTOPolicyKind = "PTO";
export const HolidayPTOPolicyKind: PTOPolicyKind = "Holiday";
export const SickPTOPolicyKind: PTOPolicyKind = "Sick";
export const OtherPTOPolicyKind: PTOPolicyKind = "Other";
export type PTOPolicyStructure = 'fixed_number' | 'unlimited' | 'local_holidays' | 'us_only';
export const FixedNumberPTOPolicyStructure: PTOPolicyStructure = "fixed_number";
export const UnlimitedPTOPolicyStructure: PTOPolicyStructure = "unlimited";
export const LocalHolidayPTOPolicyStructure: PTOPolicyStructure = "local_holidays";
export const UsOnlyPTOPolicyStructure: PTOPolicyStructure = "us_only";

//////////
// source: pto_policy_store.go

export type PTOPolicyCalendars = Partial<Record<string, PTOPolicyDate[]>>;
export interface PTOPolicyDate {
    holiday_id?: number /* int */;
    name: string;
    dates: string /* RFC3339 */[];
}
export interface CarryoverExpiration {
    month: number;
    day: number /* int */;
}

//////////
// source: pto_request.go

/**
 * PTORequest represents public.pto_requests
 */
export interface PTORequest {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    contract_id: number /* int */;
    contract_pto_id: number /* int */;
    status?: PTORequestStatus;
    days: number /* float64 */;
    start: string /* RFC3339 */;
    end: string /* RFC3339 */;
    comments?: string;
    reviewed_at?: string /* RFC3339 */;
    reviewer_id?: number /* int */;
}
export type PTORequestStatus = 'pending' | 'approved' | 'rejected' | 'canceled' | 'expired';
export const PendingPTORequestStatus: PTORequestStatus = "pending";
export const ApprovedPTORequestStatus: PTORequestStatus = "approved";
export const RejectedPTORequestStatus: PTORequestStatus = "rejected";
export const CanceledPTORequestStatus: PTORequestStatus = "canceled";
export const ExpiredPTORequestStatus: PTORequestStatus = "expired";

//////////
// source: pto_request_store.go

export interface CustomerPTORequest {
    id: number /* int */;
    created_at: string /* RFC3339 */;
    user_id: number /* int */;
    first_name: string;
    last_name: string;
    picture: string;
    status?: PTORequestStatus;
    days: number /* float64 */;
    start: string /* RFC3339 */;
    end: string /* RFC3339 */;
    comments?: string;
    approved_days: number /* float64 */;
    adjusted_days: PTOAdjustedDays;
    pto_name: string;
    pto_kind: PTOPolicyKind;
    pto_days?: number /* int */;
    carryover_days?: PTOCarryoverDays;
    reviewer_id?: number /* int */;
    contract_id: number /* int */;
    contract_pto_id: number /* int */;
}
export interface PTORequestInfo {
    ID: number /* int */;
    CreatedAt: string /* RFC3339 */;
    UpdatedAt: string /* RFC3339 */;
    PolicyName: string;
    Status: PTORequestStatus;
    Start: string /* RFC3339 */;
    End: string /* RFC3339 */;
    Comments: null /* sql.NullString */;
    FirstName: string;
    LastName: string;
    Email: string;
}

//////////
// source: raise.go

/**
 * Raise represents public.raises
 */
export interface Raise {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    status?: RaiseStatus;
    contract_id: number /* int */;
    created_by?: number /* int */;
    comment: string;
    effective_at: string /* RFC3339 */;
    old: number;
    new: number;
    deposit_id?: number /* int */;
    reviewed_at?: string /* RFC3339 */;
    reviewer_id?: number /* int */;
}
export type RaiseStatus = 'pending' | 'approved' | 'rejected';
export const PendingRaiseStatus: RaiseStatus = "pending";
export const ApprovedRaiseStatus: RaiseStatus = "approved";
export const RejectedRaiseStatus: RaiseStatus = "rejected";

//////////
// source: recommendation.go

/**
 * Recommendation represents public.recommendations
 */
export interface Recommendation {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    candidate_id: number /* int */;
    full_name: string;
    company_name: string;
    linkedin_url: string;
    description: string;
}

//////////
// source: recording.go

/**
 * Recording represents public.recordings
 */
export interface Recording {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    source: RecordingSource;
    kind: RecordingKind;
    name?: string;
    source_id: string;
    candidate_id?: number /* int */;
    customer_id?: number /* int */;
    interviewer?: number /* int */;
    participant_users?: number[];
    participant_emails?: string[];
    recording_url?: string;
    transcript_url?: string;
    metadata?: null /* json.RawMessage */;
    calendar_event_id?: number /* int */;
    permalink?: string;
    started_at?: string /* RFC3339 */;
    file_urls?: string[];
    duration?: number /* int */;
}
export type RecordingSource = 'zoom' | 'meet' | 'daily' | 'mux' | 'grain' | 'elevenlabs';
export const ZoomRecordingSource: RecordingSource = "zoom";
export const MeetRecordingSource: RecordingSource = "meet";
export const DailyRecordingSource: RecordingSource = "daily";
export const MuxRecordingSource: RecordingSource = "mux";
export const GrainRecordingSource: RecordingSource = "grain";
export const ElevenlabRecordingSource: RecordingSource = "elevenlabs";
export type RecordingKind = 'meeting' | 'interview' | 'other';
export const MeetingRecordingKind: RecordingKind = "meeting";
export const InterviewRecordingKind: RecordingKind = "interview";
export const OtherRecordingKind: RecordingKind = "other";

//////////
// source: recording_store.go

export interface RecordingMetadata {
    data: RecordingMetadataData;
    manual?: boolean;
}
export interface RecordingMetadataData {
    url: string;
}

//////////
// source: reference_contact.go

/**
 * ReferenceContact represents public.reference_contacts
 */
export interface ReferenceContact {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    user_id: number /* int */;
    candidate_id: number /* int */;
    first_name: string;
    last_name: string;
    email: string;
    phone?: string;
    linkedin_url: string;
    company_name: string;
    company_url: string;
    country?: string;
    current_company_name?: string;
    current_company_url?: string;
    relationship: ReferenceContactRelationship;
    relationship_other?: string;
    contact_data?: ReferenceContactData;
    referee_data?: ReferenceContactRefereeData;
    reviewed_by?: number /* int */;
    reviewed_at?: string /* RFC3339 */;
    status?: ReferenceContactStatus;
    status_updated_at?: string /* RFC3339 */;
    company_hubspot_id?: string;
    current_company_hubspot_id?: string;
    public?: boolean;
    contacted_at?: string /* RFC3339 */;
    legacy_text?: string;
    legacy?: boolean;
    video_url?: string;
    permalink: string;
}
export type ReferenceContactRelationship = 'direct_manager' | 'more_senior_team_member' | 'peer' | 'direct_report' | 'same_company_different_team' | 'other';
export const DirectManagerReferenceContactRelationship: ReferenceContactRelationship = "direct_manager";
export const MoreSeniorTeamMemberReferenceContactRelationship: ReferenceContactRelationship = "more_senior_team_member";
export const PeerReferenceContactRelationship: ReferenceContactRelationship = "peer";
export const DirectReportReferenceContactRelationship: ReferenceContactRelationship = "direct_report";
export const SameCompanyDifferentTeamReferenceContactRelationship: ReferenceContactRelationship = "same_company_different_team";
export const OtherReferenceContactRelationship: ReferenceContactRelationship = "other";
export type ReferenceContactStatus = 'contact_provided' | 'contacted' | 'timeout' | 'needs_review' | 'reference_provided' | 'rejected';
export const ContactProvidedReferenceContactStatus: ReferenceContactStatus = "contact_provided";
export const ContactedReferenceContactStatus: ReferenceContactStatus = "contacted";
export const TimeoutReferenceContactStatus: ReferenceContactStatus = "timeout";
export const NeedsReviewReferenceContactStatus: ReferenceContactStatus = "needs_review";
export const ReferenceProvidedReferenceContactStatus: ReferenceContactStatus = "reference_provided";
export const RejectedReferenceContactStatus: ReferenceContactStatus = "rejected";

//////////
// source: reference_contact_store.go

export const RequiredReferences = 2;
export type ReferenceCompanyLeaveReason = string;
export const ProjectEndedReferenceCompanyLeaveReason: ReferenceCompanyLeaveReason = "project_ended";
export const RelocatedReferenceCompanyLeaveReason: ReferenceCompanyLeaveReason = "relocated";
export const NewOpportunityReferenceCompanyLeaveReason: ReferenceCompanyLeaveReason = "new_opportunity";
export const RedundancyReferenceCompanyLeaveReason: ReferenceCompanyLeaveReason = "redundancy";
export const AskedToLeaveReferenceCompanyLeaveReason: ReferenceCompanyLeaveReason = "asked_to_leave";
export const OtherReferenceCompanyLeaveReason: ReferenceCompanyLeaveReason = "other";
export type StressfulSituationReaction = string;
export const CalmStressfulSituationReaction: StressfulSituationReaction = "calm";
export const PanicsStressfulSituationReaction: StressfulSituationReaction = "panics";
export const TimeToAdjustStressfulSituationReaction: StressfulSituationReaction = "time_to_adjust";
export const AdaptsQuicklyStressfulSituationReaction: StressfulSituationReaction = "adapts_quickly";
export const OtherStressfulSituationReaction: StressfulSituationReaction = "other";
export type WouldRehireOption = string;
export const YesWouldRehireOption: WouldRehireOption = "yes";
export const NoWouldRehireOption: WouldRehireOption = "no";
export const NotSureWouldRehireOption: WouldRehireOption = "not_sure";
export interface ReferenceContactData extends ReferenceCompanyData {
    first_name: string;
    last_name: string;
    email: string;
    linkedin_url: string;
    phone: string;
}
export interface ReferenceCompanyData {
    company_name: string;
    company_url: string;
    company_role: string;
    worked_from: number /* int */;
    worked_to: number /* int */;
    relationship: ReferenceContactRelationship;
    relationship_other: string;
}
export interface ReferenceContactRefereeData extends ReferenceCompanyData {
    first_name: string;
    last_name: string;
    email: string;
    picture: string;
    company_leave_reason: ReferenceCompanyLeaveReason;
    company_leave_reason_other: string;
    culture_thrive: string;
    culture_challenging: string;
    project_excelled: string;
    ideal_role: string;
    work_ethic: string;
    stressful_situation_reaction: StressfulSituationReaction;
    stressful_situation_reaction_other: string;
    areas_of_improvement: string;
    would_rehire: WouldRehireOption;
}

//////////
// source: referral.go

/**
 * Referral represents public.referrals
 */
export interface Referral {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    user_id: number /* int */;
    referrer_id: number /* int */;
    job_opening_id?: number /* int */;
    contract_id?: number /* int */;
    status?: ReferralStatus;
    payment_status?: ReferralPaymentStatus;
    due_at?: string /* RFC3339 */;
    notified_pending_at?: string /* RFC3339 */;
    notified_due_at?: string /* RFC3339 */;
    notified_paid_at?: string /* RFC3339 */;
    paid_at?: string /* RFC3339 */;
    amount?: number;
    reason?: string;
    contractor_invoice_id?: number /* int */;
    referrer_customer_id?: number /* int */;
}
export type ReferralStatus = 'pending' | 'invite_sent' | 'interview_scheduled' | 'network_accepted' | 'contractor' | 'disqualified' | 'paid';
export const PendingReferralStatus: ReferralStatus = "pending";
export const InviteSentReferralStatus: ReferralStatus = "invite_sent";
export const InterviewScheduledReferralStatus: ReferralStatus = "interview_scheduled";
export const NetworkAcceptedReferralStatus: ReferralStatus = "network_accepted";
export const ContractorReferralStatus: ReferralStatus = "contractor";
export const DisqualifiedReferralStatus: ReferralStatus = "disqualified";
export const PaidReferralStatus: ReferralStatus = "paid";
export type ReferralPaymentStatus = 'pending' | 'due' | 'invoiced' | 'canceled' | 'paid';
export const PendingReferralPaymentStatus: ReferralPaymentStatus = "pending";
export const DueReferralPaymentStatus: ReferralPaymentStatus = "due";
export const InvoicedReferralPaymentStatus: ReferralPaymentStatus = "invoiced";
export const CanceledReferralPaymentStatus: ReferralPaymentStatus = "canceled";
export const PaidReferralPaymentStatus: ReferralPaymentStatus = "paid";

//////////
// source: referral_store.go

export const ReferralPaymentDays = 90;

//////////
// source: schema.go


//////////
// source: security_deposit.go

/**
 * SecurityDeposit represents public.security_deposits
 */
export interface SecurityDeposit {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    customer_id: number /* int */;
    contract_id: number /* int */;
    amount: number;
    status: SecurityDepositStatus;
    periodicity: SecurityDepositPeriodicity;
    year: number /* int */;
    month?: number /* int */;
    billed_at?: string /* RFC3339 */;
    paid_at?: string /* RFC3339 */;
    refunded_at?: string /* RFC3339 */;
    invoice_line_id?: number /* int */;
    refunded_invoice_line_id?: number /* int */;
    comments?: string;
}
export type SecurityDepositStatus = 'invoiced' | 'paid' | 'refund_invoiced' | 'refunded';
export const InvoicedSecurityDepositStatus: SecurityDepositStatus = "invoiced";
export const PaidSecurityDepositStatus: SecurityDepositStatus = "paid";
export const RefundInvoicedSecurityDepositStatus: SecurityDepositStatus = "refund_invoiced";
export const RefundedSecurityDepositStatus: SecurityDepositStatus = "refunded";
export type SecurityDepositPeriodicity = 'yearly' | 'monthly';
export const YearlySecurityDepositPeriodicity: SecurityDepositPeriodicity = "yearly";
export const MonthlySecurityDepositPeriodicity: SecurityDepositPeriodicity = "monthly";

//////////
// source: slack_notification.go

/**
 * SlackNotification represents public.slack_notifications
 */
export interface SlackNotification {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    kind: SlackNotificationKind;
    user_id?: number /* int */;
    channel: string;
    metadata?: Metadata;
}
export type SlackNotificationKind = 'customer_pipeline' | 'customer_new_job' | 'customer_submission' | 'customer_submission_too_long' | 'contractor_invoice' | 'network_new_jobs';
export const CustomerPipelineSlackNotificationKind: SlackNotificationKind = "customer_pipeline";
export const CustomerNewJobSlackNotificationKind: SlackNotificationKind = "customer_new_job";
export const CustomerSubmissionSlackNotificationKind: SlackNotificationKind = "customer_submission";
export const CustomerSubmissionTooLongSlackNotificationKind: SlackNotificationKind = "customer_submission_too_long";
export const ContractorInvoiceSlackNotificationKind: SlackNotificationKind = "contractor_invoice";
export const NetworkNewJobSlackNotificationKind: SlackNotificationKind = "network_new_jobs";

//////////
// source: startup_application.go

/**
 * StartupApplication represents public.startup_applications
 */
export interface StartupApplication {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    token: string;
    company_name?: string;
    applied_at?: string /* RFC3339 */;
    scheduled_at?: string /* RFC3339 */;
    requested_link_at?: string /* RFC3339 */;
    sent_link_at?: string /* RFC3339 */;
    sent_reminder_at?: string /* RFC3339 */;
    status?: StartupApplicationStatus;
    hiring_plan?: StartupHiringPlan;
    info?: StartupInfo;
    crunchbase_info?: CrunchBaseInfo;
    contact_id: number /* int */;
    domain: string;
    crunchbase_id?: string;
    hubspot_id?: string;
    referred_by?: number /* int */;
    referred_by_customer?: number /* int */;
    source?: string;
    marketing?: Marketing;
    customer_id?: number /* int */;
    hubspot_deal_id?: string;
}
export type StartupApplicationStatus = 'draft' | 'submitted' | 'scheduled' | 'approved' | 'rejected';
export const DraftStartupApplicationStatus: StartupApplicationStatus = "draft";
export const SubmittedStartupApplicationStatus: StartupApplicationStatus = "submitted";
export const ScheduledStartupApplicationStatus: StartupApplicationStatus = "scheduled";
export const ApprovedStartupApplicationStatus: StartupApplicationStatus = "approved";
export const RejectedStartupApplicationStatus: StartupApplicationStatus = "rejected";

//////////
// source: startup_application_data.go

export type StartupSector = string;
export const HealthTechSector: StartupSector = "health";
export const DeveloperSector: StartupSector = "developer";
export const FintechSector: StartupSector = "fintech";
export const MarTechSector: StartupSector = "martech";
export const RealEstateSector: StartupSector = "real_estate";
export const SaaSSector: StartupSector = "saas";
export const GamesSector: StartupSector = "games";
export const TransportationSector: StartupSector = "transportation";
export const OtherSector: StartupSector = "other";
export interface StartupInfo {
    url: string;
    market: Market;
    sectors: StartupSector[];
    raised: number /* int */;
    raised_at: string /* RFC3339 */;
    hq: string;
    employees: EmployeesRange;
}
export interface RoleHiringPlan {
    engineers: number /* int */;
    stack: string[];
}
export type TimezoneOverlap = string;
export const FullTimezoneOverlap: TimezoneOverlap = "full";
export const PartialTimezoneOverlap: TimezoneOverlap = "partial";
export const NoneTimezoneOverlap: TimezoneOverlap = "none";
export interface StartupHiringPlan {
    current_engineers: number /* int */;
    stack: string[];
    hiring: Partial<Record<number /* int */, RoleHiringPlan>>;
    hiring_other: string;
    timezone_overlap: TimezoneOverlap;
    message: string;
    referral_source: string;
}
export type CrunchBaseInfo = Record<string, any>;

//////////
// source: tag.go

/**
 * Tag represents public.tags
 */
export interface Tag {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    name: string;
    slug: string;
    category?: TagCategory;
    merged_with?: number /* int */;
    alternatives: string[];
    children?: number[];
    created_by?: number /* int */;
}
export type TagCategory = 'skill' | 'sector' | 'investor' | 'expertise' | 'other';
export const SkillTagCategory: TagCategory = "skill";
export const SectorTagCategory: TagCategory = "sector";
export const InvestorTagCategory: TagCategory = "investor";
export const ExpertiseTagCategory: TagCategory = "expertise";
export const OtherTagCategory: TagCategory = "other";

//////////
// source: tag_store.go


//////////
// source: take_home_assignment.go

/**
 * TakeHomeAssignment represents public.take_home_assignments
 */
export interface TakeHomeAssignment {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    stage_id: number /* int */;
    application_id: number /* int */;
    created_by?: number /* int */;
    last_updated_by?: number /* int */;
    url?: string;
    document_id?: number /* int */;
}

//////////
// source: task.go

/**
 * Task represents public.tasks
 */
export interface Task {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    status?: TaskStatus;
    creator_id: number /* int */;
    owner_id: number /* int */;
    candidate_id: number /* int */;
    title: string;
    description: string;
    due_at: string /* RFC3339 */;
    remind_at: string /* RFC3339 */;
    reminded_at?: string /* RFC3339 */;
    flags?: Flags;
}
export type TaskStatus = 'pending' | 'reminded' | 'done';
export const PendingTaskStatus: TaskStatus = "pending";
export const RemindedTaskStatus: TaskStatus = "reminded";
export const DoneTaskStatus: TaskStatus = "done";

//////////
// source: task_store.go

export type Flags = Partial<Record<string, null>>;

//////////
// source: token.go

/**
 * Token represents public.tokens
 */
export interface Token {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    token_type: TokenType;
    token: string;
    expires_at: string /* RFC3339 */;
    user_id: number /* int */;
    refresh_token?: string;
    user_ip?: string;
    original_user_id?: number /* int */;
}
export type TokenType = 'auth' | 'login' | 'access';
export const AuthTokenType: TokenType = "auth";
export const LoginTokenType: TokenType = "login";
export const AccesTokenType: TokenType = "access";

//////////
// source: two_factor_auth_config.go

/**
 * TwoFactorAuthConfig represents public.two_factor_auth_configs
 */
export interface TwoFactorAuthConfig {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    user_id: number /* int */;
    method: TwoFactorAuthMethod;
    secret: string;
    url?: string;
    verified?: boolean;
}
export type TwoFactorAuthMethod = 'totp';
export const TotpTwoFactorAuthMethod: TwoFactorAuthMethod = "totp";

//////////
// source: user.go

/**
 * User represents public.users
 */
export interface User {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    status?: UserStatus;
    roles: Roles;
    first_name: string;
    last_name: string;
    nickname?: string;
    legal_first_name?: string;
    legal_last_name?: string;
    email: string;
    email_normalized?: string;
    phone?: string[];
    phone_unnormalized?: string[];
    picture?: string;
    country?: string;
    personal_info?: PersonalInfo;
    customer_id?: number /* int */;
    slack_network_id?: string;
    remotely_slack_id?: string;
    referral_slug?: string;
    hubspot_id?: string;
    hubspot_info?: HubspotInfo;
    im_agent_id?: string;
    require_2fa?: boolean;
    time_zone?: string;
    settings?: UserSettings;
    first_login_at?: string /* RFC3339 */;
    last_login_at?: string /* RFC3339 */;
    previous_login_at?: string /* RFC3339 */;
    picture_source?: PictureSource;
}
export type UserStatus = 'active' | 'inactive' | 'anonymization_pending' | 'anonymization_failed' | 'anonymization_complete';
export const ActiveUserStatus: UserStatus = "active";
export const InactiveUserStatus: UserStatus = "inactive";
export const AnonymizationPendingUserStatus: UserStatus = "anonymization_pending";
export const AnonymizationFailedUserStatus: UserStatus = "anonymization_failed";
export const AnonymizationCompleteUserStatus: UserStatus = "anonymization_complete";
export type UserRole = 'talent_lead' | 'applicant' | 'candidate' | 'contractor' | 'customer' | 'customer_interviewer' | 'customer_lead' | 'customer_manager' | 'customer_recruiter' | 'admin' | 'talent' | 'talent_manager' | 'talent_operations' | 'talent_freelancer' | 'accounting' | 'superadmin' | 'app';
export const TalentLeadUserRole: UserRole = "talent_lead";
export const ApplicantUserRole: UserRole = "applicant";
export const CandidateUserRole: UserRole = "candidate";
export const ContractorUserRole: UserRole = "contractor";
export const CustomerUserRole: UserRole = "customer";
export const CustomerInterviewerUserRole: UserRole = "customer_interviewer";
export const CustomerLeadUserRole: UserRole = "customer_lead";
export const CustomerManagerUserRole: UserRole = "customer_manager";
export const CustomerRecruiterUserRole: UserRole = "customer_recruiter";
export const AdminUserRole: UserRole = "admin";
export const TalentUserRole: UserRole = "talent";
export const TalentManagerUserRole: UserRole = "talent_manager";
export const TalentOperationUserRole: UserRole = "talent_operations";
export const TalentFreelancerUserRole: UserRole = "talent_freelancer";
export const AccountingUserRole: UserRole = "accounting";
export const SuperadminUserRole: UserRole = "superadmin";
export const AppUserRole: UserRole = "app";
export type PictureSource = 'upload' | 'linkedin';
export const UploadPictureSource: PictureSource = "upload";
export const LinkedinPictureSource: PictureSource = "linkedin";

//////////
// source: user_store.go

export interface UserSettings {
    login_code: boolean;
}
export type Gender = string;
export const MaleGender: Gender = "male";
export const FemaleGender: Gender = "female";
export const OtherGender: Gender = "other";
export interface PersonalInfo {
    birthday?: string /* RFC3339 */;
    civil_status?: CivilStatus;
    address?: LegalAddress;
    linkedin_url?: string;
    github_url?: string;
    scheduling_url?: string;
    emergency_contact?: EmergencyContact;
    national_id?: string;
    nationality?: string;
    gender?: Gender;
    us_visa?: boolean;
    valid_passport?: boolean;
    shipping_info?: ShippingInfo;
}
export interface EmergencyContact {
    name: string;
    relationship: string;
    phone: string;
}
export type CivilStatus = string;
export const SingleCivilStatus: CivilStatus = "single";
export const MarriedCivilStatus: CivilStatus = "married";
export const LivingTogetherCivilStatus: CivilStatus = "living_together";
export const DivorcedCivilStatus: CivilStatus = "divorced";
export const WidowCivilStatus: CivilStatus = "widow";
export type Roles = UserRole[];
export interface HubspotInfo {
    type_of_role?: string;
    job_title?: string;
}
export const AnonymizedFirstName = "Deleted";
export const AnonymizedLastName = "User";
export const MockedHubspotID = "mocked-id";
export interface ContractorBirthday {
    id: number /* int */;
    first_name: string;
    last_name: string;
    birthday: string /* RFC3339 */;
    picture: null /* sql.NullString */;
}
export interface BasicUser {
    id: number /* int */;
    first_name: string;
    last_name: string;
    picture: string;
    email?: string;
    customer_id?: number /* int */;
}

//////////
// source: webhook.go

/**
 * Webhook represents public.webhooks
 */
export interface Webhook {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    deleted_at?: string /* RFC3339 */;
    status?: WebhookStatus;
    name: string;
    table: string;
    events: string[];
    url: string;
    resolve_foreign_keys?: boolean;
    slack_channel_id?: string;
}
export type WebhookStatus = 'pending' | 'active' | 'pause';
export const PendingWebhookStatus: WebhookStatus = "pending";
export const ActiveWebhookStatus: WebhookStatus = "active";
export const PauseWebhookStatus: WebhookStatus = "pause";

//////////
// source: workflow_execution.go

/**
 * WorkflowExecution represents public.workflow_executions
 */
export interface WorkflowExecution {
    id?: number /* int */;
    created_at?: string /* RFC3339 */;
    updated_at?: string /* RFC3339 */;
    workflow_id: string;
    workflow: string;
    queue: string;
    args: string;
    schedule?: string;
    timeout_ms?: number /* int */;
    dispatch_at?: string /* RFC3339 */;
    dispatched_at?: string /* RFC3339 */;
    attempts?: number /* int */;
    last_error?: string;
    conflict_policy?: number /* int */;
}
